import { f as Deferred, _ as __awaiter, p as HttpUtils, c as CoreUtils, b as CookieUtils, q as ConfigurationService, s as Organization, L as LocalStorageUtils, a as ArrayUtils, l as WindowService, r as User, U as URLUtils, t as CommonLocalizationUtils, I as InternalNotificationService, u as HttpUrlUtils, A as AngularZoneUtils, i as SubscribeService, d as CXOneConstants, e as DateUtils, S as ScreenUtils } from './OrganizationModel-6892ef2b.js';
export { A as AngularZoneUtils, a as ArrayUtils, d as CXOneConstants, C as ColorUtils, t as CommonLocalizationUtils, q as ConfigurationService, b as CookieUtils, c as CoreUtils, n as CountriesUtils, D as DateConstants, e as DateUtils, f as Deferred, g as DomUtils, H as HttpErrorResponse, o as HttpRetryStrategy, p as HttpUtils, L as LocalStorageUtils, O as ObjectUtils, s as Organization, S as ScreenUtils, j as ScriptLoaderService, h as StringUtils, i as SubscribeService, k as TimeZoneUtils, U as URLUtils, r as User, W as Weekdays, l as WindowService } from './OrganizationModel-6892ef2b.js';
import moment from 'moment';
import 'moment-timezone';
import { Subject, fromEvent, interval, from, catchError, map as map$1, throwError, of, ReplaySubject } from 'rxjs';
import { map, takeUntil, take, timeout, retry, catchError as catchError$1, distinctUntilChanged, filter, shareReplay } from 'rxjs/operators';
import 'rxjs/fetch';
import SockJS from 'sockjs-client';

class AcdClusterDomainService {
    constructor() {
        this.deferredLoadClusterConfigs = new Deferred();
        this.loadClusterConfigInProgress = false;
        this.reset();
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new AcdClusterDomainService();
        }
        return this._instance;
    }
    reset() {
        this.clusterConfig = undefined;
        this.loadClusterConfigInProgress = false;
        this.deferredLoadClusterConfigs = new Deferred();
    }
    resetLoadClusterMappingFlow() {
        this.deferredLoadClusterConfigs = new Deferred();
        this.loadClusterConfigInProgress = false;
    }
    getCurrentClusterDomain(cluster) {
        return __awaiter(this, void 0, void 0, function* () {
            const deferred = new Deferred();
            try {
                const mappings = yield this.loadClusterMapping();
                if (!mappings) {
                    deferred.resolve(undefined);
                }
                deferred.resolve(this.lookupMappingCaseInsensitive(mappings, cluster));
            }
            catch (error) {
                console.error('getCurrentClusterDomain call failed: ' + error);
                deferred.reject(undefined);
            }
            return deferred.promise;
        });
    }
    loadClusterMapping() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.clusterConfig) {
                return Promise.resolve(this.clusterConfig);
            }
            return yield this.reloadClusterMapping();
        });
    }
    reloadClusterMapping() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.deferredLoadClusterConfigs.isPending()) {
                this.resetLoadClusterMappingFlow();
            }
            if (this.loadClusterConfigInProgress) {
                return this.deferredLoadClusterConfigs.promise;
            }
            this.loadClusterConfigInProgress = true;
            return yield this.getClusterConfigRequest();
        });
    }
    getClusterConfigRequest() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.deferredLoadClusterConfigs.isPending()) {
                this.resetLoadClusterMappingFlow();
            }
            try {
                const response = yield HttpUtils.apiGet('/.well-known/cluster-configuration', undefined, true);
                this.clusterConfig = response;
                this.deferredLoadClusterConfigs.resolve(this.clusterConfig);
            }
            catch (error) {
                console.error('Cannot get cluster domain mapping. reason: ', error);
                this.deferredLoadClusterConfigs.reject(error);
            }
            return this.deferredLoadClusterConfigs.promise;
        });
    }
    lookupMappingCaseInsensitive(object, key) {
        return object[Object.keys(object).filter((k) => k.toLowerCase() === key.toLowerCase())[0]];
    }
}

class UserTokenService {
    static isValidJWT(jwtToken) {
        return this.JWT_REGEX.test(jwtToken);
    }
    static getClaimsFromToken(token) {
        if (!UserTokenService.isValidJWT(token)) {
            return null;
        }
        try {
            const encodedBase64Url = token.split('.')[1];
            const encodedBase64 = encodedBase64Url.replace('-', '+').replace('_', '/');
            return JSON.parse(atob(encodedBase64));
        }
        catch (e) {
            console.debug('Retrying with atobV2 as error in getClaimsFromToken due to: ' + e);
            return JSON.parse(CoreUtils.atobV2(token));
        }
    }
    static getSubClaim(token) {
        const claim = UserTokenService.getClaimsFromToken(token) || {};
        return claim[UserTokenService.CLAIM_KEYS.subClaim];
    }
    static getClusterId(token) {
        const claim = UserTokenService.getClaimsFromToken(token) || {};
        return claim[UserTokenService.CLAIM_KEYS.clusterId];
    }
    static isTokenValid() {
        const accessToken = CookieUtils.getAccessToken();
        if (accessToken) {
            try {
                const tokenBody = accessToken.split('.')[1];
                const tokenBodyDecoded = atob(tokenBody);
                const tokenBodyDecodedObj = JSON.parse(tokenBodyDecoded);
                return (moment.utc(tokenBodyDecodedObj.exp * 1000).isAfter(moment.utc(), 'second'));
            }
            catch (e) {
                console.debug('Retrying with atobV2 as error in isTokenValid due to: ' + e);
                return (moment.utc(JSON.parse(CoreUtils.atobV2(accessToken)).exp * 1000).isAfter(moment.utc(), 'second'));
            }
        }
        else {
            return false;
        }
    }
    static parseJwt(token) {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace('-', '+').replace('_', '/');
            return JSON.parse(atob(base64));
        }
        catch (e) {
            console.debug('Retrying with atobV2 as error in parseJwt due to: ' + e);
            return JSON.parse(CoreUtils.atobV2(token));
        }
    }
    static getICAgentId(token) {
        const claim = UserTokenService.getClaimsFromToken(token) || {};
        return claim[UserTokenService.CLAIM_KEYS.icAgentId];
    }
    static getICBUId(token) {
        const claim = UserTokenService.getClaimsFromToken(token) || {};
        return claim[UserTokenService.CLAIM_KEYS.icBUId];
    }
}
UserTokenService.JWT_REGEX = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;
UserTokenService.CLAIM_KEYS = {
    subClaim: 'sub',
    role: 'role',
    agentId: 'icAgentId',
    username: 'name',
    tenantId: 'tenantId',
    tenantName: 'tenant',
    clusterId: 'icClusterId',
    icAgentId: 'icAgentId',
    icBUId: 'icBUId'
};

class DfoUtils {
    static saveDfoDomainFormats(acdModule) {
        const digitalAppPage = acdModule.linksList.find(y => y.id === 'dfoSettings');
        if (digitalAppPage === undefined) {
            console.error('DfoUtils: Digital Engagement AppPage was not found');
        }
        else if (digitalAppPage.urlMapping === undefined) {
            console.error('UrlMapping for DFO is not defined or was not retrievable');
        }
        else {
            DfoUtils.dfoDomainMappings = digitalAppPage.urlMapping;
        }
    }
    static isDfoDomain(domain) {
        return domain.includes('app-de') && (domain.includes('niceincontact.com') || domain.includes('nicecxone'));
    }
    static getDfoDomainFromMapping(key) {
        return DfoUtils.dfoDomainMappings[key];
    }
    static retrieveDigitalEngagementDomain(envUrl) {
        try {
            const key = DfoUtils.extractUrlMappingKey(envUrl);
            let urlDomain = DfoUtils.getDfoDomainFromMapping(key);
            if (urlDomain === undefined || urlDomain === null || urlDomain === '') {
                urlDomain = envUrl;
                console.error('DfoUtils: Url mapping for key (' + key + ') could not be found, defaulting to the niceBaseUrl');
            }
            return urlDomain;
        }
        catch (error) {
            if (error instanceof TypeError) {
                console.warn('DfoUtils: Url mapping is empty, defaulting to the niceBaseUrl');
            }
            return envUrl;
        }
    }
    static extractUrlMappingKey(envUrl) {
        let urlMappingKey = DfoUtils.extractEnvironmentId(envUrl);
        if (urlMappingKey === '') {
            urlMappingKey = DfoUtils.getAreaId();
        }
        return urlMappingKey;
    }
    static extractEnvironmentId(envUrl) {
        const response = envUrl.split(/[:.,\/ -]/);
        const env = response.filter(value => DfoUtils.ENVIRONMENTS.includes(value));
        return (typeof env !== 'undefined' && env.length === 1) ? env[0] : '';
    }
    static getAreaId() {
        let areaId = ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.AreaIdentifier);
        if (areaId) {
            areaId = areaId.trim();
        }
        return areaId;
    }
}
DfoUtils.ENVIRONMENTS = ['dev', 'test', 'staging', 'perf'];
DfoUtils.dfoDomainMappings = {};

class OrganizationService {
    constructor() {
    }
    reset() {
        this.organizationInfo = undefined;
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new OrganizationService();
        }
        return this._instance;
    }
    sendGetOrganizationInfoRequest() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpUtils.apiGet('/tenants/current', undefined, true);
                this.initOrganization(response);
                this.organizationInfo = response;
                return response;
            }
            catch (err) {
                console.error('get organization Info from TM failed: ', err);
                throw err;
            }
        });
    }
    reloadOrganizationInfo() {
        return this.sendGetOrganizationInfoRequest();
    }
    getOrganizationInfo() {
        if (this.organizationInfo) {
            return Promise.resolve(this.organizationInfo);
        }
        return this.reloadOrganizationInfo();
    }
    updateOrganizationInfo(organizationInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestObj = {
                tenantName: organizationInfo.name,
                timezone: organizationInfo.timeZone.value
            };
            try {
                const response = yield HttpUtils.apiPut('/tenants/current', requestObj, undefined, true);
                Organization.instance.name = requestObj.tenantName;
                Organization.instance.timeZone = requestObj.timezone;
                return response;
            }
            catch (err) {
                console.error('update organization name and timezone in TM failed: ', err);
                throw err;
            }
        });
    }
    initOrganization(organizationInfo) {
        Organization.instance.name = organizationInfo.tenant.tenantName;
        Organization.instance.timeZone = organizationInfo.tenant.timezone;
        Organization.instance.organizationStatus.active = organizationInfo.tenant.status;
        Organization.instance.organizationStatus.activeStatus = organizationInfo.tenant.type;
        Organization.instance.userCap = organizationInfo.tenant.userSoftLimit;
        Organization.instance.id = organizationInfo.tenant.tenantId;
        Organization.instance.customerType = organizationInfo.tenant.customerType;
        Organization.instance.licenses = organizationInfo.tenant.licenses;
        Organization.instance.billingId = organizationInfo.tenant.billingId;
    }
    initOrganizationInfo() {
        return this.getOrganizationInfo();
    }
}

class LicenseService {
    constructor() {
        this.DEFINED_LICENSES = {
            ACD: 'acd',
            WFM: 'wfm',
            WFO: 'wfo',
            QM: 'qm',
            PM: 'pm',
            WFI: 'wfi',
            RECORDING: 'recording',
            SEARCH: 'search',
            TM: 'tm',
            AUTOMATION_STUDIO: 'automationstudio',
            ANALYTICS: 'analytics',
            XSIGHT_AI: 'xsight_ai',
            ADAPTERS: 'adapters'
        };
        this.loadLicensesInProgress = false;
        this.licensesJson = { licenses: [] };
        this.applicationsToPermissionCheck = ['admin'];
        this.deferredLoadLicenses = new Deferred();
        this.DEFINED_OPERANDS = {
            '||': (value1, value2) => value1 || value2,
            '&&': (value1, value2) => value1 && value2,
            '!': (value) => {
                value = !value;
                return value;
            }
        };
        this.reset();
    }
    reset() {
        this.licenses = undefined;
        this.licensesObject = undefined;
        this.loadLicensesInProgress = false;
        this.licensesJson = { licenses: [] };
        this.deferredLoadLicenses = new Deferred();
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new LicenseService();
        }
        return this._instance;
    }
    loadLicenses(fullObject) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.licensesObject && this.licensesObject.licenses) {
                return fullObject ? this.licensesObject : this.licenses;
            }
            return yield this.reloadLicenses(fullObject);
        });
    }
    reloadLicenses(fullObject) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loadLicensesInProgress) {
                return this.deferredLoadLicenses.promise;
            }
            this.loadLicensesInProgress = true;
            this.getLicensesRequest(fullObject);
            return this.deferredLoadLicenses.promise;
        });
    }
    licenseJsonToLicenseArray(licenseJson) {
        const licenseArr = [];
        if (licenseJson.licenses === undefined) {
            return undefined;
        }
        const licenseSet = licenseJson.licenses.map((o) => ({ applicationId: o.applicationId }));
        for (const licenseSetItem of licenseSet) {
            licenseArr.push(licenseSetItem.applicationId.toLowerCase());
        }
        return licenseArr;
    }
    getLicensesRequest(fullObject) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield OrganizationService.instance.getOrganizationInfo();
                this.licensesJson.licenses = res.tenant.licenses;
                this.licenses = this.licenseJsonToLicenseArray(this.licensesJson);
                this.licensesObject = this.licensesJson;
                this.deferredLoadLicenses.resolve(fullObject ? this.licensesObject : this.licenses);
                this.resetLoadLicensesFlow();
            }
            catch (reason) {
                console.error('Cannot get licenses. reason: ', reason);
                this.deferredLoadLicenses.reject(reason);
                this.resetLoadLicensesFlow();
            }
        });
    }
    resetLoadLicensesFlow() {
        this.deferredLoadLicenses = new Deferred();
        this.loadLicensesInProgress = false;
    }
    filterArrayByLicense(arr, allowedLicense, userPermissions, checkUserPermissions) {
        const filteredArr = [];
        arr.forEach((arrItem, index) => {
            if (arrItem.license && arr[index].license.length > 0) {
                let isLicensed = false;
                const currentList = arrItem;
                for (const allowedLicenseItem of allowedLicense) {
                    if (currentList.license.indexOf(allowedLicenseItem) > -1) {
                        isLicensed = true;
                        break;
                    }
                }
                if (!isLicensed && userPermissions !== undefined && (checkUserPermissions || this.applicationsToPermissionCheck.indexOf(currentList.id) > -1)) {
                    const currPermissions = currentList.permission.split(' ');
                    for (const permissionElement of currPermissions) {
                        if (userPermissions.indexOf(permissionElement) > -1) {
                            isLicensed = true;
                            checkUserPermissions = true;
                            break;
                        }
                    }
                }
                if (isLicensed) {
                    if (currentList.linksList && currentList.linksList.length > 0) {
                        currentList.linksList = this.filterArrayByLicense(currentList.linksList, allowedLicense, userPermissions, checkUserPermissions);
                    }
                    if (currentList.subMenu && currentList.subMenu.length > 0) {
                        currentList.subMenu = this.filterArrayByLicense(currentList.subMenu, allowedLicense, userPermissions, checkUserPermissions);
                    }
                    filteredArr.push(currentList);
                }
            }
        });
        return filteredArr;
    }
    loadAndFilterLicenses(applicationsData, deferred) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.loadLicenses();
                let filteredByLicenseApplicationsData = [];
                if (result) {
                    filteredByLicenseApplicationsData = this.filterArrayByLicense(applicationsData, result);
                }
                deferred.resolve(filteredByLicenseApplicationsData);
            }
            catch (reason) {
                console.error('get all license failed. Reason: ', reason);
                throw reason;
            }
        });
    }
    filterApplicationsDataByLicense(applicationsData) {
        return __awaiter(this, void 0, void 0, function* () {
            const deferred = new Deferred();
            try {
                const userApplications = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userApplications);
                if (userApplications) {
                    // for (let userApplicationsItem of userApplications) {
                    userApplications.forEach((item, index, theArray) => {
                        theArray[index] = item.toLowerCase();
                    });
                    const userPermissions = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.permissions);
                    const filteredByLicenseApplicationsData = this.filterArrayByLicense(applicationsData, userApplications, userPermissions);
                    deferred.resolve(filteredByLicenseApplicationsData);
                }
                else {
                    yield this.loadAndFilterLicenses(applicationsData, deferred);
                }
            }
            catch (_a) {
                yield this.loadAndFilterLicenses(applicationsData, deferred);
            }
            return deferred.promise;
        });
    }
    isAnyCommon(haystack, arr) {
        return arr.some((v) => haystack.includes(v));
    }
    getlicenseType() {
        return __awaiter(this, void 0, void 0, function* () {
            const deferred = new Deferred();
            try {
                let loadedFromLocalStorage = false;
                const userApplications = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userApplications);
                if (userApplications) {
                    loadedFromLocalStorage = true;
                    const index = userApplications.indexOf('DEFAULT');
                    if (userApplications.length > 1 && index > -1) {
                        userApplications.splice(index, 1);
                    }
                    deferred.resolve(this.findLicenseType(userApplications));
                }
                if (!loadedFromLocalStorage) {
                    this.loadLicenses().then((result) => {
                        deferred.resolve(this.findLicenseType(result));
                    });
                }
            }
            catch (_a) {
                const result = yield this.loadLicenses();
                deferred.resolve(this.findLicenseType(result));
            }
            return deferred.promise;
        });
    }
    findLicenseType(licenseArray) {
        const licenses = licenseArray;
        const licensesLowerCase = [];
        for (const licensesItem of licenses) {
            licensesLowerCase.push(licensesItem.toLowerCase());
        }
        const licensesToCheck = [this.DEFINED_LICENSES.TM, this.DEFINED_LICENSES.ACD, this.DEFINED_LICENSES.WFI];
        const allLicensesInSequenceForLicenseType = [
            this.DEFINED_LICENSES.ADAPTERS,
            this.DEFINED_LICENSES.TM,
            this.DEFINED_LICENSES.ACD,
            this.DEFINED_LICENSES.WFI,
            this.DEFINED_LICENSES.WFM,
            this.DEFINED_LICENSES.QM,
            this.DEFINED_LICENSES.PM,
            this.DEFINED_LICENSES.RECORDING,
            this.DEFINED_LICENSES.ANALYTICS,
            this.DEFINED_LICENSES.AUTOMATION_STUDIO,
            this.DEFINED_LICENSES.XSIGHT_AI
        ];
        if (!this.isAnyCommon(licensesLowerCase, licensesToCheck) && licenses.length > 1) {
            return this.DEFINED_LICENSES.WFO;
        }
        for (const allLicensesInSequenceForLicenseTypeItem of allLicensesInSequenceForLicenseType) {
            if (licensesLowerCase.includes(allLicensesInSequenceForLicenseTypeItem)) {
                return allLicensesInSequenceForLicenseTypeItem;
            }
        }
        if (licensesLowerCase.length > 0) {
            return licensesLowerCase[0];
        }
        return licensesLowerCase;
    }
    getLicensesForTenant() {
        const deferred = new Deferred();
        this.loadLicenses(true).then((result) => {
            deferred.resolve(result);
        }, (reason) => {
            deferred.reject(reason);
        });
        return deferred.promise;
    }
    getEvolveProduct() {
        const deferred = new Deferred();
        HttpUtils.apiGet('/catalog/product/EVOLVE', {}, true).then((response) => {
            deferred.resolve(response.product || {});
        }, (reason) => {
            console.error('Failed to get Evolve product. reason: ', reason);
            deferred.reject(reason);
        });
        return deferred.promise;
    }
    getTenantLicenses(applicationId) {
        const deferred = new Deferred();
        this.loadLicenses(true).then((result) => {
            let appLicenses = [];
            for (const licensesItem of result.licenses) {
                if (licensesItem.applicationId.toUpperCase() === applicationId.toUpperCase()) {
                    appLicenses = licensesItem.featureIds;
                }
            }
            deferred.resolve(appLicenses);
        }, (reason) => {
            console.error('Cannot get features. reason: ', reason);
            deferred.reject(reason);
        });
        return deferred.promise;
    }
    evalObjectExpressionToBoolean(expression, tenantLicenses) {
        const boolArr = [];
        let definedOperand;
        let boolValue;
        if (Array.isArray(expression.licenses)) {
            // this is a tree, should run over it down to a leaf
            for (const expressionLicensesItem of expression.licenses) {
                boolArr.push(this.evalObjectExpressionToBoolean(expressionLicensesItem, tenantLicenses));
            }
            definedOperand = this.DEFINED_OPERANDS[expression.operand];
            if (definedOperand) {
                boolValue = boolArr[0];
                for (let j = 1; j < boolArr.length; j += 1) {
                    boolValue = definedOperand(boolValue, boolArr[j]);
                }
                // return the license value
                return boolValue;
            }
            // default result for a non-valid operand
            return false;
        }
        if (this.isLicenseStringValid(expression.licenses)) {
            // this is a leaf, should evaluate it with his operand
            boolValue = tenantLicenses.filter((lItem) => lItem.toLowerCase() === expression.licenses.toLowerCase()).length > 0;
            if (expression.operand) {
                // return the license value after evaluation with his operand
                definedOperand = this.DEFINED_OPERANDS[expression.operand];
                if (definedOperand) {
                    return definedOperand(boolValue);
                }
                // default result for a non-valid operand
                return false;
            }
            // return the license value
            return boolValue;
        }
        // default result for a non-valid expression
        return false;
    }
    isLicenseStringValid(license) {
        // validate if license is String && license exist in DEFINED_LICENSES
        return (typeof license === 'string' && Object.values(this.DEFINED_LICENSES).filter((lItem) => lItem === license.toLowerCase()).length > 0);
    }
    validateLicenseExpressionForTenant(licenseExpression) {
        let evalResult;
        const deferred = new Deferred();
        let loadedFromLocalStorage = false;
        const userApplications = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userApplications);
        if (userApplications) {
            loadedFromLocalStorage = true;
            evalResult = this.evalObjectExpressionToBoolean(licenseExpression, userApplications);
            deferred.resolve(evalResult);
        }
        if (!loadedFromLocalStorage) {
            this.loadLicenses().then((licenses) => {
                evalResult = this.evalObjectExpressionToBoolean(licenseExpression, licenses);
                deferred.resolve(evalResult);
            });
        }
        return deferred.promise;
    }
    setLicenses(licenses) {
        this.licensesObject = licenses;
    }
}

class TenantCrossDomainParamsService {
    constructor() {
        this.deferredLoadCurrentTenant = new Deferred();
        this.loadTenantDataInProgress = false;
        this.IN_CONTACT_SUB_DOMAIN_TEMPLATE = 'home-%clusterID%';
        this.IN_CONTACT_API_DOMAIN_TEMPLATE = 'api-%clusterID%';
        this.ANALYTICS_SUB_DOMAIN_TEMPLATE = 'analytics-%area%';
        this.areaIdConfigKey = 'areaIdentifier';
        this.iframeBaseUrls = 'iframeBaseUrls';
        this.currentEnv = 'currentEnv';
        this.reset();
    }
    static getWindowObject() {
        return window;
    }
    reset() {
        this.currentTenantData = undefined;
        this.loadTenantDataInProgress = false;
        this.deferredLoadCurrentTenant = new Deferred();
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new TenantCrossDomainParamsService();
        }
        return this._instance;
    }
    sleep() {
        return __awaiter(this, void 0, void 0, function* () {
            yield new Promise((resolve) => setTimeout(resolve, 3000));
        });
    }
    getAppHost() {
        const protocol = TenantCrossDomainParamsService.getWindowObject().location.protocol;
        let host = TenantCrossDomainParamsService.getWindowObject().location.hostname;
        const port = TenantCrossDomainParamsService.getWindowObject().location.port;
        let index = host.indexOf('.');
        const portRegEx = /:[0-9]{4}$/;
        let apiConfig = ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.StaticBaseUrl);
        if (apiConfig === undefined) {
            apiConfig = ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.ApiServerBaseUrl);
        }
        if (apiConfig) {
            const urlSubDomain = this.getSubDomain(apiConfig);
            if (urlSubDomain !== null && host.indexOf(urlSubDomain) === -1) {
                host = host.replace(this.getSubDomain(host), urlSubDomain);
            }
        }
        let env = ConfigurationService.instance.get(this.areaIdConfigKey);
        if (env) {
            env = env.trim();
        }
        if (index >= 0) {
            if (host.substring(0, index) !== env) {
                host = host.substring(index + 1);
                index = host.indexOf('.');
                if (host.toLowerCase().substring(0, index) === 'my') {
                    host = host.substring(index + 1);
                    index = host.indexOf('.');
                }
                if (host.substring(0, index) !== env) {
                    index = -1;
                }
            }
            if (index >= 0) {
                host = host.replace(host.substring(0, index), env);
            }
            else {
                host = env + '.' + host;
            }
        }
        return protocol + '//' + host + (port && !portRegEx.test(host) ? ':' + port : '');
    }
    getBaseUrl(clusterId, ACDSubDomain) {
        let incontactBaseUrl;
        let analyticsBaseUrl;
        let incontactApiBaseUrl;
        let digitalEngagementBaseUrl;
        const pathArray = TenantCrossDomainParamsService.getWindowObject().location.href.split(/[:.,\/ -]/);
        const niceBaseUrl = this.getAppHost();
        if (ArrayUtils.includes(pathArray, 'localhost')) {
            incontactBaseUrl = niceBaseUrl;
            analyticsBaseUrl = niceBaseUrl;
            incontactApiBaseUrl = niceBaseUrl;
            digitalEngagementBaseUrl = niceBaseUrl;
        }
        else {
            const area = ConfigurationService.instance.get(this.areaIdConfigKey);
            const protocol = TenantCrossDomainParamsService.getWindowObject().location.protocol;
            const host = TenantCrossDomainParamsService.getWindowObject().location.hostname;
            let index = host.indexOf('.');
            if (host.toLowerCase().indexOf('.my.') >= 0) {
                index = host.toLowerCase().indexOf('.my.') + 3;
            }
            let ACDHost = host;
            if (ACDSubDomain) {
                ACDHost = ACDHost.replace(this.getSubDomain(ACDHost), ACDSubDomain);
            }
            incontactBaseUrl = protocol + '//' + ACDHost.replace(host.substring(0, index), this.IN_CONTACT_SUB_DOMAIN_TEMPLATE).replace('%clusterID%', clusterId);
            incontactApiBaseUrl = protocol + '//' + ACDHost.replace(host.substring(0, index), this.IN_CONTACT_API_DOMAIN_TEMPLATE).replace('%clusterID%', clusterId);
            analyticsBaseUrl = niceBaseUrl.replace(area, this.ANALYTICS_SUB_DOMAIN_TEMPLATE).replace('%area%', area);
            digitalEngagementBaseUrl = DfoUtils.retrieveDigitalEngagementDomain(niceBaseUrl);
        }
        return {
            niceBaseUrl,
            incontactBaseUrl,
            analyticsBaseUrl,
            incontactApiBaseUrl,
            digitalEngagementBaseUrl
        };
    }
    getAuthHostForArea() {
        const protocol = TenantCrossDomainParamsService.getWindowObject().location.protocol;
        let host = TenantCrossDomainParamsService.getWindowObject().location.hostname;
        const port = TenantCrossDomainParamsService.getWindowObject().location.port;
        let apiConfig = ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.StaticBaseUrl);
        if (apiConfig === undefined) {
            apiConfig = ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.ApiServerBaseUrl);
        }
        if (apiConfig) {
            const urlSubDomain = this.getSubDomain(apiConfig);
            if (urlSubDomain !== null && host.indexOf(urlSubDomain) === -1) {
                host = host.replace(this.getSubDomain(host), urlSubDomain);
            }
        }
        let areaIdentifier = ConfigurationService.instance.get(this.areaIdConfigKey);
        if (areaIdentifier) {
            areaIdentifier = areaIdentifier.trim();
        }
        let subHostName = areaIdentifier;
        const currentEnv = ConfigurationService.instance.get(this.currentEnv);
        const brandingHost = CookieUtils.getBrandingHost(areaIdentifier, currentEnv);
        if (brandingHost) {
            subHostName = brandingHost;
        }
        if (host.includes('.my.')) {
            host = host.replace(/(.*?)\.my\./, subHostName + '.');
        }
        else {
            host = host.replace(/(.*?)\./, subHostName + '.');
        }
        return protocol + '//' + host + (port ? ':' + port : '');
    }
    loadCurrentTenantData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.currentTenantData) {
                return Promise.resolve(this.currentTenantData);
            }
            return yield this.reloadCurrentTenantData();
        });
    }
    reloadCurrentTenantData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.deferredLoadCurrentTenant.isPending()) {
                this.resetCurrentTenantData();
            }
            if (this.loadTenantDataInProgress) {
                return this.deferredLoadCurrentTenant.promise;
            }
            this.loadTenantDataInProgress = true;
            return yield this.getCurrentTenantRequest();
        });
    }
    resetCurrentTenantData() {
        this.deferredLoadCurrentTenant = new Deferred();
        this.loadTenantDataInProgress = false;
    }
    getCurrentTenantRequest() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.deferredLoadCurrentTenant.isPending()) {
                this.resetCurrentTenantData();
            }
            try {
                const response = yield OrganizationService.instance.getOrganizationInfo();
                this.currentTenantData = response.tenant;
                this.deferredLoadCurrentTenant.resolve(response.tenant);
            }
            catch (reason) {
                console.error('Cannot get current Tenant response. reason: ', reason);
                this.deferredLoadCurrentTenant.reject(reason);
            }
            return this.deferredLoadCurrentTenant.promise;
        });
    }
    /**
     * Get tenant cluster id info from token local storage
     *
     * @returns tenant cluster id
     */
    loadTenantClusterIdFromLocal() {
        return __awaiter(this, void 0, void 0, function* () {
            const clusterIdDeferred = new Deferred();
            let token = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userToken);
            if (token) {
                const clusterId = UserTokenService.getClusterId(token);
                clusterIdDeferred.resolve(clusterId);
            }
            else {
                yield this.sleep();
                token = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userToken);
                if (token) {
                    const clusterId = UserTokenService.getClusterId(token);
                    clusterIdDeferred.resolve(clusterId);
                }
                else {
                    clusterIdDeferred.resolve(undefined);
                }
            }
            return clusterIdDeferred.promise;
        });
    }
    /**
     * Load tenant clusterId
     */
    loadTenantClusterId() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const tenantClusterId = yield this.loadTenantClusterIdFromLocal();
                if (tenantClusterId) {
                    return tenantClusterId;
                }
                else {
                    // if for some reason clusterId is null or undefined from token, fall back tenant service
                    return yield this.loadTenantClusterIdFromService();
                }
            }
            catch (reason) {
                // if some error happens with feature toggle service, get clusterId by tenant service
                console.error('Not able to get feature toggle. Error: ', reason);
                return this.loadTenantClusterIdFromService();
            }
        });
    }
    /**
     * Get tenant baseUrl
     */
    getTenantBaseUrl() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const tenantClusterId = yield this.loadTenantClusterId();
                if (!tenantClusterId) {
                    return Promise.reject(new Error('Tenant Cluster Id was not retrieved correctly.'));
                }
                else {
                    const acdSubDomain = yield this.getACDSubDomain(tenantClusterId);
                    return this.getBaseUrl(tenantClusterId.toLowerCase(), acdSubDomain);
                }
            }
            catch (reason) {
                console.error('Cannot get tenant base url. Reason: ', reason);
                return reason;
            }
        });
    }
    getInviewDashboardIntegrationBaseURL() {
        return __awaiter(this, void 0, void 0, function* () {
            const deferred = new Deferred();
            try {
                const iframeBaseUrl = JSON.parse(JSON.stringify(ConfigurationService.instance.get(this.iframeBaseUrls)));
                const clearViewBaseUrl = yield iframeBaseUrl.clearViewBaseUrl;
                deferred.resolve(clearViewBaseUrl);
            }
            catch (reason) {
                console.error('Cannot find ClearView Base Url. Reason: ', reason);
                deferred.reject(reason);
            }
            return deferred.promise;
        });
    }
    getACDSubDomain(clusterId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let domain = yield AcdClusterDomainService.instance.getCurrentClusterDomain(clusterId);
                if (domain) {
                    if (!domain.startsWith('.')) {
                        domain = '.' + domain;
                    }
                    return domain;
                }
                else {
                    return undefined;
                }
            }
            catch (reason) {
                console.error('getACDSubDomain -> call to getCurrentClusterDomain with clusterId' + clusterId + 'failed with error:', reason);
                return undefined;
            }
        });
    }
    getSubDomain(url) {
        let subDomain = null;
        let index = -1;
        if (url) {
            index = url.indexOf('.');
            /* eslint @typescript-eslint/prefer-string-starts-ends-with: "off"*/
            if (url.toLowerCase().indexOf('.my.') >= 0) {
                url = url.substring(index + 1);
                index = url.indexOf('.');
            }
            if (index !== -1) {
                subDomain = url.substring(index, url.length);
            }
        }
        return subDomain;
    }
    /**
     * Get tenant cluster id info from TM service
     *
     * @returns tenant cluster id
     */
    loadTenantClusterIdFromService() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let tenantData = yield this.loadCurrentTenantData();
                tenantData = tenantData || {};
                if (!tenantData.clusterId) {
                    console.debug('No valid cluster id.');
                }
                return tenantData.clusterId;
            }
            catch (reason) {
                console.error('Cannot get current tenant data. Reason: ', reason);
                return reason;
            }
        });
    }
    isParentDomainDifferent(url) {
        let retVal = false;
        let hostName;
        const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
        if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
            hostName = match[2];
        }
        else {
            hostName = null;
        }
        let domain = hostName;
        if (hostName != null) {
            const parts = hostName.split('.').reverse();
            if (parts != null && parts.length > 1) {
                domain = '.' + parts[1] + '.' + parts[0];
                retVal = WindowService.instance.getWindowObject().location.host.indexOf(domain) === -1;
            }
        }
        return retVal;
    }
    checkACDDomain(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const urls = yield TenantCrossDomainParamsService.instance.getTenantBaseUrl();
            if (urls && urls.incontactBaseUrl) {
                return url.includes(urls.incontactBaseUrl);
            }
            return false;
        });
    }
    checkDomainSwitch(url) {
        return WindowService.instance.getWindowObject().location.href.split('/')[2] !== url.split('/')[2];
    }
}

class AnalyticsInjector {

    constructor(userId, organizationName, role, billingId, areaIdentifier, currentEnv, apiServerBaseUrl, organizationId) {
        this.userId = userId;
        this.tenantId = organizationId;
        this.tenantName = organizationName;
        this.role = role;
        this.billingId = billingId;
        this.currentEnv = currentEnv;
        this.areaIdentifier = areaIdentifier;
        this.helpURL = 'help.nice-incontact.com';
        this.helpConfigURL = 'https://na1.nice-incontact.com/cxone-fe-config/configuration/analytics_configuration.json';
        this.helpJsURL = 'na1.nice-incontact.com/cxone-fe-config/script/fs.js';
        this.configURL = `${location.protocol}//${apiServerBaseUrl}cxone-fe-config/configuration/analytics_configuration.json`;
        this.jsURL = apiServerBaseUrl + 'cxone-fe-config/script/fs.js';
    }

    static helpSaveParamsToStorage() {
        try {

            // retrieve query string parameters
            const urlSearchParams = new URLSearchParams(AnalyticsInjector.getWindowLocationSearch());
            const params = Object.fromEntries(urlSearchParams.entries());
            if (Object.keys(params).length === 0) { return; }

            // filter out invalid parameters and invalid values
            let options = {};
            const whitelist = ['currentEnv','userId','orgId','orgName','role','billingId'];
            whitelist.forEach(paramName => {
                if (params[paramName]) {
                    options[paramName] = params[paramName].replace(/(<([^>]+)>)/gi, '');
                }
            });
            if (Object.keys(options).length === 0) { return; }

            // save valid parameters and values to session storage
            window.sessionStorage.setItem('analytics_session_info',JSON.stringify(options));

        } catch (e) {} // ignores errors from invalid JSON or any other cause
    }

    static helpInitAnalyticsFromStorage() {
        try {
            const optionsJSON = window.sessionStorage.getItem('analytics_session_info');
            if (!optionsJSON) return;
            const options = JSON.parse(optionsJSON);
            const userId = options.userId || null;
            const organizationName = options.orgName || null;
            const role = options.role || null;
            const billingId = options.billingId || null;
            const areaIdentifier = null;
            const currentEnv = options.currentEnv || null;
            const apiServerBaseUrl = null;
            const organizationId = options.orgId || null;
            const cxoneAnalyticsInjector = new AnalyticsInjector(userId, organizationName, role, billingId, areaIdentifier, currentEnv, apiServerBaseUrl, organizationId);
            cxoneAnalyticsInjector.readConfigAndLoadAnalytics();
            return cxoneAnalyticsInjector;
        } catch (e) {} // ignores errors from invalid JSON or any other cause
    }

    static getWindowLocationHostname() {
        return window.location.hostname;
    }

    static getWindowLocationSearch() {
        return window.location.search;
    }

    checkIfRequestIsFromHelp() {
        return AnalyticsInjector.getWindowLocationHostname().includes(this.helpURL);
    }

    getConfigKeyForCurrentEnvironment() {
        let env = window.location.hostname;
        if (env.includes('localhost')) {
            return 'dev';
        } else if (this.currentEnv && this.currentEnv !== '') {
            return this.currentEnv;
        } else
        if (env.includes(this.helpURL)) {
            return 'na1';
        } else {
            return this.areaIdentifier;
        }
    }

    getEnvironmentConfig(response) {
        let configFileKey = this.getConfigKeyForCurrentEnvironment();
        if (response[configFileKey]) {
            return response[configFileKey];
        } else {
            console.debug('Unable to find environment configuration for your request, Setting default DEV config');
            return response.dev;
        }
    }

    includeAllTenants (includeTenants) {
        if (includeTenants && includeTenants[0] === '*')
           return true;
        return false;
    }

    tenantMatchList(tenants) {
        const found = (element) => {
            return this.tenantId === element;
        };
        return tenants.some(found);
    }

    getAccountId(config) {
       return this.checkIfTenantEnabled(config)? config.accountId : null;
    }

    checkIfTenantEnabled(rules) {
        if (!this.tenantId || !rules.enabled) {
            return false;
        }
        const isTenantInBlackList = this.tenantMatchList(rules.excludeTenants);
        if (isTenantInBlackList) {
            return false;
        }
        const isTenantInWhiteList = this.tenantMatchList(rules.includeTenants);
        const includeAllTenants = this.includeAllTenants(rules.includeTenants);
        if (includeAllTenants || isTenantInWhiteList) {
                return true;
         }
       return false;
    }

    loadFullStoryJs(accountId, options) {
        if (!accountId) return null;

        const URL = this.checkIfRequestIsFromHelp() ? this.helpJsURL : this.jsURL;

        window._fs_debug = options.debug;
        window._fs_org = accountId;
        window._fs_host = 'fullstory.com';
        window._fs_namespace = 'FS';
        window._fs_script = URL;

        if (window.parent.location !== window.location ) {
            //running in iFrame
            window._fs_run_in_iframe = true;
        }

        (function (url, window, document, nameSpace, t, l, o, g, y) {
            if (nameSpace in window) {
                if (window.console && window.console.log) {
                    window.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
                }
                return;
            }
            g = window[nameSpace] = function (a, b, s) {
                return g.q ? g.q.push([a, b, s]) : g._api(a, b, s);
            };
            g.q = [];
            o = document.createElement(t);
            o.async = 1;
            o.crossOrigin = 'anonymous';
            o.src = `${location.protocol}//${url}`;
            y = document.getElementsByTagName(t)[0];
            y.parentNode.insertBefore(o, y);
            g.identify = function (i, v, s) {
                g(l, {uid: i}, s);
                if (v) {
                    g(l, v, s);
                }
            };
            g.setUserVars = function (v, s) {
                g(l, v, s);
            };
            g.event = function (i, v, s) {
                g('event', {n: i, p: v}, s);
            };
            g.anonymize = function() {
                g.identify(!!0);
            };
            g.shutdown = function () {
                g('rec', !1);
            };
            g.restart = function () {
                g('rec', !0);
            };
            g.log = function (a, b) {
                g('log', [a, b]);
            };
            g.consent = function (a) {
                g('consent', !arguments.length || a);
            };
            g.identifyAccount = function (i, v) {
                o = 'account';
                v = v || {};
                v.acctId = i;
                g(o, v);
            };
            g.clearUserCookie = function () {
            };
            g.setVars=function(n,p) {
                g('setVars',[n,p]);
            };
            g._w={};
            y = 'XMLHttpRequest';
            g._w[y] = window[y];
            y='fetch';
            g._w[y] = window[y];
           if (window[y]) {
               window[y]= function() {
                   return g._w[y].apply(this,arguments);
                };
           }
            g._v='1.3.0';
         })(URL, window, document, window._fs_namespace, 'script', 'user');

        window._fs.identify(this.userId, {
            tenantId: this.tenantId ? this.tenantId : 'NA',
            tenantName: this.tenantName ? this.tenantName : 'NA',
            role: this.role ? this.role : 'NA',
            billingId: this.billingId ? this.billingId : 'NA'
        });
    }

    handleErrors(response) {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response;
    }

    loadGainSight(gainSightAccountId, options) {

        document.cookie = 'apt.debug=' + options.debug + '; path=/ ; domain=' + window.location.host;

        let script = document.createElement('script');
        let inlineScript = document.createTextNode(`(function(n,t,a,e,co){var i="aptrinsic";n[i]=n[i]||function(){(n[i].q=n[i].q||[]).push(arguments)},n[i].p=e;n[i].c=co;var r=t.createElement("script");r.async=!0,r.src=a+"?a="+e;var c=t.getElementsByTagName("script")[0];c.parentNode.insertBefore(r,c)})(window,document,"https://web-sdk.aptrinsic.com/api/aptrinsic.js","${gainSightAccountId}");`);
        script.appendChild(inlineScript);
        document.head.appendChild(script);
        script = document.createElement('script');
        inlineScript = document.createTextNode(`
        aptrinsic('identify', {
            "id": "${this.userId}",
            "role": "${this.role}"
            }, {
            "id": "${this.tenantId}",
            "name": "${this.tenantName}",
            "billingId": "${this.billingId}"
          });
        `);

        script.appendChild(inlineScript);
        document.head.appendChild(script);
    }

    readConfigAndLoadAnalytics() {
        return new Promise((res) => {
            const url = this.checkIfRequestIsFromHelp() ? this.helpConfigURL : this.configURL;
            fetch(url, {cache: 'no-cache'})
                .then(this.handleErrors)
                .then(function (response) {
                    return response.json();
                })
                .then((config) => {
                    console.debug('Analytics : Config file loaded successfully', config);
                    const appConfig = this.getEnvironmentConfig(config);
                    const fullStoryAccountId = this.getAccountId(appConfig.fullStory);
                    const debugFlag = config.hasOwnProperty('debug') ? (config.debug ? true : false) : false;

                    this.loadFullStoryJs(fullStoryAccountId, {
                        debug: debugFlag
                    });

                    const gainSightAccountId = this.getAccountId(appConfig.gainSight);

                    if (gainSightAccountId) {
                        this.loadGainSight(gainSightAccountId, {
                            debug: debugFlag
                        });
                    }

                    res();
                }).catch(error => {
                console.error('Analytics : Failed to load config file :' + error);
                res();
            });
        });
    }

}

class AnalyticsService {
    constructor() {
        this.getBaseUrl = () => {
            const fullURL = TenantCrossDomainParamsService.instance.getAppHost();
            let url = this.removeProtocolFromURL(fullURL);
            url = this.formatHostURL(url);
            console.log('full story URL:', url);
            return url;
        };
        this.removeProtocolFromURL = (url) => {
            const urlSplitted = url.split('://');
            if (urlSplitted.length > 1) {
                return urlSplitted[1];
            }
            return url;
        };
        this.formatHostURL = (url) => {
            const lastChrOfHostURL = url.charAt(url.length - 1);
            if (lastChrOfHostURL !== '/') {
                url += '/';
            }
            return url;
        };
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new AnalyticsService();
        }
        return this._instance;
    }
    inject(userId, organizationName, role, billingId, areaIdentifier, currentEnv, organizationId, apiBaseUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const analyticsInjector = new AnalyticsInjector(userId || User.instance.id, organizationName || User.instance.organizationName, role || User.instance.role, billingId || Organization.instance.billingId, areaIdentifier || ConfigurationService.instance.get('areaIdentifier'), currentEnv || ConfigurationService.instance.get('currentEnv'), apiBaseUrl || this.getBaseUrl(), organizationId || Organization.instance.id);
            yield analyticsInjector.readConfigAndLoadAnalytics();
        });
    }
}

class BrandingService {
    constructor() {
    }
    reset() {
        this.brandingProfileInfo = undefined;
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new BrandingService();
        }
        return this._instance;
    }
    setBrandingProfileLocalStorage(result) {
        const brandingJSON = { token: User.instance.token, brandingData: result };
        return LocalStorageUtils.setItem(LocalStorageUtils.KEYS.brandingProfile, brandingJSON);
    }
    getBrandingProfileLocalStorage() {
        return LocalStorageUtils.getItem(LocalStorageUtils.KEYS.brandingProfile);
    }
    getBrandingProfile() {
        return __awaiter(this, void 0, void 0, function* () {
            const brandingProfileStorage = this.getBrandingProfileLocalStorage();
            if (brandingProfileStorage && brandingProfileStorage.token === User.instance.token) {
                return brandingProfileStorage.brandingData;
            }
            try {
                const response = yield HttpUtils.apiGet('/branding-profiles/current', undefined, true);
                if (response && response.brandingProfile && response.brandingProfile.profileName !== null) {
                    this.setBrandingProfileLocalStorage(response);
                    console.debug('Get Branding Profile done successfully');
                    return response;
                }
                else {
                    console.debug('Get Branding Profile returns empty logos');
                    return;
                }
            }
            catch (err) {
                console.error('Get Branding profile failed. Reason: ', err);
                throw err;
            }
        });
    }
    getBrandingProperties(hostName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield HttpUtils.apiGet('/branding-details/:hostName/branding-properties.json', { params: hostName }, false);
            }
            catch (error) {
                console.error('failed to get branding properties');
                throw error;
            }
        });
    }
    getBrandingHostURL() {
        const hostName = URLUtils.getDomain();
        let brandingHostUrl;
        const currentEnv = ConfigurationService.instance.get('currentEnv');
        const areaIdentifier = ConfigurationService.instance.get('areaIdentifier');
        const brandingHost = CookieUtils.getBrandingHost(areaIdentifier, currentEnv);
        if (brandingHost && brandingHost !== hostName) {
            brandingHostUrl = WindowService.instance.getWindowObject().location.href.replace(hostName, brandingHost);
        }
        return brandingHostUrl;
    }
}

class DateTimeFormattingService {
    constructor() {
    }
    reset() {
        this.allDateTimeFormats = undefined;
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new DateTimeFormattingService();
        }
        return this._instance;
    }
    getAllDateTimeFormats() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.allDateTimeFormats) {
                return this.allDateTimeFormats;
            }
            return yield this.loadAllDateTimeFormatsFromServer();
        });
    }
    loadAllDateTimeFormatsFromServer() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield HttpUtils.staticGet('/date_time_formats/dateTimeFormats/dateTimeFormats.json', undefined, false);
                this.allDateTimeFormats = res;
                return res;
            }
            catch (err) {
                console.error('Cannot get date time formats from S3. reason: ', err);
                throw err;
            }
        });
    }
    getDateTimeFormatByLocale(locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const allLocales = yield this.getAllDateTimeFormats();
            let dateTimeFormat = allLocales[locale];
            if (!dateTimeFormat) {
                const mainLang = locale.split('-');
                dateTimeFormat = allLocales[mainLang[0]] ? allLocales[mainLang[0]] : allLocales['en-US'];
            }
            return dateTimeFormat;
        });
    }
    getCurrentLocaleFromBrowser() {
        return CommonLocalizationUtils.getCurrentLocaleFromBrowser();
    }
    getDateTimeFormatByBrowserLocale() {
        return __awaiter(this, void 0, void 0, function* () {
            const currentLocale = this.getCurrentLocaleFromBrowser();
            return yield this.getDateTimeFormatByLocale(currentLocale);
        });
    }
    setDateTimeFormats(allDateTimeFormats) {
        this.allDateTimeFormats = allDateTimeFormats;
    }
}

class EmployeeGroupsService {
    constructor() {
        this.setApiBaseUrl(ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.ApiServerBaseUrl));
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new EmployeeGroupsService();
        }
        return this._instance;
    }
    setApiBaseUrl(url) {
        this.apiServerBaseUrl = url;
    }
    reset() {
        this.groups = undefined;
    }
    getAllEmployeeGroups() {
        return new Promise((resolve, reject) => {
            if (!this.groups) {
                HttpUtils.apiGet('/user/groups', undefined, true).then(response => {
                    if (!response.groups) {
                        response.groups = [];
                    }
                    this.groups = response.groups;
                    resolve(response);
                }, err => {
                    console.error('Get employee groups failed ', err);
                    reject(err);
                });
            }
            else {
                resolve(this.groups);
            }
        });
    }
    fetchSUDetails(suId) {
        const params = {};
        params.suId = suId;
        return new Promise((resolve, reject) => {
            HttpUtils.apiGet('/user/groups/employeeGroup/:suId', params, true)
                .then((response) => {
                resolve(response);
            }, (reason) => {
                console.error('cannot get SU details. reason: ', reason);
                reject(reason);
            });
        });
    }
    addOrUpdateGroup(group) {
        if (group.isDefault && group.name.endsWith(EmployeeGroupsService.DEFAULT_SUFFIX)) {
            group.name = group.name.replace(EmployeeGroupsService.DEFAULT_SUFFIX, '');
        }
        delete group.isDefault;
        return new Promise((resolve, reject) => {
            HttpUtils.apiPut('/user/groups', group, undefined, true)
                .then((response) => {
                console.debug('Add employee group done successfully ');
                resolve(response);
            }, err => {
                console.error('Add employee group failed ', err);
                reject(err);
            });
        });
    }
    deleteGroup(group) {
        return new Promise((resolve, reject) => {
            HttpUtils.apiDelete(`/user/groups?groupId=${group}`, undefined, undefined, true)
                .then((response) => {
                console.debug('Delete employee group done successfully ');
                resolve(response);
            }, err => {
                console.error('Delete employee group failed ', err);
                reject(err);
            });
        });
    }
    validateGroupName(groupId, groupName) {
        const groupObj = {};
        groupObj.groupId = groupId ? groupId : 0;
        groupObj.groupName = groupName;
        return new Promise((resolve, reject) => {
            HttpUtils.apiGet(this.apiServerBaseUrl + '/user/groups/validateGroupName', groupObj, true)
                .then((response) => {
                console.debug('Group employee exists');
                resolve(response);
            }, err => {
                console.error('Failed to check group employee exists ', err);
                reject(err);
            });
        });
    }
}
EmployeeGroupsService.DEFAULT_SUFFIX = ' (Default)';

class GroupsService {
    constructor() {
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new GroupsService();
        }
        return this._instance;
    }
    reset() {
        this.groups = undefined;
    }
    getGroups() {
        return new Promise((resolve, reject) => {
            if (!this.groups) {
                HttpUtils.apiGet('/group', undefined, true).then(response => {
                    if (!response.groups) {
                        response.groups = [];
                    }
                    this.groups = response.groups;
                    resolve(response);
                }, err => {
                    console.error('Get groups failed ', err);
                    reject(err);
                });
            }
            else {
                resolve(this.groups);
            }
        });
    }
    addGroup(group, users) {
        const groupObj = {
            name: group.name,
            usersIds: []
        };
        if (typeof users !== 'undefined') {
            groupObj.usersIds = users.map(user => user.id);
        }
        return new Promise((resolve, reject) => {
            HttpUtils.apiPost('/group', groupObj, undefined, true)
                .then((response) => {
                console.debug('Add group done successfully ');
                resolve(response);
            }, err => {
                console.error('Add group failed ', err);
                reject(err);
            });
        });
    }
    updateGroup(group, users) {
        const groupObj = {
            name: group.name,
            usersIds: []
        };
        if (typeof users !== 'undefined') {
            groupObj.usersIds = users.map(user => user.id);
        }
        return new Promise((resolve, reject) => {
            HttpUtils.apiPut('/group', groupObj, undefined, true)
                .then((response) => {
                console.debug('Update group done successfully ');
                resolve(response);
            }, err => {
                console.error('Update groups failed ', err);
                reject(err);
            });
        });
    }
    deleteGroup(groupToDelete) {
        const groupObj = {
            groupToDeleteIds: []
        };
        groupObj.groupToDeleteIds = groupToDelete.map(group => group.id);
        return new Promise((resolve, reject) => {
            HttpUtils.apiPost('/group/delete', groupObj, undefined, true)
                .then((response) => {
                console.debug('Delete group done successfully ');
                resolve(response);
            }, err => {
                console.error('Delete groups failed ', err);
                reject(err);
            });
        });
    }
    checkGroupExistenceByName(groupName) {
        const groupObj = {};
        groupObj.name = groupName;
        return new Promise((resolve, reject) => {
            HttpUtils.apiPost('/group/exists', groupObj, undefined, true)
                .then((response) => {
                console.debug('Group exists');
                resolve(response);
            }, err => {
                console.error('Failed to check group exists ', err);
                reject(err);
            });
        });
    }
    searchGroupsV1(searchPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpUtils.apiPost('/user-management/v1/groups/search', searchPayload, undefined, true);
                console.debug('search users successfully completed');
                return response;
            }
            catch (error) {
                console.error('search users failed. Reason: ', error);
                throw error;
            }
        });
    }
}

class HierarchyDataService {
    constructor() {
        this.getAllNodesInProgress = false;
        this.cacheExpirationTimestamp = 0;
        this.MINUTES_TO_CACHE_DATA = 5;
        this.NODES_MAX_PARALLEL_CALLS = 10;
        this.NODES_MAX_PAGE_SIZE = 500;
        this.TEAMS_MAX_PARALLEL_CALLS = 10;
        this.TEAMS_MAX_PAGE_SIZE = 100;
        this.reset();
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new HierarchyDataService();
        }
        return this._instance;
    }
    reset() {
        this.primaryHierarchy = undefined;
        this.dataTree = undefined;
        this.getAllNodesInProgress = false;
        this.deferredGetAllNodes = new Deferred();
        this.cacheExpirationTimestamp = 0;
    }
    /**
     * This method makes a series of rest call to retrieve all
     * the nodes in the primary hierarchy, formatted for use in
     * an AG Grid tree. It returns a resolved promise with an
     * array of all the node objects.
     */
    getAllNodes() {
        return __awaiter(this, void 0, void 0, function* () {
            // if the service is in the process of getting all nodes, return the deferred promise
            if (this.getAllNodesInProgress) {
                return this.deferredGetAllNodes.promise;
            }
            // if the tree data has been loaded previously and the current time is less than the time that data expires, return the previous data
            if (this.dataTree !== undefined && (new Date().getTime() < this.cacheExpirationTimestamp)) {
                return Promise.resolve(this.dataTree);
            }
            this.getAllNodesInProgress = true;
            // Step 1: get the primary hierarchy
            this.primaryHierarchy = undefined;
            yield this.loadPrimaryHierarchy().catch(() => {
                // if getting the primary hierarchy fails, return early with a rejected promise
                this.getAllNodesInProgress = false;
                return Promise.reject();
            });
            // Step 2: fetch the node data, page by page, from the server
            const allNodes = yield this.fetchAllNodes().catch(() => {
                // if fetching the nodes fails, return early with a rejected promise
                this.getAllNodesInProgress = false;
                return Promise.reject();
            });
            // Step 3: update an existing array of data with team names
            yield this.addTeamNamesToNodes(allNodes).catch(() => {
                // if updating the team names fails, return early with a rejected promise
                this.getAllNodesInProgress = false;
                return Promise.reject();
            });
            // Step 4: create an array of HierarchyNode objects with orgHierarchy and other properties
            this.dataTree = this.formatHierarchyNodes(allNodes);
            this.deferredGetAllNodes.resolve(this.dataTree);
            if (this.dataTree && this.dataTree.length) {
                this.cacheExpirationTimestamp = new Date().getTime() + this.MINUTES_TO_CACHE_DATA * 60 * 1000;
            }
            this.getAllNodesInProgress = false;
            return this.deferredGetAllNodes.promise;
        });
    }
    /**
     * This method makes a series of rest call to retrieve all
     * the nodes in the primary hierarchy, formatted for use in an AG Grid tree.
     * It returns a resolved promise with an array of all the node objects and a HierarchyID.
     */
    getAllNodesWithMetadata() {
        return __awaiter(this, void 0, void 0, function* () {
            const allNodes = yield this.getAllNodes().catch(() => {
                // if fetching the nodes fails, return early with a rejected promise
                return Promise.reject();
            });
            const hierarchyId = this.primaryHierarchy ? this.primaryHierarchy.id : '';
            return Promise.resolve({ hierarchyId: hierarchyId, nodes: allNodes });
        });
    }
    fetchAllNodes() {
        return __awaiter(this, void 0, void 0, function* () {
            // fetch the node data, page by page, from the server
            const pageSizeNodes = this.NODES_MAX_PAGE_SIZE;
            const maxParallelCallsNodes = this.NODES_MAX_PARALLEL_CALLS;
            let allNodes = [];
            let skip = 0;
            // get descendantsCount of rootNode
            const firstNodeArray = yield this.fetchNodes(0, 1).catch(() => {
                // if this call errors, return early with a rejected promise
                this.getAllNodesInProgress = false;
                return Promise.reject();
            });
            let totalNodesCount = 0;
            if (firstNodeArray && firstNodeArray.length && firstNodeArray[0] && firstNodeArray[0].descendantsCount !== undefined) {
                totalNodesCount = firstNodeArray[0].descendantsCount + 1;
            }
            // calculating no of rest calls need to be made
            const totalCallsNodes = Math.ceil(totalNodesCount / pageSizeNodes);
            const iterationsNodes = Math.ceil(totalCallsNodes / maxParallelCallsNodes);
            let parallelCallsNodes = 0;
            if (iterationsNodes > 0) {
                parallelCallsNodes = Math.ceil(totalCallsNodes / iterationsNodes);
            }
            for (let i = 0; i < iterationsNodes; i++) {
                const calls = [];
                for (let j = 0; j < parallelCallsNodes; j++) {
                    if (skip < totalNodesCount) {
                        calls.push(this.fetchNodes(skip, pageSizeNodes));
                    }
                    skip = skip + pageSizeNodes;
                }
                const response = yield Promise.all(calls).catch(() => {
                    // if any of the calls error, return early with a rejected promise
                    this.getAllNodesInProgress = false;
                    return Promise.reject();
                });
                for (let x = 0; x < response.length; x++) {
                    if (response[x]) {
                        allNodes = [...allNodes, ...response[x]];
                    }
                }
            }
            return Promise.resolve(allNodes);
        });
    }
    /**
     * This method receives an array of nodes, extracts from
     * it a list of team IDs, makes a series of rest calls to
     * retrieve the team names, and then adds the team names
     * to the original array of nodes.
     */
    addTeamNamesToNodes(allNodes) {
        return __awaiter(this, void 0, void 0, function* () {
            // group team IDs into batches to prepare for making rest calls to get team names
            const allTeamIds = allNodes.filter((node) => node.associatedEntityId && node.type === 'TEAM').map((x) => x.associatedEntityId || '');
            const maxParallelCallsTeams = this.TEAMS_MAX_PARALLEL_CALLS;
            const pageSizeTeams = this.TEAMS_MAX_PAGE_SIZE;
            const totalCallsTeams = Math.ceil(allTeamIds.length / pageSizeTeams);
            const iterationsTeams = Math.ceil(totalCallsTeams / maxParallelCallsTeams);
            let parallelCallsTeams = 0;
            if (iterationsTeams > 0) {
                parallelCallsTeams = Math.ceil(totalCallsTeams / iterationsTeams);
            }
            const batchedTeamIds = [];
            for (let iTeam = 0; iTeam < totalCallsTeams; iTeam++) {
                batchedTeamIds[iTeam] = allTeamIds.slice(pageSizeTeams * iTeam, (pageSizeTeams * iTeam) + pageSizeTeams);
            }
            // make rest calls to get team names
            let requestCount = 0;
            let teamsArray = [];
            for (let i = 0; i < iterationsTeams; i++) {
                const calls = [];
                for (let j = 0; j < parallelCallsTeams; j++) {
                    if (batchedTeamIds[requestCount] && batchedTeamIds[requestCount].length > 0) {
                        calls.push(this.fetchTeams(batchedTeamIds[requestCount]));
                    }
                    requestCount = requestCount + 1;
                }
                const response = yield Promise.all(calls).catch(() => {
                    // if any of the calls error, return early with a rejected promise
                    this.getAllNodesInProgress = false;
                    return Promise.reject();
                });
                for (let x = 0; x < response.length; x++) {
                    if (response[x] && response[x].teams) {
                        teamsArray = [...teamsArray, ...response[x].teams];
                    }
                }
            }
            // update an existing array of data with team names
            teamsArray.forEach((team) => {
                const teamNode = allNodes.find((node) => (node.associatedEntityId === team.id));
                if (teamNode) {
                    teamNode.name = team.name;
                }
            });
            return Promise.resolve(true);
        });
    }
    /**
     * This method receives a node in the format it came from the
     * server and returns it as a HierarchyNode object. It needs
     * the full list of all the nodes in order to populate the
     * orgHierarchy and ancestorNames properties.
     */
    formatHierarchyNodes(allNodes) {
        return allNodes.map((node) => {
            node.orgHierarchy = [node.id];
            if (node.parentId) {
                const parent = allNodes.find((item) => item.id === node.parentId);
                if (parent && parent.orgHierarchy) {
                    node.orgHierarchy = [...parent.orgHierarchy, node.id];
                }
            }
            const ancestorIds = node.orgHierarchy ? node.orgHierarchy.slice(0, -1) : [];
            const nodeDetails = {
                id: node.id,
                name: node.name ? node.name : '',
                nameLower: node.name ? node.name.toLowerCase() : '',
                type: node.type,
                orgHierarchy: node.orgHierarchy,
                ancestorNames: ancestorIds.map((x) => { var _a; return ((_a = allNodes.find((item) => item.id === x)) === null || _a === void 0 ? void 0 : _a.name) || ''; }),
                descendantsCount: node.descendantsCount || 0
            };
            if (node.type === 'TEAM') {
                nodeDetails.teamId = node.associatedEntityId;
            }
            return nodeDetails;
        });
    }
    /**
     * This method makes a rest call to retrieve a
     * page of nodes and returns a promise that will
     * resolve with the returned array of node objects.
     */
    fetchNodes(skip = 0, pageSize = 500) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.primaryHierarchy === undefined) {
                return Promise.resolve([]);
            }
            const requestUrl = '/hierarchy-management/v2/hierarchies/' + this.primaryHierarchy.id + '/subTree/' + this.primaryHierarchy.id + '?skip=' + skip + '&top=' + pageSize;
            return new Promise((resolve, reject) => {
                const nodeId = this.primaryHierarchy ? this.primaryHierarchy.id : '';
                HttpUtils.apiGet(requestUrl, undefined, true).then((response) => {
                    return resolve(response.nodes);
                }, (error) => {
                    console.error('Error retrieving nodes of hierarchy ' + nodeId, error);
                    return reject();
                });
            });
        });
    }
    /**
     * If the primary hierarchy has not already been set for
     * this service, this method will make a rest call to fetch
     * it and set it.
     */
    loadPrimaryHierarchy() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.primaryHierarchy) {
                const primaryHierarchy = yield this.fetchPrimaryHierarchy().catch(() => {
                    return Promise.reject(false);
                });
                if (primaryHierarchy === undefined) {
                    return Promise.resolve(false);
                }
                this.primaryHierarchy = primaryHierarchy;
            }
            return Promise.resolve(true);
        });
    }
    /**
     * This method makes a rest call to retrieve the
     * primary hierarchy and returns a promise that will
     * resolve with the returned hierarchy object.
     */
    fetchPrimaryHierarchy() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                HttpUtils.apiPost('/hierarchy-management/v3/hierarchies/search', {
                    scope: { isPrimary: true },
                    entityType: 'HIERARCHY',
                    fields: [
                        'hierarchyId',
                        'hierarchyName',
                        'isPrimary'
                    ],
                    filter: {}
                }, undefined, true).then((response) => {
                    if (response && response.hierarchies && response.hierarchies[0]) {
                        return resolve(response.hierarchies[0]);
                    }
                    else {
                        console.error('There is no primary hierarchy specified');
                        return resolve(undefined);
                    }
                }, (error) => {
                    console.error('Error retrieving primary hierarchy', error);
                    return reject();
                });
            });
        });
    }
    /**
     * This method receives an array of team IDs and makes a rest call
     * to retrieve the names of those teams. It returns a promise that
     * will resolve with the returned object containing those names.
     */
    fetchTeams(teamIds = []) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                HttpUtils.apiPost('/user-management/v3/teams/search', {
                    filter: { id: teamIds },
                    fields: [],
                    skip: 0,
                    top: 100
                }, undefined, true).then((response) => {
                    return resolve(response);
                }, (error) => {
                    console.error('Error retrieving teams', error);
                    return reject();
                });
            });
        });
    }
}

class UserDetailsService {
    constructor() {
        this.loadUserInfoInProgress = false;
        this.reset();
    }
    reset() {
        this.deferredLoadUserInfo = new Deferred();
        this.userInfo = undefined;
        this.userBasicInfo = undefined;
        this.loadUserInfoInProgress = false;
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new UserDetailsService();
        }
        return this._instance;
    }
    sendGetUserInfoRequest(userId, resolvePromiseEvenIfFailed) {
        return __awaiter(this, void 0, void 0, function* () {
            // Has the deferred been resolved from a previous execution.
            // If so lets reset it.
            if (!this.deferredLoadUserInfo.isPending()) {
                this.deferredLoadUserInfo = new Deferred();
                this.loadUserInfoInProgress = false;
            }
            try {
                const response = yield HttpUtils.apiGet('/user-management/v1/users/:userId', { params: { userId } }, true);
                console.debug('get user Info from user-manager done successfully');
                // only persist data for current user
                const isCurrentUser = yield this.isCurrentUser(userId);
                if (isCurrentUser) {
                    this.setUserInfo(response.user);
                }
                this.deferredLoadUserInfo.resolve(response.user);
            }
            catch (reason) {
                console.error('get user Info from user-manager failed. Reason: ', reason);
                if (resolvePromiseEvenIfFailed) {
                    const user = yield this.getUserBasicDetailsFromToken();
                    this.initUser(user);
                    this.deferredLoadUserInfo.resolve(user);
                }
                else {
                    this.deferredLoadUserInfo.reject(reason);
                }
            }
            return this.deferredLoadUserInfo.promise;
        });
    }
    reloadUserInfo(userId, resolvePromiseEvenIfFailed) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loadUserInfoInProgress) {
                return this.deferredLoadUserInfo.promise;
            }
            this.loadUserInfoInProgress = true;
            return yield this.sendGetUserInfoRequest(userId, resolvePromiseEvenIfFailed);
        });
    }
    // function to fetch all user details
    // resolvePromiseEvenIfFailed flag will not reject the promise even when api fails to retrieve data from UM
    // the above mentioned flag is for special cases which just require the getUserDetails to initialize User Object
    // You can see the example for the use case of resolvePromiseEvenIfFailed flag in nice-navigation-ui niceHeader component
    getUserDetails(resolvePromiseEvenIfFailed) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.userInfo) {
                return Promise.resolve(this.userInfo);
            }
            else {
                const user = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userDetails);
                if (user && user.emailAddress) {
                    this.userInfo = user;
                    return Promise.resolve(this.userInfo);
                }
                else {
                    const userId = yield this.getUserId();
                    return yield this.reloadUserInfo(userId, resolvePromiseEvenIfFailed);
                }
            }
        });
    }
    // function to fetch basic user details
    getUserBasicDetails() {
        return __awaiter(this, void 0, void 0, function* () {
            const deferred = new Deferred();
            if (this.userBasicInfo) {
                console.debug('getUserBasicDetails from userBasicInfo', this.userBasicInfo);
                deferred.resolve(this.userBasicInfo);
            }
            else {
                const userBasicInfo = yield this.getUserBasicDetailsFromToken();
                console.debug('getUserBasicDetails from getUserBasicDetailsFromToken', userBasicInfo);
                deferred.resolve(userBasicInfo);
            }
            return deferred.promise;
        });
    }
    // function to fetch user full details by ID (which may be different then current user's ID)
    getUserDetailsById(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const deferred = new Deferred();
            if (this.userInfo) {
                yield this.isCurrentUser(userId);
                deferred.resolve(this.userInfo);
            }
            else {
                deferred.resolve(yield this.reloadUserInfo(userId, false));
            }
            return deferred.promise;
        });
    }
    isCurrentUser(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const deferred = new Deferred();
            const currentUserId = yield this.getUserId();
            const isCurrentUser = (currentUserId === userId) ? true : false;
            deferred.resolve(isCurrentUser);
            return deferred.promise;
        });
    }
    getUserId() {
        return __awaiter(this, void 0, void 0, function* () {
            const deferred = new Deferred();
            let userId;
            let user = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userDetails);
            if (user && user.id) {
                userId = user.id;
                deferred.resolve(userId);
            }
            else {
                user = yield this.getUserBasicDetailsFromToken();
                userId = user ? user.id : '';
                deferred.resolve(userId);
            }
            return deferred.promise;
        });
    }
    getUserBasicDetailsFromToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const deferred = new Deferred();
            const token = yield this.getToken();
            const user = {};
            if (token) {
                let userId = '';
                const subClaim = UserTokenService.getSubClaim(token);
                if (subClaim) {
                    userId = subClaim.split(':')[1] || '';
                }
                const claims = UserTokenService.getClaimsFromToken(token);
                // create user basic info object
                if (claims) {
                    user.id = userId;
                    user.userName = claims.name;
                    user.firstName = claims.given_name;
                    user.lastName = claims.family_name;
                    user.role = claims.role.legacyId;
                    user.roleUUID = claims.role.id;
                    user.organizationName = claims.tenant;
                }
                // set global variable
                this.userBasicInfo = user;
                // set user local storage with basic details from token
                LocalStorageUtils.setItem(LocalStorageUtils.KEYS.userDetails, user);
            }
            else {
                console.debug('getUserBasicDetailsFromToken NO TOKEN');
            }
            deferred.resolve(user);
            return deferred.promise;
        });
    }
    getToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const deferred = new Deferred();
            let token = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userToken);
            if (token) {
                deferred.resolve(token);
            }
            else {
                yield this.sleep();
                token = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userToken);
                deferred.resolve(token);
            }
            return deferred.promise;
        });
    }
    initUser(user) {
        const currentToken = User.instance.token;
        User.instance.user = {
            emailAddress: user.emailAddress,
            assignedGroup: user.assignedGroup,
            userName: user.userName,
            id: user.id,
            firstName: user.firstName,
            lastName: user.lastName,
            status: user.status,
            invitationExpired: user.invitationExpired,
            organizationName: user.organizationName,
            impersonated: user.impersonated,
            hireDate: user.hireDate || new Date('2015-03-01'),
            loggedIn: true,
            token: currentToken,
            role: user.role
        };
    }
    sleep() {
        return __awaiter(this, void 0, void 0, function* () {
            yield new Promise((resolve) => setTimeout(resolve, 3000));
        });
    }
    setUserInfo(userInfo) {
        this.userInfo = userInfo;
        LocalStorageUtils.setItem(LocalStorageUtils.KEYS.userDetails, this.userInfo);
        this.initUser(this.userInfo);
    }
}

class NotificationService {
    constructor() {
        this.internalNotificationService = InternalNotificationService.getInstance(SockJS);
    }
    sendToSubscribes(key, value) {
        this.internalNotificationService.sendToSubscribes(key, value);
    }
    subscribeToSubject(key) {
        return this.internalNotificationService.subscribeToSubject(key);
    }
    getWindowObject() {
        return this.internalNotificationService.getWindowObject();
    }
    static get instance() {
        if (!NotificationService._instance) {
            NotificationService._instance = new NotificationService();
        }
        return NotificationService._instance;
    }
    reset() {
        this.internalNotificationService.reset();
    }
    setApiBaseUrl(url) {
        this.internalNotificationService.setApiBaseUrl(url);
    }
    createNewSockJS(apiServerBaseUrl, options) {
        return this.internalNotificationService.createNewSockJS(apiServerBaseUrl, options);
    }
    getSockJSObject(apiServerBaseUrl, options) {
        return this.internalNotificationService.getSockJSObject(apiServerBaseUrl, options);
    }
    authenticateConnection(options) {
        this.internalNotificationService.authenticateConnection(options);
    }
    resetTryToConnectInterval(command) {
        this.internalNotificationService.resetTryToConnectInterval(command);
    }
    routeAllNotificationMessagesToCallback(callbackFunc) {
        this.internalNotificationService.routeAllNotificationMessagesToCallback(callbackFunc);
    }
    registerToWSEvents(options) {
        this.internalNotificationService.registerToWSEvents(options);
    }
    createWebSocketHandshake(options) {
        this.internalNotificationService.createWebSocketHandshake(options);
    }
    sendAcknowledge(notificationAcknowledge) {
        this.internalNotificationService.sendAcknowledge(notificationAcknowledge);
    }
    disconnectWebSocket() {
        this.internalNotificationService.disconnectWebSocket();
    }
    getTimeIntervalForWSConnection() {
        return this.internalNotificationService.getTimeIntervalForWSConnection();
    }
}

class PreferencesService {
    static getWindowObject() {
        return window;
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new PreferencesService();
        }
        return this._instance;
    }
    addPreference(preferences, element, preference, preferenceName) {
        if (preferences[element]) {
            preferences[element][preferenceName] = preference[preferenceName];
        }
        else {
            preferences[element] = preference;
        }
        return preferences;
    }
    getPreferences(context) {
        let localPreferences;
        if (context === 'general') {
            if (CookieUtils.getCookieAsObject('preference_' + User.instance.id + '_' + context)) {
                localPreferences = CookieUtils.getCookieAsObject('preference_' + User.instance.id + '_' + context);
            }
            else {
                const cxonePreference = CookieUtils.getCookieAsObject('CXone.UserPreference');
                if (cxonePreference && cxonePreference.userId === User.instance.id) {
                    localPreferences = cxonePreference.value;
                }
            }
        }
        else {
            const storedValue = LocalStorageUtils.getItem('preference_' + User.instance.id + '_' + context);
            localPreferences = storedValue;
        }
        if (localPreferences) {
            return localPreferences;
        }
        return {};
    }
    setPreferences(context, value) {
        if (context === 'general') {
            // only general preferences related to last visited page are stored in cookies
            const windowObject = PreferencesService.getWindowObject();
            const host = windowObject.location.hostname;
            let domain;
            if (host.indexOf('localhost') > -1) {
                domain = '.dev.localhost';
            }
            else {
                domain = host.substring(host.indexOf('.'));
            }
            CookieUtils.removeCookie('preference_' + User.instance.id + '_' + context, {
                domain,
                path: '/',
                secure: windowObject.location.protocol === 'https:',
                samesite: windowObject.location.protocol === 'https:' ? 'None' : 'Lax'
            });
            if (User.instance.id) {
                CookieUtils.removeCookie('CXone.UserPreference', {
                    domain,
                    path: '/',
                    secure: windowObject.location.protocol === 'https:',
                    samesite: windowObject.location.protocol === 'https:' ? 'None' : 'Lax'
                });
                CookieUtils.setCookie('CXone.UserPreference', { userId: User.instance.id, context: context, value: value }, {
                    domain,
                    expires: moment.utc().add(15, 'days').toDate(),
                    path: '/',
                    secure: windowObject.location.protocol === 'https:',
                    samesite: windowObject.location.protocol === 'https:' ? 'None' : 'Lax'
                });
            }
        }
        else {
            // all other preferences are stored in local storage
            const storageVal = typeof value === 'string' ? value : JSON.stringify(value);
            LocalStorageUtils.setItem('preference_' + User.instance.id + '_' + context, storageVal);
        }
    }
    setLastAccessedPage(url, ignorePageList, ignoreAppList) {
        const windowObject = PreferencesService.getWindowObject();
        const host = windowObject.location.hostname;
        let domain;
        if (host.indexOf('localhost') > -1) {
            domain = '.dev.localhost';
        }
        else {
            domain = host.substring(host.indexOf('.'));
        }
        const parser = document.createElement('a');
        let landingPageUrl;
        let hash;
        parser.href = HttpUrlUtils.instance.sanitizeUrl(url);
        const protocol = parser.protocol;
        const port = parser.port;
        const hashPath = parser.hash;
        const pathSplit = parser.pathname.split('/');
        const appContext = pathSplit[1];
        const path = '/' + pathSplit.slice(2).join('/');
        const hashValue = parser.hash.split('?');
        ignorePageList = ignorePageList || [];
        ignoreAppList = ignoreAppList || [];
        const hasExcludedUrl = ignorePageList.find((o) => hashPath.includes(o));
        const appExcludedUrl = ignoreAppList.find((o) => appContext.includes(o));
        if (!(hasExcludedUrl || appExcludedUrl)) {
            if (hashValue.length >= 1) {
                hash = hashValue[0];
                if (hashValue.length > 1 && hashValue[1] !== '') {
                    hash = this.getUrlParams(hash, hashValue[1]);
                }
                if (port === null || port === '') {
                    landingPageUrl = protocol + '//' + host + '/' + appContext + path + hash;
                }
                else {
                    landingPageUrl = protocol + '//' + host + ':' + port + '/' + appContext + path + hash;
                }
                CookieUtils.setCookie('bookmark_page', { landingPage: landingPageUrl }, {
                    domain,
                    expires: moment.utc().add(2, 'minutes').toDate(),
                    path: '/',
                    secure: protocol === 'https:',
                    samesite: protocol === 'https:' ? 'None' : 'Lax'
                });
            }
        }
    }
    getUserLastPage() {
        const preferences = this.getPreferences('general');
        if (preferences.navigation && preferences.navigation.lastPage) {
            return preferences.navigation.lastPage;
        }
    }
    getUserLastSubMenu() {
        const preferences = this.getPreferences('general');
        if (preferences.navigation && preferences.navigation.lastSubMenu) {
            return preferences.navigation.lastSubMenu;
        }
    }
    getUserLastApp() {
        const preferences = this.getPreferences('general');
        if (preferences.navigation && preferences.navigation.lastApp) {
            return preferences.navigation.lastApp;
        }
    }
    getUserLastModule() {
        const preferences = this.getPreferences('general');
        if (preferences.navigation && preferences.navigation.lastModule) {
            return preferences.navigation.lastModule;
        }
    }
    getUserLastAppContext() {
        const preferences = this.getPreferences('general');
        if (preferences.navigation && preferences.navigation.lastAppContext) {
            return preferences.navigation.lastAppContext;
        }
    }
    saveStatePreference(uiRouterData, ignorePageList) {
        const preferenceName = 'general';
        const location = PreferencesService.getWindowObject().location;
        const pathSplit = location.pathname.split('/');
        const appContext = pathSplit[1];
        const path = '/' + pathSplit.slice(2).join('/');
        const hash = location.hash;
        ignorePageList = ignorePageList || [];
        const hasExcludedUrl = ignorePageList.find((o) => hash.includes(o));
        if (!hasExcludedUrl) {
            const preferences = this.getPreferences(preferenceName) || {};
            preferences.navigation = preferences.navigation || {};
            preferences.navigation.lastPage = path + hash;
            if (uiRouterData.subMenuId) {
                preferences.navigation.lastSubMenu = uiRouterData.subMenuId;
            }
            else {
                preferences.navigation.lastSubMenu = uiRouterData.pageId;
            }
            preferences.navigation.lastAppContext = appContext;
            preferences.navigation.lastModule = uiRouterData.moduleId;
            this.setPreferences(preferenceName, preferences);
        }
    }
    setStudioUsers(userArray) {
        return LocalStorageUtils.setItem('preference_studioDoNotShow', userArray.join());
    }
    getStudioUsers() {
        let studioUsers = [];
        const usersString = LocalStorageUtils.getItem('preference_studioDoNotShow');
        if (usersString !== null && usersString.length !== 0) {
            studioUsers = usersString.split(',');
        }
        return studioUsers;
    }
    getUrlParams(hash, hashValue) {
        let bookmark = [];
        let urlParams = '';
        if (hashValue.includes('&')) {
            bookmark = hashValue.split('&');
            bookmark.forEach((entry) => {
                if (!(entry.startsWith('auth=') || entry.startsWith('authCode='))) {
                    if (urlParams === '') {
                        urlParams += entry;
                    }
                    else {
                        urlParams = urlParams + '&' + entry;
                    }
                }
            });
        }
        else if (!(hashValue.startsWith('auth=') || hashValue.startsWith('authCode='))) {
            urlParams = hashValue;
        }
        if (urlParams !== '') {
            hash = hash + '?' + urlParams;
        }
        return hash;
    }
}

class PermissionService {
    static get instance() {
        if (!this._instance) {
            this._instance = new PermissionService();
        }
        return this._instance;
    }
    constructor() {
        this.defaultPermissions = ['createAccount', 'login', 'default', 'expiredInvitation',
            'success', 'examples', 'form_examples', 'recoverPassword', 'setPassword', 'updatePassword',
            'resetPassword', 'expiredVerificationEmail', 'updateEmail'];
        this.tmPermissions = ['tenant:view'];
        this.permissionsHaveBeenFetchedFromServer = false;
        this.init();
    }
    init() {
        this.storedUserPermissions = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.permissions);
        // if already logged-in and got permissions
        if (User.instance.loggedIn && this.storedUserPermissions && this.storedUserPermissions.length > 0) {
            this.sectionToPermissionMap = this.storedUserPermissions;
        }
        else { // if not logged in - init permissions to the basic
            this.sectionToPermissionMap = CoreUtils.deepCopy(this.defaultPermissions);
        }
    }
    reset() {
        delete this.sectionToPermissionMap;
        delete this.storedUserPermissions;
        delete this.lowerCaseSectionToPermissionMap;
        this.permissionsHaveBeenFetchedFromServer = false;
        this.fetchUserPermissionListDeferred = null;
        this.init();
    }
    buildPermissionList(originalPermissionList) {
        const userPermissions = CoreUtils.deepCopy(originalPermissionList);
        // add default permissions to the received user permissions list
        // eslint-disable-next-line @typescript-eslint/no-for-in-array
        for (const i in this.defaultPermissions) {
            if (userPermissions.indexOf(this.defaultPermissions[i]) < 0) {
                userPermissions.push(this.defaultPermissions[i]);
            }
        }
        return userPermissions;
    }
    fetchUserPermissionList() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.fetchUserPermissionListDeferred) {
                this.fetchUserPermissionListDeferred = new Deferred();
                const fetchUserPermissionListResponse = yield HttpUtils.apiGet('/authorization/v1/role/permissions', undefined, true);
                this.fetchUserPermissionListDeferred.resolve(fetchUserPermissionListResponse);
            }
            return this.fetchUserPermissionListDeferred.promise;
        });
    }
    getUserPermissionList() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.sectionToPermissionMap && this.permissionsHaveBeenFetchedFromServer) {
                return this.sectionToPermissionMap;
            }
            try {
                const response = yield this.fetchUserPermissionList();
                if (response && response.permissions === null) {
                    console.error('get Permission failed.');
                    return response;
                }
                else {
                    const permissionsMap = this.buildPermissionList(response.permissions);
                    this.setPermissionsList(permissionsMap);
                    if (!this.isTMAdmin()) {
                        if (response.applications) {
                            LocalStorageUtils.setItem(LocalStorageUtils.KEYS.userApplications, response.applications);
                        }
                    }
                    else {
                        LocalStorageUtils.removeItem(LocalStorageUtils.KEYS.userApplications);
                    }
                    console.debug('get Permissions succeeded.');
                    return permissionsMap;
                }
            }
            catch (err) {
                console.error('Cannot get permissions: ', err);
                throw err;
            }
        });
    }
    isTMAdmin() {
        for (const permission of this.tmPermissions) {
            if (ArrayUtils.includes(this.sectionToPermissionMap, permission)) {
                return true;
            }
        }
        return false;
    }
    isAutomationStudioUser() {
        return (this.sectionToPermissionMap.indexOf('automationstudio:manage') > -1);
    }
    isAdmin() {
        return (this.sectionToPermissionMap.indexOf('all') > -1);
    }
    getLastPageURL(availableModules, accessKey, lastModule, lastSubMenu) {
        const targetModule = availableModules.find(a => a.id === lastModule);
        if (targetModule === undefined) {
            return undefined;
        }
        const targetLinksList = targetModule.linksList.find((t) => t.id === lastSubMenu);
        if (targetLinksList === undefined) {
            return undefined;
        }
        if (targetLinksList.subMenu === undefined && targetLinksList.id === accessKey) {
            return targetLinksList.appContext + targetLinksList.url;
        }
        else {
            const targetSubMenu = targetLinksList.subMenu.find((ts) => ts.id === accessKey);
            if (targetSubMenu) {
                return targetSubMenu.appContext + targetSubMenu.url;
            }
            else {
                return undefined;
            }
        }
    }
    setLastAccessedPage(ignorePageList, ignoreAppList) {
        return PreferencesService.instance.setLastAccessedPage(window.location.href, ignorePageList, ignoreAppList);
    }
    addAuthCodeParam(url, authCodeVal) {
        const newURL = this.addURLQueryParam(url, 'authCode');
        return (newURL + authCodeVal);
    }
    removeUrlParam(param) {
        // let urlObject : any ;
        const urlObject = new URLSearchParams(window.location.search);
        const auth = urlObject.get(param);
        if (auth !== undefined) {
            urlObject.set(param, '');
        }
    }
    addURLQueryParam(url, queryParam) {
        if (url.indexOf('?') > -1) {
            url = url + '&' + queryParam + '=';
        }
        else {
            url = url + '?' + queryParam + '=';
        }
        return url;
    }
    trimKey(section) {
        let str = '';
        if (typeof (section) === 'string') {
            str = section;
        }
        else if (section.name) {
            str = section.name;
        }
        else {
            return null;
        }
        return str.split(' ');
    }
    allowAccess(sections) {
        const sectionsList = this.trimKey(sections);
        if (this.sectionToPermissionMap == null || sectionsList == null || sectionsList.length === 0) {
            return false;
        }
        this.lowerCaseSectionToPermissionMap = [];
        for (const sectionPermission of this.sectionToPermissionMap) {
            this.lowerCaseSectionToPermissionMap.push(sectionPermission.toLowerCase());
        }
        for (const section of sectionsList) {
            if ((this.lowerCaseSectionToPermissionMap.indexOf(section.toLowerCase()) > -1)
                || this.lowerCaseSectionToPermissionMap.indexOf('all') > -1) {
                return true;
            }
        }
        return false;
    }
    resetToDefault() {
        this.sectionToPermissionMap = CoreUtils.deepCopy(this.defaultPermissions); // reset permissions to the basic.
    }
    setPermissionsList(permissions) {
        this.sectionToPermissionMap = permissions;
        this.permissionsHaveBeenFetchedFromServer = true;
        LocalStorageUtils.setItem(LocalStorageUtils.KEYS.permissions, this.sectionToPermissionMap);
    }
}

var Messages;
(function (Messages) {
    Messages["Loaded"] = "Loaded";
    Messages["Token"] = "Token";
    Messages["AccessTokenNeeded"] = "AccessTokenNeeded";
    Messages["AccessTokenAvailable"] = "AccessTokenAvailable";
    Messages["SessionTimeout"] = "SessionTimeout";
})(Messages || (Messages = {}));
class IFrameAppService {
    constructor() {
        this.issuer = 'CXOne';
        this.iframeName = '#host-iframe';
    }
    static getWindowObject() {
        return window;
    }
    static getDocumentObject() {
        return document;
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new IFrameAppService();
        }
        return this._instance;
    }
    set HostIFrameName(hostIFrameName) {
        this.iframeName = hostIFrameName;
    }
    receiveMessage(e) {
        if (e.data.issuer === this.iFrameAppIssuer) {
            if (e.data.messageType === Messages.Loaded || e.data.messageType === Messages.AccessTokenNeeded) {
                this.sendToken(User.instance.token, e.origin);
            }
        }
    }
    init(issuer) {
        this.iFrameAppIssuer = issuer;
        AngularZoneUtils.runOutsideAngularZone(() => {
            const windowObject = IFrameAppService.getWindowObject();
            windowObject.addEventListener('message', this.receiveMessage.bind(this));
        });
    }
    sendToken(token, origin) {
        const deferred = new Deferred();
        TenantCrossDomainParamsService.instance.getTenantBaseUrl().then((result) => {
            const data = {
                messageType: Messages.Token,
                issuer: this.issuer,
                token: token,
                urls: {
                    authBaseUrl: result.niceBaseUrl,
                    incontactBaseUrl: result.incontactBaseUrl,
                    niceBaseUrl: result.niceBaseUrl,
                    analyticsBaseUrl: result.analyticsBaseUrl,
                    incontactApiBaseUrl: result.incontactApiBaseUrl
                }
            };
            this.sendMessage(data, origin);
            deferred.resolve();
        });
        return deferred.promise;
    }
    sendAccessTokenAvailableMessage() {
        const data = {
            messageType: Messages.AccessTokenAvailable,
            issuer: this.issuer
        };
        this.sendMessage(data);
    }
    sendSessionTimeoutMessage() {
        const data = {
            messageType: Messages.SessionTimeout,
            issuer: this.issuer
        };
        this.sendMessage(data);
    }
    sendMessage(data, origin) {
        const iframe = IFrameAppService.getDocumentObject().querySelector(this.iframeName);
        if (iframe) {
            if (!origin) {
                origin = iframe.src.split('/')[0] + '//' + iframe.src.split('/')[2];
            }
            iframe.contentWindow.postMessage(data, origin);
        }
    }
}

class RefreshTokenService {
    constructor() {
        this.diffMinutesBeforeTokenExpire = 5;
        this._minutesToAutoLogout = 20;
        this._secondsToWarnPreLogout = 60; // countdown from this number of seconds before auto logout
        this._secondsToWarnPreLogoutBuffer = 2; // send warning event this number of seconds early to avoid timing weirdness
        this._secondsToWarnPreLogoutTotal = this._secondsToWarnPreLogout + this._secondsToWarnPreLogoutBuffer;
        this._refreshTokenRetryTimes = 5;
        this.getSessionActivityCallbackCount = 0;
        this.iframeCount = 0;
        this.hostIFrameName = '#host-iframe';
        this.sessionFrameUrl = '/login/#/sessionFrame';
        this._devMode = false;
        this.SITE_NOT_AUTHORIZED_POST_MESSAGE = 'Your site is not authorized to post to this page.';
    }
    static getWindowObject() {
        return window;
    }
    static getDocumentObject() {
        return document;
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new RefreshTokenService();
        }
        return this._instance;
    }
    set HostIFrameName(hostIFrameName) {
        this.hostIFrameName = hostIFrameName;
    }
    reset() {
        this.tokenExpireDate = undefined;
        this.diffMinutesBeforeTokenExpire = 5;
        this._minutesToAutoLogout = 20;
        this.refreshTokenTimer = undefined;
        this.autoLogoutTimer = undefined;
        this.autoLogoutWarningTimer = undefined;
        this.callAutoLogoutInMS = undefined;
        this._refreshTokenRetryTimes = 5;
        this.logoutUserCallback = undefined;
        this.updateUserTokenCallback = undefined;
    }
    get minutesToAutoLogout() {
        return this._minutesToAutoLogout;
    }
    set minutesToAutoLogout(val) {
        this._minutesToAutoLogout = val;
    }
    get refreshTokenRetryTimes() {
        return this._refreshTokenRetryTimes;
    }
    set refreshTokenRetryTimes(count) {
        this._refreshTokenRetryTimes = count;
    }
    logOut() {
        if (this.logoutUserCallback) {
            this.logoutUserCallback(true);
        }
    }
    init(token, tokenExpirationTime, updateTokenCallback, logoutCallback) {
        AngularZoneUtils.runOutsideAngularZone(() => {
            this.initCallbacks(updateTokenCallback, logoutCallback);
            this.saveDataInLocalStorage(token, tokenExpirationTime);
            this.startRefreshTokenTimer();
            this.subscribeToTimeoutChanges();
            this.subscribeToPageVisibilityChanges();
            this.subscribeToTokenExpires();
        });
    }
    initCallbacks(updateTokenCallback, logoutCallback) {
        this.updateUserTokenCallback = updateTokenCallback;
        this.logoutUserCallback = logoutCallback;
    }
    initFromLocalStorage(updateTokenCallback, logoutCallback) {
        AngularZoneUtils.runOutsideAngularZone(() => {
            this.initCallbacks(updateTokenCallback, logoutCallback);
            this.tokenExpireDate = LocalStorageUtils.getUserTokenExpirationTime();
            this.startRefreshTokenTimer();
            this.subscribeToTimeoutChanges();
            this.subscribeToPageVisibilityChanges();
            this.subscribeToTokenExpires();
        });
    }
    subscribeToTimeoutChanges() {
        SubscribeService.instance.subscribeToEvent('IDLE_TIMEOUT_UPDATED', () => { this.updateSessionTimeoutValue(); });
    }
    subscribeToPageVisibilityChanges() {
        SubscribeService.instance.subscribeToEvent(CXOneConstants.EVENTS.ON_PAGE_VISIBLE, () => { this.onPageVisible(); });
    }
    subscribeToTokenExpires() {
        SubscribeService.instance.subscribeToEvent(CXOneConstants.EVENTS.TOKEN_EXPIRED, () => { this.onTokenExpired(); });
    }
    verifyIfTokenExpired() {
        console.log('%% verify if user token expired');
        if (!CoreUtils.isTokenExpired()) {
            console.log('%% User token not expired');
            return;
        }
        const isRefreshTokenExpired = CoreUtils.isRefreshTokenExpired();
        if (isRefreshTokenExpired === true || isRefreshTokenExpired === undefined) {
            console.log('%% User token and refresh token has expired. Logging out user...');
            this.logOut();
        }
        else {
            console.log('%% User Token has expired. Refreshing token now....');
            this.refreshTokenNow();
        }
    }
    onTokenExpired() {
        console.log('%% on token expired verify refresh token');
        this.verifyIfTokenExpired();
    }
    onPageVisible() {
        console.log('%% on page visible verify user token');
        this.verifyIfTokenExpired();
    }
    updateSessionTimeoutValue() {
        const deferred = new Deferred();
        RefreshTokenService.instance.getSessionTimeout().then((tenantMetaData) => {
            if (tenantMetaData && tenantMetaData.tenantProperty && !CoreUtils.isNil(tenantMetaData.tenantProperty.sessionTimeout)) {
                this._minutesToAutoLogout = tenantMetaData.tenantProperty.sessionTimeout;
                this.stopTimer(this.autoLogoutTimer);
                this.stopTimer(this.autoLogoutWarningTimer);
                this.initAutoLogoutTimer();
                deferred.resolve();
            }
            else {
                deferred.resolve();
            }
        }, (errors) => {
            console.debug('%% Tenant-metadata retrieval failed; previous time will still be used.', errors);
            deferred.resolve();
        });
        return deferred.promise;
    }
    saveDataInLocalStorage(token, tokenExpirationTime, refreshToken) {
        LocalStorageUtils.setItem(LocalStorageUtils.KEYS.userToken, token);
        if (refreshToken) {
            LocalStorageUtils.setItem(LocalStorageUtils.KEYS.userRefreshToken, refreshToken);
        }
        // we save the DateTime representation of the tokenExpirationTimeSec which is in ms so we will always know when it is expires
        this.tokenExpireDate = moment(tokenExpirationTime);
        LocalStorageUtils.setItem(LocalStorageUtils.KEYS.expirationTime, this.tokenExpireDate.format());
    }
    updateNiceAuthCookie(token, refreshToken, tokenExpirationTimeSec, refreshTokenExpirationTimeSec) {
        return __awaiter(this, void 0, void 0, function* () {
            const authCookie = {
                token: token,
                tokenExpirationTimeSec: tokenExpirationTimeSec,
                refreshToken: refreshToken,
                refreshTokenExpirationTimeSec: refreshTokenExpirationTimeSec,
                sessionId: CookieUtils.getSessionId()
            };
            const brandingHostSessionIframe = RefreshTokenService.getDocumentObject().querySelector('#branding-host-session-iframe');
            if (brandingHostSessionIframe !== null) {
                const brandingHostUri = brandingHostSessionIframe.getAttribute('src');
                brandingHostSessionIframe.contentWindow.postMessage({
                    messageType: 'SetNiceAuthInfoForBrandingHostDomain',
                    issuer: RefreshTokenService.getWindowObject().location.host,
                    niceAuthInfo: authCookie
                }, brandingHostUri);
            }
            this.getIsCurrentHostNiceBaseUrl().then((isCurrentHostNiceBaseUrl) => {
                if (isCurrentHostNiceBaseUrl) {
                    const cookie = {
                        sessionId: CookieUtils.getSessionId()
                    };
                    console.debug('%% Update with remove token FT ON nice_auth_info cookie: ' + JSON.stringify(cookie));
                    CookieUtils.setAuthCookie(JSON.stringify(cookie));
                }
            }, (reason) => {
                console.debug('%% Not able to check if current host is inContact base url', reason);
            });
        });
    }
    getIsCurrentHostNiceBaseUrl() {
        const deferred = new Deferred();
        TenantCrossDomainParamsService.instance.getTenantBaseUrl().then((result) => {
            const niceBaseUrl = result.niceBaseUrl;
            const currentHost = RefreshTokenService.getWindowObject().location.host;
            const isCurrentHostNiceBaseUrl = niceBaseUrl.includes(currentHost);
            deferred.resolve(isCurrentHostNiceBaseUrl);
        }, (reason) => {
            deferred.reject(reason);
        });
        return deferred.promise;
    }
    initRefreshTokenTimer() {
        let callRefreshInMS = 5;
        const tokenExpireDateClone = moment(this.tokenExpireDate);
        // this is because when you add/subtract from a moment object,
        // it will return a new moment with the result but it will change the moment object too!
        let timeToCallRefresh = tokenExpireDateClone.subtract(this.diffMinutesBeforeTokenExpire, 'minutes');
        if (this._devMode) {
            timeToCallRefresh = timeToCallRefresh = moment(DateUtils.now()).add(30, 'seconds');
        }
        if (timeToCallRefresh.isBefore(moment(DateUtils.now()))) {
            callRefreshInMS = this.tokenExpireDate.diff(moment(DateUtils.now()));
        }
        else {
            callRefreshInMS = timeToCallRefresh.diff(moment(DateUtils.now()));
            // get how much milliseconds from now is the time to call refresh (25 minutes)
        }
        console.debug('initRefreshTokenTimer should call onTimeoutToRefreshToken in ', callRefreshInMS);
        this.refreshTokenTimer = RefreshTokenService.getWindowObject().setTimeout(this.onTimeoutToRefreshToken.bind(this), callRefreshInMS);
        // we want the function to run only once
        console.debug('%% Current Time is ' + moment(DateUtils.now()).format() + '.  Token will expire at: ' + this.tokenExpireDate.format() +
            '. RefreshTokenTimer was set to:' + timeToCallRefresh.format());
    }
    onTimeoutToRefreshToken() {
        console.debug('%% user activity was at the last ' + this.diffMinutesBeforeTokenExpire + ' minutes. About to call refreshToken api...');
        this.refreshTokenNow();
    }
    refreshTokenNow() {
        return this.refreshTokenInternal();
    }
    getSessionTimeout() {
        const deferred = new Deferred();
        HttpUtils.apiGet('/tenant-metadata/v1/tenant-properties?fields=sessionTimeout&noCache', undefined, true).then((res) => {
            console.debug('user session timeout received successfully');
            deferred.resolve(res);
        }, (reason) => {
            console.error('user session timeout failed. Reason: ', reason);
            deferred.reject(reason);
        });
        return deferred.promise;
    }
    startRefreshTokenTimer() {
        const deferred = new Deferred();
        // Set new default of 15 minutes
        this._minutesToAutoLogout = 15;
        this.getSessionTimeout().then((tenantMetaData) => {
            if (tenantMetaData && tenantMetaData.tenantProperty && !CoreUtils.isNil(tenantMetaData.tenantProperty.sessionTimeout)) {
                this._minutesToAutoLogout = tenantMetaData.tenantProperty.sessionTimeout;
                console.debug('Session Timeout Updated ', this._minutesToAutoLogout);
            }
            this.initRefreshTokenTimer();
            this.initAutoLogoutTimer();
            deferred.resolve();
        }).catch(reason => {
            console.debug('%% Tenant-metadata retrieval failed; default time will be used. Reason', reason);
            this.initRefreshTokenTimer();
            this.initAutoLogoutTimer();
            deferred.resolve();
        });
        return deferred.promise;
    }
    isTimeExpired() {
        const lastActivityTime = CookieUtils.getUserLastActivityTime();
        console.debug('%% User last activity was at ' + lastActivityTime.format() + '. right now time is: ' + moment(DateUtils.now()).format());
        const lastActiveInMS = DateUtils.now().getTime() - lastActivityTime.toDate().getTime();
        console.debug('isTimeExpired', lastActiveInMS, this.callAutoLogoutInMS, lastActiveInMS >= this.callAutoLogoutInMS);
        return lastActiveInMS >= this.callAutoLogoutInMS;
    }
    isTimeExpiringSoon() {
        const lastActivityTime = CookieUtils.getUserLastActivityTime();
        console.debug('%% User last activity was at ' + lastActivityTime.format() + '. right now time is: ' + moment(DateUtils.now()).format());
        const lastActiveInMS = DateUtils.now().getTime() - lastActivityTime.toDate().getTime();
        console.debug('%% User last activity was ' + lastActiveInMS + ' milliseconds ago');
        console.debug('isTimeExpiringSoon', lastActiveInMS, this.callAutoLogoutInMS, this.callAutoLogoutInMS - (this._secondsToWarnPreLogoutTotal * 1000), lastActiveInMS >= (this.callAutoLogoutInMS - (this._secondsToWarnPreLogoutTotal * 1000)));
        return lastActiveInMS >= (this.callAutoLogoutInMS - (this._secondsToWarnPreLogoutTotal * 1000));
    }
    shouldAutoLogout() {
        return this._minutesToAutoLogout !== 0;
    }
    receiveSessionForCrossDomainIFrameApp(e) {
        const deferred = new Deferred();
        this.getSessionActivityCallbackCount += 1;
        if (this.getSessionActivityCallbackCount >= this.iframeCount) {
            RefreshTokenService.getWindowObject().removeEventListener('message', this.receiveMessageFunction);
        }
        TenantCrossDomainParamsService.instance.getTenantBaseUrl().then(baseUrlObject => {
            if (e.data === this.SITE_NOT_AUTHORIZED_POST_MESSAGE) {
                console.error('%% Not able to check cross domain lastActivityTime. ' + this.SITE_NOT_AUTHORIZED_POST_MESSAGE);
            }
            else if ((baseUrlObject.niceBaseUrl === e.origin || e.data.messageType === 'LastActivityEvent') &&
                e.data.lastActivityTime &&
                CookieUtils.getUserLastActivityTime().diff(e.data.lastActivityTime) < 0) {
                console.debug('%% Set lastActivityTime Cookie to: ' + e.data.lastActivityTime + '. LastActivityTime got it from cross domain');
                CookieUtils.setUserLastActivityTime(e.data.lastActivityTime);
            }
            if (this.getSessionActivityCallbackCount === this.iframeCount) {
                this.stopTimer(this.waitIFrameAppActivityTimer);
                this.logoutOrRestartTimer();
            }
            deferred.resolve();
        }).catch((err) => {
            console.error(err);
            deferred.resolve();
        });
        return deferred.promise;
    }
    receiveSessionForCrossDomainApp(e) {
        const deferred = new Deferred();
        RefreshTokenService.getWindowObject().removeEventListener('message', this.receiveSessionForCrossDomainApp);
        TenantCrossDomainParamsService.instance.getTenantBaseUrl().then(baseUrlObject => {
            if (e.data === this.SITE_NOT_AUTHORIZED_POST_MESSAGE) {
                console.error('%% Not able to check cross domain lastActivityTime. ' + this.SITE_NOT_AUTHORIZED_POST_MESSAGE);
            }
            else if (baseUrlObject.niceBaseUrl === e.origin &&
                e.data.lastActivityTime &&
                CookieUtils.getUserLastActivityTime().diff(e.data.lastActivityTime) < 0) {
                console.debug('%% Set lastActivityTime Cookie to: ' + e.data.lastActivityTime + '. LastActivityTime got it from cross domain');
                CookieUtils.setUserLastActivityTime(e.data.lastActivityTime);
            }
            this.logoutOrRestartTimer();
            deferred.resolve();
        }).catch((err) => {
            console.error(err);
            deferred.resolve();
        });
        return deferred.promise;
    }
    warningBeforeAutoLogout(lengthInSeconds) {
        if (this.isTimeExpiringSoon()) {
            if (lengthInSeconds < 0) {
                lengthInSeconds = 0;
            }
            SubscribeService.instance.invokeSubscribeCallbacks('LAUNCH_PRE_LOGOUT_MESSAGE', Math.floor(lengthInSeconds), true);
        }
        else {
            SubscribeService.instance.invokeSubscribeCallbacks('CLOSE_PRE_LOGOUT_MESSAGE', null, true);
            this.restartTimer();
        }
    }
    onTimeoutToAutoLogout() {
        const deferred = new Deferred();
        TenantCrossDomainParamsService.instance.getTenantBaseUrl().then(result => {
            try {
                this.getSessionActivityCallbackCount = 0;
                this.iframeCount = 0;
                const baseUrlObject = result;
                const host = RefreshTokenService.getWindowObject().location.host;
                const currentSubDomain = host.substring(host.indexOf('.')); // get current sub-domain e.g. dev.niceincontact.com
                const niceSubDomain = baseUrlObject.niceBaseUrl.substring(baseUrlObject.niceBaseUrl.indexOf('.'));
                const isDifferentSubDomain = niceSubDomain !== currentSubDomain;
                const hostIframe = RefreshTokenService.getDocumentObject().querySelector(this.hostIFrameName);
                const sessionIframe = RefreshTokenService.getDocumentObject().querySelector('#session-iframe');
                if (((sessionIframe !== null && isDifferentSubDomain) || hostIframe != null) && this.isTimeExpired()) {
                    // If there is an available cross domain session iframe, the last activity from that iframe must be checked before logging out
                    this.receiveMessageFunction = this.receiveSessionForCrossDomainIFrameApp.bind(this);
                    RefreshTokenService.getWindowObject().addEventListener('message', this.receiveMessageFunction);
                    if (sessionIframe !== null && isDifferentSubDomain) {
                        this.iframeCount += 1;
                        sessionIframe.contentWindow.postMessage({
                            messageType: 'GetSessionForCrossDomainApp',
                            issuer: host
                        }, baseUrlObject.niceBaseUrl + this.sessionFrameUrl);
                    }
                    if (hostIframe != null) {
                        this.iframeCount += 1;
                        IFrameAppService.instance.sendSessionTimeoutMessage();
                    }
                    const delayForWaitIFrameAppActivityMS = moment().add(1, 'minutes').diff(moment());
                    this.waitIFrameAppActivityTimer = RefreshTokenService.getWindowObject().setTimeout(this.elapseWaitIFrameAppResponseTimer.bind(this), delayForWaitIFrameAppActivityMS);
                }
                else {
                    this.logoutOrRestartTimer();
                }
                deferred.resolve();
            }
            catch (error) {
                console.debug('%% Session frame check failed; reverting to default auto logout check.', error);
                this.logoutOrRestartTimer();
                deferred.resolve();
            }
        }).catch(error => {
            console.debug('%% Session frame check failed; reverting to default auto logout check.', error);
            this.logoutOrRestartTimer();
            deferred.resolve();
        });
        return deferred.promise;
    }
    elapseWaitIFrameAppResponseTimer() {
        this.logoutOrRestartTimer();
    }
    retryRefreshTokenNow() {
        return __awaiter(this, void 0, void 0, function* () {
            this._refreshTokenRetryTimes = this._refreshTokenRetryTimes - 1;
            return new Promise((resolve) => {
                RefreshTokenService.getWindowObject().setTimeout(() => {
                    this.refreshTokenInternal();
                    resolve();
                }, 5000);
            });
        });
    }
    refreshTokenInternal() {
        return __awaiter(this, void 0, void 0, function* () {
            const authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
            const scope = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.scope);
            // calling sso refresh API in case of scope==openID
            if (scope && scope === 'openid') {
                const refreshRequestForOpenId = {
                    grant_type: 'refresh_token',
                    scope: 'openid'
                };
                const refreshTokenForOpenId = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userRefreshToken);
                if (refreshTokenForOpenId) {
                    refreshRequestForOpenId.refresh_token = refreshTokenForOpenId;
                }
                const url = ConfigurationService.instance.get('global.web_app.url').length < 1 ? URLUtils.getCxoneHost()
                    : ConfigurationService.instance.get('global.web_app.url') + '/openid/token';
                try {
                    const response = yield HttpUtils.apiPost(url, URLUtils.jQueryLikeParamSerializer(refreshRequestForOpenId), { headers: [{ name: 'Content-Type', value: 'application/x-www-form-urlencoded' }], overridePrefixValue: '' }, false);
                    yield this.handleRefreshTokenResponse(response, response.access_token, response.refresh_token, response.expires_in);
                }
                catch (reason) {
                    if (this._refreshTokenRetryTimes >= 1) {
                        yield this.retryRefreshTokenNow();
                    }
                    else {
                        this.logOut();
                        console.error('%% refresh token failed. Reason: ', reason);
                        throw reason;
                    }
                }
            }
            else {
                const action = {
                    url: authHostUrl + '/public/authentication/v1/refresh',
                    requireToken: false
                };
                const refreshRequest = {};
                const refreshToken = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userRefreshToken);
                if (refreshToken) {
                    refreshRequest.token = refreshToken;
                }
                try {
                    const response = yield HttpUtils.apiPost(action.url, refreshRequest, { overridePrefixValue: '' }, action.requireToken);
                    console.debug('response from refresh request', response);
                    yield this.handleRefreshTokenResponse(response, response.token, response.refreshToken, response.tokenExpirationTimeSec, response.refreshTokenExpirationTimeSec);
                }
                catch (reason) {
                    if (this._refreshTokenRetryTimes >= 1) {
                        yield this.retryRefreshTokenNow();
                    }
                    else {
                        this.logOut();
                        console.error('%% refresh token failed. Reason: ', reason);
                        throw reason;
                    }
                }
            }
        });
    }
    stopTimer(timer) {
        if (timer) {
            RefreshTokenService.getWindowObject().clearTimeout(timer);
            timer = undefined;
        }
    }
    logoutOrRestartTimer() {
        if (this.isTimeExpired()) {
            console.debug('%% No user activity in the last ' + this._minutesToAutoLogout + ' minutes. Logout the user');
            this.logOut();
        }
        else {
            console.debug('%% restart timer called ' + this._minutesToAutoLogout + ' minutes. Logout the user');
            this.restartTimer();
        }
    }
    restartTimer() {
        const lastActivityTime = CookieUtils.getUserLastActivityTime();
        const idleTime = moment().diff(lastActivityTime);
        this.elapseAutoLogoutTimer(this.callAutoLogoutInMS - idleTime);
    }
    elapseAutoLogoutTimer(delayForCallLogout) {
        this.stopTimer(this.autoLogoutTimer);
        this.stopTimer(this.autoLogoutWarningTimer);
        if (this.shouldAutoLogout()) {
            delayForCallLogout = !CoreUtils.isNil(delayForCallLogout) && (0 < delayForCallLogout < this.callAutoLogoutInMS) ? delayForCallLogout : this.callAutoLogoutInMS;
            console.debug('%% Remaining time: ' + delayForCallLogout + ' to check idle timeout');
            this.autoLogoutTimer = RefreshTokenService.getWindowObject().setTimeout(this.onTimeoutToAutoLogout.bind(this), delayForCallLogout);
            const warnInMS = delayForCallLogout - (this._secondsToWarnPreLogoutTotal * 1000);
            console.debug('%% Remaining time: ' + warnInMS + ' to warn about idle timeout');
            if (warnInMS > 0) {
                SubscribeService.instance.invokeSubscribeCallbacks('CLOSE_PRE_LOGOUT_MESSAGE', null, true);
                this.autoLogoutWarningTimer = RefreshTokenService.getWindowObject().setTimeout(() => { this.warningBeforeAutoLogout(this._secondsToWarnPreLogout); }, warnInMS);
            }
            else {
                this.warningBeforeAutoLogout(Math.floor(delayForCallLogout / 1000));
            }
        }
    }
    cancelTimer() {
        this.stopTimer(this.refreshTokenTimer);
        console.debug('%% Refresh timer is cancelled');
        // stop refreshToken timer
        this.stopTimer(this.autoLogoutTimer);
        this.stopTimer(this.autoLogoutWarningTimer);
        console.debug('%% autoLogout timer is cancelled');
    }
    initAutoLogoutTimer() {
        // User will not auto logout if minutesToAutoLogout is set to 0 hours.
        if (this.shouldAutoLogout()) {
            const callAutoLogout = moment().add(this._minutesToAutoLogout, 'minutes');
            this.callAutoLogoutInMS = callAutoLogout.diff(moment());
            if (this._devMode) {
                this.callAutoLogoutInMS = 120000;
            }
            console.debug('initAutoLogoutTimer should call onTimeoutToAutoLogout in', this.callAutoLogoutInMS);
            this.autoLogoutTimer = RefreshTokenService.getWindowObject().setTimeout(this.onTimeoutToAutoLogout.bind(this), this.callAutoLogoutInMS);
            const warnInMS = this.callAutoLogoutInMS - (this._secondsToWarnPreLogoutTotal * 1000);
            console.debug('initAutoLogoutTimer should warn about onTimeoutToAutoLogout in', warnInMS);
            this.autoLogoutWarningTimer = RefreshTokenService.getWindowObject().setTimeout(() => { this.warningBeforeAutoLogout(this._secondsToWarnPreLogout); }, warnInMS);
        }
    }
    handleRefreshTokenResponse(response, token, refreshToken, tokenExpirationTimeSec, refreshTokenExpirationTimeSec) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('%% refreshTokenNow is done successfully');
            const existingRole = UserTokenService.parseJwt(LocalStorageUtils.getItem('userToken')).role;
            const newRole = UserTokenService.parseJwt(token).role;
            this.saveDataInLocalStorage(token, moment().add(tokenExpirationTimeSec, 'seconds').valueOf(), refreshToken);
            SubscribeService.instance.invokeSubscribeCallbacks(CXOneConstants.EVENTS.USER_TOKEN_REFRESHED, token, true);
            yield this.updateNiceAuthCookie(token, refreshToken, tokenExpirationTimeSec, refreshTokenExpirationTimeSec);
            IFrameAppService.instance.sendAccessTokenAvailableMessage();
            yield this.reinitializeUserPermissions(existingRole, newRole);
            this.initRefreshTokenTimer();
            this._refreshTokenRetryTimes = 5;
            this.updateUserTokenCallback(token);
            return response;
        });
    }
    hasRolesChanged(existingRole, newRole) {
        if (existingRole.id !== newRole.id || existingRole.lastUpdateTime !== newRole.lastUpdateTime) {
            return true;
        }
        else if ('secondaryRoles' in existingRole && 'secondaryRoles' in newRole) {
            return this.hasSecondaryRolesChanged(existingRole.secondaryRoles, newRole.secondaryRoles);
        }
        return false;
    }
    hasRoleMatched(role, roleList) {
        for (const roleItem of roleList) {
            if (role.id === roleItem.id && role.lastUpdateTime === roleItem.lastUpdateTime) {
                return true;
            }
        }
        return false;
    }
    hasSecondaryRolesChanged(existingSecondaryRoles, newSecondaryRoles) {
        if (existingSecondaryRoles.length !== newSecondaryRoles.length) {
            return true;
        }
        for (const roleItem of existingSecondaryRoles) {
            const isRoleMatched = this.hasRoleMatched(roleItem, newSecondaryRoles);
            if (!isRoleMatched) {
                return true;
            }
        }
        return false;
    }
    reinitializeUserPermissions(existingRole, newRole) {
        return __awaiter(this, void 0, void 0, function* () {
            const deferred = new Deferred();
            if (this.hasRolesChanged(existingRole, newRole)) {
                try {
                    yield PermissionService.instance.getUserPermissionList();
                    RefreshTokenService.getWindowObject().location.reload();
                    deferred.resolve();
                }
                catch (e) {
                    deferred.reject();
                }
            }
            else {
                deferred.resolve();
            }
            return deferred.promise;
        });
    }
    fetchRefreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
            const response = yield HttpUtils.apiGet(authHostUrl + '/public/user/cookie', { overridePrefixValue: '' }, false).catch((reason) => {
                console.error('%% get refresh token failed. Reason: ', reason);
                throw new Error(reason);
            });
            LocalStorageUtils.setItem(LocalStorageUtils.KEYS.userRefreshToken, response.refreshToken);
            return response;
        });
    }
}

class UserActivityService {
    constructor() {
        this.activityCanceled = new Subject();
    }
    subscribeToVisibilityChange() {
        fromEvent(document, 'visibilitychange')
            .pipe(map(() => document.visibilityState))
            .subscribe(this.onPageVisibilityChange);
    }
    onPageVisibilityChange(visibilityState) {
        if (visibilityState === 'visible') {
            // Tab is now active
            console.log('Notifying page visible subscriptors');
            SubscribeService.instance.invokeSubscribeCallbacks(CXOneConstants.EVENTS.ON_PAGE_VISIBLE, null, false);
        }
        else if (visibilityState === 'hidden') {
            // Tab is now inactive
            console.debug('CxOne Page is hidden');
        }
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new UserActivityService();
        }
        return this._instance;
    }
    onWindowEventReceived() {
        this.lastActivityTime = moment(DateUtils.now()); // set lastActivityTime to current time (NOW)
        console.debug('%% onWindowEventReceived was called. elapse Auto logoutTimer and ' +
            'Updated lastActivityTime to: ' + this.lastActivityTime.format());
        RefreshTokenService.instance.elapseAutoLogoutTimer();
    }
    registerToGlobalActivityEvents() {
        const windowObject = CookieUtils.getWindowObject();
        windowObject.addEventListener('click', this.onWindowEventReceived.bind(this));
        windowObject.addEventListener('scroll', this.onWindowEventReceived.bind(this));
        windowObject.addEventListener('keypress', this.onWindowEventReceived.bind(this));
    }
    updateSessionForCrossDomainApp() {
        TenantCrossDomainParamsService.instance.getTenantBaseUrl().then(baseUrlObject => {
            const iframeElement = CookieUtils.getWindowObject().document.getElementById('session-iframe');
            const host = CookieUtils.getWindowObject().location.host;
            const currentSubDomain = host.substring(host.indexOf('.')); // get current sub-domain e.g. dev.niceincontact.com
            const niceSubDomain = baseUrlObject.niceBaseUrl.substring(baseUrlObject.niceBaseUrl.indexOf('.'));
            const isDifferentSubDomain = niceSubDomain !== currentSubDomain;
            if (iframeElement && isDifferentSubDomain) {
                if (iframeElement.contentWindow) {
                    console.debug('%% Sending postMessage to session-iframe. LastActivityTime: ' + this.lastActivityTime.format());
                    iframeElement.contentWindow.postMessage({
                        messageType: 'SetSessionForCrossDomainApp',
                        issuer: host,
                        lastActivityTime: this.lastActivityTime.format()
                    }, baseUrlObject.niceBaseUrl + '/login/#/sessionFrame');
                }
            }
        });
    }
    startSavingActivityTimer(useCookies) {
        const activityInterval = interval(30000);
        activityInterval.pipe(takeUntil(this.activityCanceled))
            .subscribe(() => this.triggerSavingActivity(useCookies));
    }
    triggerSavingActivity(useCookies) {
        const token = useCookies ? CookieUtils.getAccessToken() : LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userToken);
        if (!token) {
            RefreshTokenService.instance.logOut();
        }
        const savedLastActivityTime = CookieUtils.getUserLastActivityTime();
        if (savedLastActivityTime && this.lastActivityTime.format() !== savedLastActivityTime.format()) {
            if (this.lastActivityTime.diff(savedLastActivityTime) > 0) {
                console.debug('%% lastActivityTime updated to: ' + this.lastActivityTime.format() + '. About to save it to local storage');
                CookieUtils.setUserLastActivityTime(this.lastActivityTime.format());
                this.updateSessionForCrossDomainApp();
            }
        }
    }
    removeWindowEvents() {
        const windowObject = CookieUtils.getWindowObject();
        windowObject.removeEventListener('click', this.onWindowEventReceived);
        windowObject.removeEventListener('scroll', this.onWindowEventReceived);
        windowObject.removeEventListener('keypress', this.onWindowEventReceived);
    }
    init(useCookies) {
        AngularZoneUtils.runOutsideAngularZone(() => {
            this.activityCanceled.next(false);
            this.lastActivityTime = moment(DateUtils.now()); // save current time as lastActivityTime
            CookieUtils.setUserLastActivityTime(this.lastActivityTime.format());
            this.registerToGlobalActivityEvents();
            this.startSavingActivityTimer(useCookies ? true : false);
            this.subscribeToVisibilityChange();
        });
    }
    cancelTimerAndEvents() {
        this.activityCanceled.next(true);
        this.removeWindowEvents();
        console.debug('%% User activity timer is cancelled and window events are unsubscribed');
    }
    refreshLastActivityTime() {
        this.onWindowEventReceived();
    }
}

class UserAuthenticationService {
    constructor() {
        this.reset();
    }
    reset() {
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new UserAuthenticationService();
        }
        return this._instance;
    }
    authenticateUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield HttpUtils.apiPost('/public/authentication/v1/login', user, undefined, false);
                console.debug('authenticate user successfully');
                return result;
            }
            catch (reason) {
                console.error('authenticate user failed ', reason);
                throw reason;
            }
        });
    }
    updateAuthenticationUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpUtils.apiPatch('/authentication/v1/users/:userId', user, { params: { userId: user.id } }, true);
                console.debug('update authentication user successfully completed');
                return response;
            }
            catch (error) {
                console.error('update authentication user failed. Reason: ', error);
                throw error;
            }
        });
    }
    clearUserSession(areaIdentifier, env) {
        NotificationService.instance.disconnectWebSocket();
        this.clearUserData(areaIdentifier, env);
        CookieUtils.removeCookie('nice_auth_info');
        if (CookieUtils.getCookieAsObject('cxone_token_info')) {
            console.debug('removing cxone_token_info cookie on logout');
            CookieUtils.removeCookie('cxone_token_info');
        }
    }
    clearUserDetails() {
        User.instance.reset();
    }
    clearUserData(areaIdentifier, env) {
        this.clearUserDetails();
        LocalStorageUtils.clearAllValues();
        CookieUtils.clearAllCookies(areaIdentifier, env);
        UserActivityService.instance.cancelTimerAndEvents();
        RefreshTokenService.instance.cancelTimer();
        PermissionService.instance.resetToDefault();
    }
    callLogoutAPI(areaIdentifier, env) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const requestPayload = {
                    accessToken: LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userToken),
                    refreshToken: LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userRefreshToken)
                };
                yield HttpUtils.apiPost('/public/authentication/v1/logout', requestPayload, undefined, true);
                this.clearUserSession(areaIdentifier, env);
            }
            catch (reason) {
                console.error('authenticated user logout failed ', reason);
                throw reason;
            }
        });
    }
    impersonate() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const authUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
                const response = yield HttpUtils.apiPost(authUrl + '/authentication/v2/token/exchange/impersonation', undefined, { overridePrefixValue: '' }, true);
                console.debug('impersonate successfully completed');
                return response;
            }
            catch (error) {
                console.error('impersonate call failed.');
                throw error;
            }
        });
    }
}

class UserRoleService {
    constructor() {
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new UserRoleService();
        }
        return this._instance;
    }
    reset() {
        this.roles = undefined;
    }
    userRoleSearch(filter, metrices, page, operations, orderBy, isEntityQuery) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = {
                filter: filter,
                metrices: metrices,
                page: page,
                operations: operations,
                orderBy: orderBy,
                isEntityQuery: isEntityQuery
            };
            try {
                const response = yield HttpUtils.apiPost('/user/role/search', body, undefined, true);
                return response.roles;
            }
            catch (err) {
                console.error('Cannot get roles: ', err);
                throw err;
            }
        });
    }
    getRolesByFilter(filter, metrices) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = {
                filter: filter || {},
                metrices: metrices || {
                    columns: ['roleName', 'displayName']
                }
            };
            if (!this.roles) {
                try {
                    const response = yield HttpUtils.apiPost('/authorization/roles/search', body, undefined, true);
                    this.roles = response.roles;
                    return response;
                }
                catch (err) {
                    console.error('Cannot get roles: ', err);
                    throw err;
                }
            }
            else {
                return { roles: this.roles };
            }
        });
    }
    getRole() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield HttpUtils.apiGet('/authorization/v1/role', undefined, true);
            }
            catch (reason) {
                console.error('Error retrieving roles. Reason: ', reason);
                throw reason;
            }
        });
    }
    getAllAuthenticator() {
        return __awaiter(this, void 0, void 0, function* () {
            const searchData = {
                filter: {
                    status: ['ACTIVE'],
                    internal: [0]
                },
                page: {
                    pageNo: 0
                },
                metrices: {
                    columns: ['id', 'name', 'isDefault', 'type']
                }
            };
            try {
                return yield HttpUtils.apiPost('/authorization/v1/login-authenticator/search', searchData, undefined, true);
            }
            catch (error) {
                console.error('Error retrieving all authenticator. Reason: ', error);
                throw error;
            }
        });
    }
}

class PermissionServiceMock {
}
PermissionServiceMock.availableModules = [
    {
        id: 'admin',
        moduleName: 'Admin',
        linksList: [
            {
                id: 'userManagement',
                name: 'Employees',
                appContext: 'http://na1.localhost:8088/admin',
                url: '/#/userManagement'
            },
            {
                id: 'skills',
                name: 'Skills',
                appContext: 'http://na1.localhost:8088/admin',
                url: '/#/skills'
            },
            {
                id: 'groups',
                name: 'Groups',
                appContext: 'http://na1.localhost:8088/admin',
                url: '/#/groups'
            },
            {
                id: 'employeeGroups',
                name: 'Scheduling Unit',
                appContext: 'http://na1.localhost:8088/admin',
                url: '/#/employeeGroups'
            }
        ]
    },
    {
        id: 'scheduler',
        moduleName: 'Scheduler',
        linksList: [
            {
                id: 'scheduler',
                name: 'Schedule Manager',
                appContext: 'http://na1.localhost:8088/wfm',
                url: '/#/scheduler'
            },
            {
                id: 'realTimeAdherence',
                name: 'Real Time Adherence',
                appContext: 'http://na1.localhost:8088/wfm',
                url: '/#/realTimeAdherence'
            },
            {
                id: 'generateschedule',
                name: 'Generate Schedule',
                appContext: 'http://na1.localhost:8088/wfm',
                url: '/#/generateschedule'
            },
            {
                id: 'timeOffRequests',
                name: 'Requests',
                appContext: 'http://na1.localhost:8088/wfm',
                url: '/#/timeOffRequests'
            },
            {
                id: 'scheduler-setup',
                name: 'Scheduler Setup',
                appContext: 'http://na1.localhost:8088/wfm',
                subMenu: [
                    {
                        id: 'activityCodes',
                        name: 'Activity Codes',
                        appContext: 'http://na1.localhost:8088/wfm',
                        url: '/#/activityCodes'
                    },
                    {
                        id: 'dailyRule',
                        name: 'Daily Rules',
                        appContext: 'http://na1.localhost:8088/wfm',
                        url: '/#/dailyRule'
                    },
                    {
                        id: 'weeklyRules',
                        name: 'Weekly Rules',
                        appContext: 'http://na1.localhost:8088/wfm',
                        url: '/#/weeklyRules'
                    },
                    {
                        id: 'acdActivitiesMapping',
                        name: 'ACD Mapping',
                        appContext: 'http://na1.localhost:8088/wfm',
                        url: '/#/acdActivitiesMapping'
                    }
                ]
            },
            {
                id: 'shift-bidding',
                name: 'Shift Bidding',
                subMenu: [
                    {
                        id: 'shiftBiddingTemplates',
                        name: 'Bidding Templates',
                        appContext: 'http://na1.localhost:8088/wfm',
                        url: '/#/shiftBiddingTemplates'
                    },
                    {
                        id: 'biddingManager',
                        name: 'Bidding Manager',
                        appContext: 'http://na1.localhost:8088/wfm',
                        url: '/#/biddingManager'
                    }
                ]
            }
        ]
    },
    {
        id: 'forecaster',
        moduleName: 'Forecaster',
        linksList: [
            {
                id: 'generatedForecasts',
                name: 'Generate Forecast',
                appContext: 'http://na1.localhost:8088/wfm',
                url: '/#/generatedForecasts'
            },
            {
                id: 'importStaffingJob',
                name: 'Staffing Plans',
                appContext: 'http://na1.localhost:8088/wfm',
                url: '/#/importStaffingJob'
            },
            {
                id: 'historicalData',
                name: 'Historical Data',
                appContext: 'http://na1.localhost:8088/wfm',
                url: '/#/historicalData'
            }
        ]
    },
    {
        id: 'formManager',
        moduleName: 'QM Tools',
        linksList: [
            {
                id: 'manageForms',
                name: 'Form Manager',
                appContext: 'http://na1.localhost:8088/qm',
                url: '/#/manageForms'
            },
            {
                id: 'qpPlanManager',
                name: 'Quality Planner',
                appContext: 'http://na1.localhost:8088/qm',
                url: '/#/qpPlanManager'
            },
            {
                id: 'coaching',
                name: 'Coaching',
                appContext: 'http://na1.localhost:8088/qm',
                subMenu: [
                    {
                        id: 'coachingPackage',
                        name: 'Coaching Package',
                        appContext: 'http://na1.localhost:8088/qm',
                        url: '/#/coachingPackage'
                    },
                    {
                        id: 'coachingPlans',
                        name: 'Coaching Plans',
                        appContext: 'http://na1.localhost:8088/qm',
                        url: '/#/coachingPlans'
                    }
                ]
            }
        ]
    },
    {
        id: 'my-space',
        moduleName: 'My Space',
        linksList: [
            {
                id: 'mySchedule',
                name: 'My Schedule',
                appContext: 'http://na1.localhost:8088/wfm',
                url: '/#/mySchedule',
                embeddedClientSupport: true
            },
            {
                id: 'myTimeOffRequests',
                name: 'My Time Off Requests',
                appContext: 'http://na1.localhost:8088/wfm',
                url: '/#/myTimeOffRequests',
                embeddedClientSupport: true
            },
            {
                id: 'myDashboard',
                name: 'My Dashboard',
                appContext: 'http://na1.localhost:8088/mydashboard',
                url: '/#/myDashboard'
            },
            {
                id: 'myTasks',
                name: 'My Tasks',
                appContext: 'http://na1.localhost:8088/qm',
                url: '/#/myTasks'
            },
            {
                id: 'myEvaluations',
                name: 'My Evaluations',
                appContext: 'http://na1.localhost:8088/qm',
                url: '/#/myEvaluations',
                embeddedClientSupport: true
            },
            {
                id: 'plansMonitoring',
                name: 'Plan Monitoring',
                appContext: 'http://na1.localhost:8088/qm',
                url: '/#/plansMonitoring'
            },
            {
                id: 'performanceMonitoring',
                name: 'Performance Monitoring',
                appContext: 'http://na1.localhost:8088/qm',
                url: '/#/performanceMonitoring'
            },
            {
                id: 'shiftBidding',
                name: 'Shift Bidding',
                appContext: 'http://na1.localhost:8088/wfm',
                url: '/#/shiftBidding',
                embeddedClientSupport: true
            },
            {
                id: 'calibrations',
                name: 'Calibrations',
                appContext: 'http://na1.localhost:8088/qm',
                url: '/#/calibrations'
            },
            {
                id: 'myCoachings',
                name: 'My Coachings',
                appContext: 'http://na1.localhost:8088/qm',
                url: '/#/myCoachings',
                embeddedClientSupport: true
            }
        ]
    }
];

class AccessKeyService {
    constructor() {
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new AccessKeyService();
        }
        return this._instance;
    }
    reset() {
        this.accessKeys = undefined;
    }
    generateAccessKey(newAccessKeyRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield HttpUtils.apiPost('/access-key-management/v1/access-keys', newAccessKeyRequest, undefined, true);
            }
            catch (reason) {
                console.error('Cannot generate access key. reason: ', reason);
                throw reason;
            }
        });
    }
    updateAccessKey(accessKeyId, isActiveKey) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const body = {
                    isActive: isActiveKey
                };
                return yield HttpUtils.apiPatch(`/access-key-management/v1/access-keys/${accessKeyId}`, body, undefined, true);
            }
            catch (reason) {
                console.error('Cannot update access key. reason: ', reason);
                throw reason;
            }
        });
    }
    deleteAccessKey(accessKeyId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield HttpUtils.apiDelete(`/access-key-management/v1/access-keys/${accessKeyId}`, undefined, undefined, true);
            }
            catch (reason) {
                console.error('Cannot delete access key. reason: ', reason);
                throw reason;
            }
        });
    }
    getAllAccessKeysForUser(currentUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.accessKeys) {
                try {
                    return yield HttpUtils.apiGet('/access-key-management/v1/access-keys', { params: { userId: currentUserId } }, true, undefined);
                }
                catch (reason) {
                    console.error('Cannot get access keys for User. reason: ', reason);
                    throw reason;
                }
            }
            else {
                return this.accessKeys;
            }
        });
    }
    getAccessKeysForTenantPaginated(skip = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.accessKeys) {
                try {
                    return yield HttpUtils.apiGet('/access-key-management/v1/access-keys', { params: { top: 100, skip: skip } }, true, undefined);
                }
                catch (reason) {
                    console.error('Cannot get access keys for Tenant. reason: ', reason);
                    throw reason;
                }
            }
            else {
                return this.accessKeys;
            }
        });
    }
}

class GlobalAuthService {
    static getWindowObject() {
        return window;
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new GlobalAuthService();
        }
        return this._instance;
    }
    getDiscoveryResponse() {
        return __awaiter(this, void 0, void 0, function* () {
            // get discovery document
            const discoveryDocument = yield HttpUtils.apiGet('/.well-known/openid-configuration', { withCredentials: false, overridePrefixValue: ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.GlobalWebappUrl) }, false).catch((reason) => {
                console.error('get discovery document failed. Reason: ', reason);
                throw new Error(reason);
            });
            console.debug('logoutFromGA - end_session_endpoint = ' + discoveryDocument.end_session_endpoint);
            return discoveryDocument;
        });
    }
    logoutFromGA(postLogoutRedirectUri) {
        return __awaiter(this, void 0, void 0, function* () {
            // get discovery document
            const discoveryDocument = yield this.getDiscoveryResponse();
            console.debug('logoutFromGA - end_session_endpoint = ' + discoveryDocument.end_session_endpoint + ', postLogoutRedirectUri = ' + postLogoutRedirectUri);
            WindowService.instance.closeWindow();
            URLUtils.redirectToUrl(discoveryDocument.end_session_endpoint + '?post_logout_redirect_uri=' + postLogoutRedirectUri);
        });
    }
    getLoginAuthenticatorIdentities(queryParams) {
        return __awaiter(this, void 0, void 0, function* () {
            let fullUrl = '/authenticators/identities';
            if (queryParams !== '') {
                fullUrl = fullUrl + '?' + queryParams;
            }
            const response = yield HttpUtils.apiGet(fullUrl, { overridePrefixValue: ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.GlobalWebappUrl) }, true);
            return response;
        });
    }
    getLoginAuthenticatorById(loginAuthenticatorId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpUtils.apiGet('/authenticators/' + loginAuthenticatorId, { overridePrefixValue: ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.GlobalWebappUrl) }, true);
            return response;
        });
    }
    getTenantConfigDiscoveryApi() {
        return __awaiter(this, void 0, void 0, function* () {
            // get discovery API response for tenant configuration
            if (this.discoveryApiDocument === undefined) {
                this.discoveryApiDocument = yield HttpUtils.apiGet('/.well-known/cxone-configuration?tenantId=' + Organization.instance.id, { withCredentials: false, overridePrefixValue: ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.GlobalWebappUrl) }, false).catch((reason) => {
                    console.error('get discovery document failed. Reason: ', reason);
                    throw new Error(reason);
                });
            }
            console.debug('discover End point' + Organization.instance.id);
            return this.discoveryApiDocument;
        });
    }
}

class UserService {
    static getWindowObject() {
        return window;
    }
    constructor() {
        this.clientId = 'inContact Admin@inContact Inc.';
        this.noAccess = 'No Access';
        this.alignRole = {};
        this.embeddedClientDeferred = new Deferred();
        this.reset();
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new UserService();
        }
        return this._instance;
    }
    reset() {
        this.alignRole = {};
        this.embeddedClientDeferred = new Deferred();
        this.disableNotificationsforEmbeddedClient = null;
    }
    createWebSocket(disableNotifications) {
        let isSso = false;
        if (URLUtils.isUriPathExist('/sso')) {
            isSso = true;
            console.trace('NOTIFICATION createWebSocket, disableNotifications: ' + disableNotifications);
        }
        if (disableNotifications !== true && !isSso) {
            NotificationService.instance.createWebSocketHandshake();
        }
    }
    setInitialField(user) {
        Object.assign(user, { initials: CoreUtils.getUserInitials(user) });
    }
    initServices(authObj, disableNotifications) {
        return __awaiter(this, void 0, void 0, function* () {
            if (authObj.accessToken && authObj.accessTokenExpirationTime && authObj.id) {
                this.initUser({ id: authObj.id }, authObj.accessToken);
                LocalStorageUtils.setItem(LocalStorageUtils.KEYS.userToken, authObj.accessToken);
                try {
                    LocalStorageUtils.removeItem('preference_schedulerDate');
                    const userDetailsResponseAll = yield Promise.all([this.getUserDetails(authObj.id, true),
                        PermissionService.instance.getUserPermissionList()]);
                    const userDetailsResponse = userDetailsResponseAll[0];
                    this.initUser(userDetailsResponse.user, authObj.accessToken);
                    LocalStorageUtils.setItem(LocalStorageUtils.KEYS.userDetails, userDetailsResponse.user);
                    this.createWebSocket(disableNotifications);
                    UserActivityService.instance.init();
                    RefreshTokenService.instance.init(authObj.accessToken, authObj.accessTokenExpirationTime, this.updateUserToken.bind(this), this.logout.bind(this));
                }
                catch (error) {
                    console.debug('get user details failed for auth');
                    PermissionService.instance.setLastAccessedPage(['#/logout', '#/landingPage', '#/sessionFrame'], ['sso', 'logout']);
                    const authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
                    URLUtils.redirectToUrl(authHostUrl + '/login/');
                }
            }
            else {
                console.debug('invalid token or tokenExpirationTimeSec in auth param');
                PermissionService.instance.setLastAccessedPage(['#/logout', '#/landingPage', '#/sessionFrame'], ['sso', 'logout']);
                const authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
                URLUtils.redirectToUrl(authHostUrl + '/login/');
            }
        });
    }
    initUserFromToken(auth, disableNotifications) {
        return __awaiter(this, void 0, void 0, function* () {
            const accessToken = auth.token;
            let userId = '';
            let accessTokenExpirationTimeInMillis;
            try {
                const claims = UserTokenService.getClaimsFromToken(accessToken);
                if (claims && claims.exp) {
                    const expTimeInSeconds = claims.exp;
                    accessTokenExpirationTimeInMillis = moment.unix(expTimeInSeconds).valueOf();
                    console.debug('%% Claim TokenExpirationTimeInMillis: ' + accessTokenExpirationTimeInMillis);
                }
            }
            catch (err) {
                console.error('%% initUserFromToken: Unable to get feature toggle status. Reason: ' + err);
                accessTokenExpirationTimeInMillis = moment().add(auth.tokenExpirationTimeSec, 'seconds').valueOf();
                console.debug('%% TokenExpirationTimeInMillis: ' + accessTokenExpirationTimeInMillis);
            }
            LocalStorageUtils.setItem(LocalStorageUtils.KEYS.accessTokenExpirationTime, moment(accessTokenExpirationTimeInMillis).format());
            const subClaim = UserTokenService.getSubClaim(accessToken);
            if (subClaim) {
                userId = subClaim.split(':')[1] || '';
            }
            LocalStorageUtils.setItem(LocalStorageUtils.KEYS.userRefreshToken, auth.refreshToken);
            if (accessToken && accessTokenExpirationTimeInMillis && userId) {
                try {
                    this.initUser({ id: userId }, accessToken);
                    RefreshTokenService.instance.init(accessToken, accessTokenExpirationTimeInMillis, this.updateUserToken.bind(this), this.logout.bind(this));
                    LocalStorageUtils.removeItem('preference_schedulerDate');
                    const [userDetailsResponse] = yield Promise.all([this.getUserDetails(userId, true),
                        PermissionService.instance.getUserPermissionList()]);
                    this.initUser(userDetailsResponse.user, accessToken);
                    LocalStorageUtils.setItem(LocalStorageUtils.KEYS.userDetails, userDetailsResponse.user);
                    this.createWebSocket(disableNotifications);
                    UserActivityService.instance.init();
                }
                catch (error) {
                    console.debug('get user details failed for auth');
                    PermissionService.instance.setLastAccessedPage(['#/logout', '#/landingPage', '#/sessionFrame'], ['sso', 'logout']);
                    const authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
                    URLUtils.redirectToUrl(authHostUrl + '/login/');
                }
            }
            else {
                console.debug('invalid token or tokenExpirationTimeSec in auth param');
                PermissionService.instance.setLastAccessedPage(['#/logout', '#/landingPage', '#/sessionFrame'], ['sso', 'logout']);
                const authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
                URLUtils.redirectToUrl(authHostUrl + '/login/');
            }
        });
    }
    requestToken(ACTION, requestPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield HttpUtils.apiPost(ACTION.url, requestPayload, {
                    headers: [
                        { name: 'Authorization', value: 'Basic ' + btoa(this.clientId) }
                    ], overridePrefixValue: ''
                }, false);
                const token = UserTokenService.parseJwt(result.accessToken);
                return {
                    accessToken: result.accessToken,
                    accessTokenExpiry: result.accessTokenExpiry,
                    accessTokenExpirationTime: token.exp * 1000,
                    refreshToken: result.refreshToken,
                    refreshTokenExpiry: result.refreshTokenExpiry,
                    id: token.sub.substr(token.sub.indexOf(':') + 1)
                };
            }
            catch (error) {
                console.error('Request Token: Could not obtain token: ' + error);
                PermissionService.instance.setLastAccessedPage(['#/logout', '#/landingPage', '#/sessionFrame'], ['sso', 'logout']);
                const authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
                return URLUtils.redirectToUrl(authHostUrl + '/login/');
            }
        });
    }
    listenForToken(event, disableNotifications) {
        return __awaiter(this, void 0, void 0, function* () {
            if (event.data && event.data.messageType && event.data.messageType === 'Token' && event.data.issuer !== 'CXone') {
                if (event.data.token) {
                    const authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
                    const ACTION = {
                        url: authHostUrl + '/public/authentication/v1/token'
                    };
                    const tokenObj = { accessToken: event.data.token };
                    const authObj = yield this.requestToken(ACTION, tokenObj);
                    try {
                        yield this.initServices(authObj, disableNotifications);
                        this.embeddedClientDeferred.resolve();
                    }
                    catch (error) {
                        console.error('InitServices error: ' + error);
                        PermissionService.instance.setLastAccessedPage(['#/logout', '#/landingPage', '#/sessionFrame'], ['sso', 'logout']);
                        URLUtils.redirectToUrl(authHostUrl + '/login/');
                    }
                }
            }
        });
    }
    initUserFromEmbedded(disableNotifications) {
        return __awaiter(this, void 0, void 0, function* () {
            const embeddedClient = URLUtils.getQueryParameter('embeddedClient', UserService.getWindowObject().location.href);
            this.disableNotificationsforEmbeddedClient = disableNotifications;
            console.debug('initUserFromEmbedded.1', embeddedClient);
            if (embeddedClient) {
                const eventObj = {
                    messageType: 'Loaded',
                    token: '',
                    issuer: 'CXone'
                };
                UserService.getWindowObject().parent.postMessage(eventObj, '*');
                UserService.getWindowObject().addEventListener('message', this.listenForToken.bind(this));
                console.debug('Should have removed the URL parameters but lets wait');
                // let newUrl: string = URLUtils.removeURLParameter(UserService.getWindowObject().location.href, 'embeddedClient');
                // newUrl = URLUtils.removeURLParameter(newUrl, 'postMsg');
                // UserService.getWindowObject().location.href = newUrl;
                UserService.getWindowObject().setTimeout(() => {
                    console.debug('initUserFromEmbedded rejected');
                    this.embeddedClientDeferred.reject();
                }, 5000);
            }
            else {
                console.debug('EmbeddedClient param does not exist in redirection url');
                PermissionService.instance.setLastAccessedPage(['#/logout', '#/landingPage', '#/sessionFrame'], ['sso', 'logout']);
                const authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
                URLUtils.redirectToUrl(authHostUrl + '/login/');
            }
            return this.embeddedClientDeferred.promise;
        });
    }
    initUserFromRedirectionUrl(disableNotifications) {
        return __awaiter(this, void 0, void 0, function* () {
            const authParam = URLUtils.getQueryParameter('auth', UserService.getWindowObject().location.href);
            if (authParam) {
                const authStr = atob(authParam);
                const authObj = JSON.parse(authStr);
                yield this.initServices(authObj, disableNotifications);
            }
            else {
                console.debug('auth param does not exist in redirection url');
                PermissionService.instance.setLastAccessedPage(['#/logout', '#/landingPage', '#/sessionFrame'], ['sso', 'logout']);
                const authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
                URLUtils.redirectToUrl(authHostUrl + '/login/');
            }
        });
    }
    initUserFromLocalStorage(useCookie, disableNotifications) {
        if (useCookie) {
            let user = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userDetails);
            const token = CookieUtils.getAccessToken();
            if (!user && token) {
                console.debug('Token exists but user details not found: Extracting user from token');
                user = this.getUserFromToken(CookieUtils.getAccessToken());
                LocalStorageUtils.setItem(LocalStorageUtils.KEYS.userDetails, user);
            }
            this.initUser(user, token);
            this.createWebSocket(disableNotifications);
            UserActivityService.instance.init(true);
        }
        else {
            this.initUser(LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userDetails), //empty {}
            LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userToken));
            this.createWebSocket(disableNotifications);
            UserActivityService.instance.init();
            RefreshTokenService.instance.initFromLocalStorage(this.updateUserToken.bind(this), this.logout.bind(this));
        }
    }
    getUserFromToken(token) {
        let userId;
        const user = {};
        const subClaim = UserTokenService.getSubClaim(token);
        if (subClaim) {
            userId = subClaim.split(':')[1] || '';
        }
        const claims = UserTokenService.getClaimsFromToken(token);
        //create user basic info object
        if (claims) {
            user.id = userId;
            user.userName = claims.name;
            user.firstName = claims.given_name;
            user.lastName = claims.family_name;
            user.role = claims.role.legacyId;
            user.roleUUID = claims.role.id;
            user.organizationName = claims.tenant;
        }
        //set user local storage with basic details from token
        console.debug('Extracted user details: ', JSON.stringify(user));
        return user;
    }
    initUserFromCookie(auth, disableNotifications) {
        return __awaiter(this, void 0, void 0, function* () {
            const tokenFromCookie = JSON.parse(auth).accessToken;
            const tokenFromLocalStorage = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userToken);
            let authHostUrl;
            if (typeof tokenFromLocalStorage !== 'undefined' && tokenFromLocalStorage !== tokenFromCookie) {
                try {
                    authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
                    const ACTION = {
                        url: authHostUrl + '/public/authentication/v1/token'
                    };
                    const tokenObj = { accessToken: tokenFromCookie };
                    const result = yield this.requestToken(ACTION, tokenObj);
                    const authObj = {
                        token: result.accessToken,
                        refreshToken: result.refreshToken,
                        tokenExpirationTimeSec: result.accessTokenExpiry
                    };
                    yield this.initUserFromToken(authObj, disableNotifications);
                    return result;
                }
                catch (reason) {
                    console.error('unable to exchange for a new token. Reason: ', reason);
                    URLUtils.redirectToUrl(authHostUrl + '/login/');
                }
            }
            else if (tokenFromCookie) {
                const token = UserTokenService.parseJwt(tokenFromCookie);
                const authObj = {
                    accessToken: tokenFromCookie,
                    refreshToken: CookieUtils.getRefreshToken(),
                    accessTokenExpirationTime: token.exp * 1000,
                    id: token.sub.substr(token.sub.indexOf(':') + 1)
                };
                return yield this.initServices(authObj, disableNotifications);
            }
            else {
                return Promise.reject();
            }
        });
    }
    getAvailability(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpUtils.apiGet('/wfo/user/:userId/availability', { params: { userId } }, true);
                console.debug('availability retrieved completed');
                return response;
            }
            catch (reason) {
                console.error('Error retrieving user availability for user id "', userId, '", reason: ', reason);
                throw reason;
            }
        });
    }
    /**
     * @param ids list of userIds for which skills need to fetched for. Keep the length of userIds < 45.
     * To get all user skill associations call this method with empty arr.
     */
    getUserSkillAssociations(ids = []) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (ids.length === 0) {
                    return yield HttpUtils.apiGet('/wfo/user/users-to-skills', undefined, true);
                }
                else {
                    const userIds = ids.join(',');
                    return yield HttpUtils.apiGet('/wfo/user/users-to-skills?userIds=:userIds', { params: { userIds } }, true);
                }
            }
            catch (reason) {
                console.error(reason);
                throw reason;
            }
        });
    }
    getUserList(withAndWithoutEmailFlag, includeDeletedFlag) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                withAndWithoutEmail: withAndWithoutEmailFlag ? withAndWithoutEmailFlag : false,
                includeDeleted: includeDeletedFlag ? includeDeletedFlag : false
            };
            try {
                const [usersListResponse, rolesResponse] = yield Promise.all([HttpUtils.apiGet('/wfo/user', { params }, true),
                    UserRoleService.instance.getRolesByFilter()]);
                console.debug('getAllUsers done successfully');
                // this is a temporary fix, added for handling users imported, who don't have email id
                // once the api for importing users is complete, this will be removed.
                usersListResponse.users = this.filterUsersWithNoAccessRole(usersListResponse.users);
                yield this.applyChangesOnData(usersListResponse.users, rolesResponse.roles);
                return usersListResponse.users;
            }
            catch (reason) {
                console.error('getAllUsers failed. Reason: ', reason);
                throw reason;
            }
        });
    }
    userNameExists(userName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield HttpUtils.apiGet('/user/userName/exists/status', { params: { userName } }, true);
            }
            catch (reason) {
                console.error(reason);
                throw reason;
            }
        });
    }
    getUserListFilteredByName(searchName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const [usersByNameResponse, rolesResponse] = yield Promise.all([HttpUtils.apiGet('/user?fullNameContains=:search', { params: { search: searchName } }, true),
                    UserRoleService.instance.getRolesByFilter()]);
                yield this.applyChangesOnData(usersByNameResponse.users, rolesResponse.roles);
                return usersByNameResponse;
            }
            catch (reason) {
                console.error('Error searching for users. Reason: ', reason);
                throw reason;
            }
        });
    }
    userNameExistForPublicFlow(userName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield HttpUtils.apiGet('/public/user/username/exists', { params: { userName } }, false);
                return result.existing;
            }
            catch (reason) {
                console.error(reason);
                throw reason;
            }
        });
    }
    getUserDetails(userId, basicInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (basicInfo) {
                    console.debug('basicInfo is ', basicInfo);
                    const user = yield UserDetailsService.instance.getUserBasicDetails();
                    console.debug('getUserDetails.user', user);
                    return { user };
                }
                else {
                    try {
                        console.debug('get by Id API called');
                        return yield HttpUtils.apiGet('/user-management/v1/users/:userId', { params: { userId } }, true);
                    }
                    catch (reason) {
                        console.error('get User details failed', reason);
                        throw reason;
                    }
                }
            }
            catch (reason) {
                console.error('Get userDetailsFromDDB FT error' + reason);
                try {
                    return yield HttpUtils.apiGet('/user-management/v1/users/:userId', { params: { userId } }, true);
                }
                catch (reason2) {
                    console.error('get User details failed', reason2);
                    throw reason2;
                }
            }
        });
    }
    getImpersonateUsers() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const [usersListResponse, rolesResponse] = yield Promise.all([HttpUtils.apiGet('/wfo/user', { params: { onlyImpersonated: true } }, true), UserRoleService.instance.getRolesByFilter()]);
                console.debug('getImpersonateUsers done successfully');
                // this is a temporary fix, added for handling users imported, who don't have email id
                // once the api for importing users is complete, this will be removed.
                usersListResponse.users = this.filterUsersWithNoAccessRole(usersListResponse.users);
                yield this.applyChangesOnData(usersListResponse.users, rolesResponse.roles);
                return usersListResponse.users;
            }
            catch (reason) {
                console.error('getAllUsers failed. Reason: ', reason);
                throw reason;
            }
        });
    }
    getUserByPermission(permissionsFilter) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const [usersByPermissionResponse, rolesResponse] = yield Promise.all([HttpUtils.apiPost('/wfo/user/searchByPermission', permissionsFilter, undefined, true),
                    UserRoleService.instance.getRolesByFilter()]);
                console.debug('getAllUsers with permission done successfully');
                yield this.applyChangesOnData(usersByPermissionResponse.users, rolesResponse.roles);
                return usersByPermissionResponse.users;
            }
            catch (reason) {
                console.error('getAllUsers with permission failed. Reason: ', reason);
                throw reason;
            }
        });
    }
    searchUsers(searchPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpUtils.apiPost('/user-management/v1/users/search', searchPayload, undefined, true);
                console.debug('search users successfully completed');
                return response;
            }
            catch (error) {
                console.error('search users failed. Reason: ', error);
                throw error;
            }
        });
    }
    searchUsersV2(searchPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpUtils.apiPost('/user-management/v2/users/search', searchPayload, undefined, true);
                console.debug('search users successfully completed');
                return response;
            }
            catch (error) {
                console.error('search users failed. Reason: ', error);
                throw error;
            }
        });
    }
    getUsersBasicDetails(includeDeleted) {
        return __awaiter(this, void 0, void 0, function* () {
            if (includeDeleted === undefined) {
                includeDeleted = false;
            }
            const response = yield HttpUtils.apiPost('/user/getUsersBasicDetails?includeDeleted=:includeDeleted', {}, { params: { includeDeleted } }, true);
            console.debug('got users basic details');
            return response.users;
        });
    }
    getUsersByTeamIds(teamId, metrices, excludeDeleted) {
        return __awaiter(this, void 0, void 0, function* () {
            let body = {
                filter: { teamId },
                metrices
            };
            if (excludeDeleted) {
                body = {
                    filter: {
                        teamId,
                        status: ['UNREGISTERED', 'PENDING', 'ACTIVE']
                    },
                    metrices
                };
            }
            try {
                const response = yield HttpUtils.apiPost('/user/search', body, undefined, true);
                return response.users;
            }
            catch (reason) {
                console.error('unable to get users by the given filter. Reason: ', reason);
                throw reason;
            }
        });
    }
    /* function used to get users based on Custom Attribute
     Input to this is Array of Attribute.
     Eg. const attributes = [{id: 'canBeCoachedOrEvaluated', flag: true}];*/
    getUserByCustomAttribute(attributes) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            attributes.forEach(item => params[item.id] = item.flag);
            try {
                const [usersByCustomAttributeResponse, rolesResponse] = yield Promise.all([
                    HttpUtils.apiGet('/user/byAttributes', undefined, true),
                    UserRoleService.instance.getRolesByFilter()
                ]);
                console.debug('get Users done successfully by Custom Attribute');
                yield this.applyChangesOnData(usersByCustomAttributeResponse.users, rolesResponse.roles);
                return usersByCustomAttributeResponse.users;
            }
            catch (reason) {
                console.error('Failed to get users by Custom Attribute. Reason: ', reason);
                throw reason;
            }
        });
    }
    getWfoUsersByCustomAttribute(attributes) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            attributes.forEach(item => params[item.id] = item.flag);
            try {
                const [wfoUsersByCustomAttributeResponse, rolesResponse] = yield Promise.all([
                    HttpUtils.apiGet('/wfo/user/byAttributes', undefined, true),
                    UserRoleService.instance.getRolesByFilter()
                ]);
                console.debug('get WFO users done successfully by custom attribute');
                yield this.applyChangesOnData(wfoUsersByCustomAttributeResponse.users, rolesResponse.roles);
                return wfoUsersByCustomAttributeResponse.users;
            }
            catch (reason) {
                console.error('Failed to get WFO users by custom attribute. Reason: ', reason);
                throw reason;
            }
        });
    }
    /* this is a temporary fix, added for handling users imported, who don't have email id
       once the api for importing users is complete, this will be removed. */
    filterUsersWithNoAccessRole(users) {
        const filteredData = [];
        users.forEach((employee) => {
            if (employee.role !== this.noAccess) {
                filteredData.push(employee);
            }
        });
        return filteredData;
    }
    applyChangesOnData(users, roles) {
        const deferred = new Deferred();
        this.alignRoles(roles);
        for (const user of users) {
            this.convertUserStringDateToDate(user);
            this.setInitialField(user);
            user.role = this.alignRole[user.role];
            if (!user.role && user.roleUUID) {
                user.role = user.roleUUID;
            }
        }
        deferred.resolve();
        return deferred.promise;
    }
    alignRoles(roles) {
        if (roles) {
            roles.forEach(item => {
                this.alignRole[item.roleName] = item.displayName;
            });
        }
    }
    convertUserStringDateToDate(user) {
        try {
            if (!(user.hireDate instanceof Date)) {
                user.hireDate = this.convertStringHireDateToDate(user.hireDate);
            }
        }
        catch (e) {
            console.error('Error while converting date: ', e);
        }
    }
    convertStringHireDateToDate(userHireDateTime) {
        if (userHireDateTime) {
            let userHireDate = userHireDateTime;
            const timeIndex = userHireDateTime.indexOf('T');
            if (timeIndex >= 0) {
                userHireDate = userHireDateTime.substr(0, timeIndex);
            }
            return moment(userHireDate, 'YYYY-MM-DD').toDate();
        }
        else {
            console.debug('user hire date is undefined or null so using a default value.');
            return moment().toDate();
        }
    }
    createAccount(user) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpUtils.apiPost('/public/user/createaccount', user, undefined, true);
                this.userLoggedInSuccess(response);
                console.debug('create account done successfully');
            }
            catch (error) {
                console.error('create account failed for user:' + JSON.stringify(user) + ' Reason: ', error);
                throw error;
            }
        });
    }
    register(user) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpUtils.apiPost('/user/register', user, undefined, true);
                console.debug('user registration done successfully');
                return response;
            }
            catch (error) {
                console.error('user registration failed for user: ' + JSON.stringify(user) + ' Reason: ', error);
                throw error;
            }
        });
    }
    revive(emailAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpUtils.apiPost('/user/revive', emailAddress, undefined, true);
                console.debug('revive user done successfully');
                return response;
            }
            catch (error) {
                console.error('revive user failed for user address: ' + emailAddress + ' Reason: ', error);
                throw error;
            }
        });
    }
    getLockedUsers(retryObject) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpUtils.apiGet('/authentication/v1/locked-users', undefined, true, retryObject);
                console.debug('getLockedUsers call successful');
                return response;
            }
            catch (error) {
                console.error('getLockedUsers call failed', error);
                throw error;
            }
        });
    }
    resetUserPassword(newPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            const resetPwdRequest = {
                password: newPassword,
                email: User.instance.emailAddress
            };
            try {
                const response = yield HttpUtils.apiPost('/user/resetpassword', resetPwdRequest, undefined, true);
                console.debug('resetUserPassword successfully completed');
                return response;
            }
            catch (error) {
                console.error('resetUserPassword failed. Reason:', error);
                throw error;
            }
        });
    }
    invite(users) {
        return __awaiter(this, void 0, void 0, function* () {
            const inviteUsersRequest = {
                emailAddressesList: users,
                senderEmail: User.instance.userName
            };
            try {
                const response = yield HttpUtils.apiPost('/user/invite', inviteUsersRequest, undefined, true);
                console.debug('invite user successfully completed');
                return response;
            }
            catch (error) {
                console.error('invite user failed. Reason: ', error);
                throw error;
            }
        });
    }
    activateUser(userPassword, token, mfaToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const activateUserRequest = {
                email: User.instance.emailAddress,
                userName: User.instance.userName,
                password: userPassword,
                token,
                totp: mfaToken
            };
            try {
                const response = yield HttpUtils.apiPost('/public/user/activate', activateUserRequest, undefined, true);
                console.debug('activate user successfully completed');
                return response;
            }
            catch (error) {
                console.error('activate user failed. Reason: ', error);
                throw error;
            }
        });
    }
    update(user) {
        return __awaiter(this, void 0, void 0, function* () {
            this.removeRedundantFields(user);
            try {
                const response = yield HttpUtils.apiPost('/user/update', user, undefined, true);
                console.debug('update user done successfully');
                return response;
            }
            catch (error) {
                console.error('update user failed for user: ' + JSON.stringify(user) + ' Reason: ', error);
                throw error;
            }
        });
    }
    deleteUser(users) {
        return __awaiter(this, void 0, void 0, function* () {
            const deleteUsersRequest = {
                emailAddressesList: users
            };
            try {
                const response = yield HttpUtils.apiPost('/user/delete', deleteUsersRequest, undefined, true);
                console.debug('delete user successfully completed');
                return response;
            }
            catch (error) {
                console.error('delete user failed. Reason: ', error);
                throw error;
            }
        });
    }
    deleteUserById(usersIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const deleteUsersRequest = {
                userIds: usersIds
            };
            try {
                const response = yield HttpUtils.apiPost('/user/deleteUsersById', deleteUsersRequest, undefined, true);
                console.debug('delete user by Ids successfully completed');
                return response;
            }
            catch (error) {
                console.error('delete user by Ids failed. Reason: ', error);
                throw error;
            }
        });
    }
    updateUserRole(user) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpUtils.apiPut('/user/assignrole', user, undefined, true);
                console.debug('user role updated successfully');
                return response;
            }
            catch (error) {
                console.error('update user role failed for user: ' + JSON.stringify(user) + ' Reason: ', error);
                throw error;
            }
        });
    }
    verifyEmail(userName, token) {
        return __awaiter(this, void 0, void 0, function* () {
            const verifyEmailReq = {
                userName,
                emailVerificationToken: token
            };
            try {
                const response = yield HttpUtils.apiPatch('/public/user-management/v1/users/email-verify', verifyEmailReq, undefined, false);
                console.debug('verify email successfully completed');
                return response;
            }
            catch (error) {
                console.error('verify email failed. Reason: ', error);
                throw error;
            }
        });
    }
    emailVerification(users) {
        return __awaiter(this, void 0, void 0, function* () {
            const emailVerificationReq = {
                userIds: users
            };
            try {
                const response = yield HttpUtils.apiPatch('/user/v1/email-verification', emailVerificationReq, undefined, true);
                console.debug('email verification successfully completed');
                return response;
            }
            catch (error) {
                console.error('email verification failed. Reason: ', error);
                throw error;
            }
        });
    }
    initUser(user, accessToken) {
        if (user && accessToken) {
            User.instance.user = {
                token: accessToken,
                emailAddress: user.emailAddress,
                userName: user.userName,
                id: user.id,
                firstName: user.firstName,
                lastName: user.lastName,
                status: user.status,
                invitationExpired: user.invitationExpired,
                organizationName: user.organizationName,
                impersonated: user.impersonated,
                hireDate: user.hireDate || new Date('2015-03-01'),
                loggedIn: true,
                assignedGroup: user.assignedGroup,
                role: user.role
            };
        }
    }
    updateUserToken(newToken) {
        SubscribeService.instance.invokeSubscribeCallbacks('UPDATE_TOKEN', newToken, false);
        User.instance.user.token = newToken;
    }
    removeRedundantFields(user) {
        delete user.organizationName;
        delete user.status;
        delete user.password;
        delete user.invitationExpired;
        delete user.initials;
    }
    userLoggedInSuccess(loginResponse) {
        UserService.instance.initUser(loginResponse.user, loginResponse.token);
        LocalStorageUtils.setAccessTokenExpirationTimeFromResponse(loginResponse.tokenExpirationTimeSec);
        UserActivityService.instance.init(true);
    }
    login(user) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield UserAuthenticationService.instance.authenticateUser(user);
                if ((res.token === null || res.refreshToken === null) && res.authCode === null) {
                    console.error('login failed for user details: Token == null');
                    return Promise.reject();
                }
                else if (res.token === null && res.authCode != null) {
                    this.userLoggedInSuccess(res);
                    return res;
                }
                else {
                    this.userLoggedInSuccess(res);
                    return res;
                }
            }
            catch (reason) {
                console.error('login failed', reason);
                throw reason;
            }
        });
    }
    showLoginPage() {
        try {
            const authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
            URLUtils.redirectToUrl(authHostUrl + '/login/');
        }
        catch (error) {
            console.error('Unable to show login page' + error);
        }
    }
    resolveInvitationToken(emailAddress, username, tok) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestObj = {
                email: emailAddress,
                userName: username,
                token: tok
            };
            try {
                return yield HttpUtils.apiPost('/public/user/resolveInvitationToken', requestObj, undefined, false);
            }
            catch (reason) {
                console.error('resolve invitation token failed. Reason: ', reason);
                throw reason;
            }
        });
    }
    goToHelp() {
        UserService.getWindowObject().open('http://help.nice-incontact.com/', '_blank');
    }
    convertHireDateToStr(hireDate) {
        return moment(hireDate).format('MMM-DD-YYYY');
    }
    logout(isAuto) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                console.log('logoutFromGA flow as FT is ON - logout-SC-16277');
                const fullUrlPrefix = this.getLogoutUrlPrefix();
                yield GlobalAuthService.instance.logoutFromGA(this.getLogoutUrl(isAuto, fullUrlPrefix));
            }
            catch (err) {
                console.error(`Calling logoutFromRegional as error in GA logout, Error : ${err}`);
                this.logoutFromRegional(isAuto);
            }
            const globalWindow = WindowService.instance.getWindowObject();
            if (globalWindow.sessionStorage) {
                globalWindow.sessionStorage.clear();
            }
            if (globalWindow.aptrinsic) {
                // update Gainsight Reset Session
                globalWindow.aptrinsic('reset');
            }
        });
    }
    getLogoutUrl(isAuto, fullUrlPrefix) {
        const embeddedClientMode = ScreenUtils.instance.getLayoutSetting().isCustomLayout;
        if (embeddedClientMode) { // embedded client mode - keep the embeddedClient url parameter in order to relogin to this mode again
            return encodeURIComponent(fullUrlPrefix + '/login/#/logout?autoLogout=' + isAuto + '&embeddedClient=true');
        }
        else {
            return encodeURIComponent(fullUrlPrefix + '/login/#/logout?autoLogout=' + isAuto);
        }
    }
    getLogoutUrlPrefix() {
        return TenantCrossDomainParamsService.instance.getAuthHostForArea();
    }
    logoutFromRegional(isAuto) {
        console.log('Logout From Regional flow started');
        const fullUrlPrefix = this.getLogoutUrlPrefix();
        WindowService.instance.closeWindow();
        const embeddedClientMode = ScreenUtils.instance.getLayoutSetting().isCustomLayout;
        if (embeddedClientMode) { // embedded client mode - keep the embeddedClient url
            // parameter in order to relogin to this mode again
            URLUtils.redirectToUrl(fullUrlPrefix + '/login/#/logout?autoLogout=' + isAuto + '&embeddedClient=true');
        }
        else {
            URLUtils.redirectToUrl(fullUrlPrefix + '/login/#/logout?autoLogout=' + isAuto);
        }
    }
}

class UserServiceMock {
    static generateUser(fieldsOverride) {
        fieldsOverride = fieldsOverride || {};
        return {
            id: fieldsOverride.id === undefined ? '1000' : fieldsOverride.id,
            firstName: (fieldsOverride.firstName || UserServiceMock.randomString(10, 'abcdefghijklmnopqrstuvwxyz')),
            lastName: fieldsOverride.lastName || UserServiceMock.randomString(10, 'abcdefghijklmnopqrstuvwxyz'),
            skills: fieldsOverride.skills || [],
            role: fieldsOverride.role || 'Employee',
            emailAddress: fieldsOverride.emailAddress || UserServiceMock.randomEmail(10),
            mobileNumber: fieldsOverride.mobileNumber || UserServiceMock.randomString(10, '1234567890'),
            assignedGroup: fieldsOverride.assignedGroup || '',
            hireDate: fieldsOverride.hireDate,
            rank: fieldsOverride.rank || '1',
            maxHoursPerWeek: fieldsOverride.maxHoursPerWeek || '100',
            status: fieldsOverride.status || 'UNREGISTERED',
            impersonated: fieldsOverride.impersonated || false,
            customAttribute: fieldsOverride.impersonated || false,
            lock: fieldsOverride.lock || false
        };
    }
    static randomString(length, characterOverride) {
        let text = '';
        let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        if (characterOverride) {
            possible = characterOverride;
        }
        for (let i = 0; i < length; i += 1) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }
    static getUsersBasicDetails() {
        return [
            {
                id: '1',
                firstName: 'firstName',
                lastName: 'lastName',
                emailAddress: 'mockuser@mailinator.com',
                userName: 'mockuser@mailinator.com',
                role: 'Evaluator',
                status: 'ACTIVE'
            },
            {
                id: '2',
                firstName: 'firstName2',
                lastName: 'lastName2',
                emailAddress: 'mockuser2@mailinator.com',
                userName: 'mockuser2@mailinator.com',
                role: 'Evaluator',
                status: 'ACTIVE'
            }
        ];
    }
    static getUsersByTeamIds() {
        return [
            {
                id: '1',
                firstName: 'Bruce',
                lastName: 'Wayne',
                emailAddress: 'mockuser@mailinator.com',
                userName: 'mockuser@mailinator.com',
                role: 'Evaluator',
                status: 'ACTIVE'
            },
            {
                id: '2',
                firstName: 'Peter',
                lastName: 'Parker',
                emailAddress: 'mockuser2@mailinator.com',
                userName: 'mockuser2@mailinator.com',
                role: 'Evaluator',
                status: 'ACTIVE'
            }
        ];
    }
    static getDiscoveryDocument() {
        return {
            issuer: 'https://cxone.dev.niceincontact.com',
            authorization_endpoint: 'https://cxone.dev.niceincontact.com/auth/authorize',
            token_endpoint: 'https://cxone.dev.niceincontact.com/auth/token',
            jwks_uri: 'https://cxone.dev.niceincontact.com/auth/jwks',
            end_session_endpoint: 'https://cxone.dev.niceincontact.com/auth/authorize/logout'
        };
    }
    static randomEmail(length) {
        return UserServiceMock.randomString(length) + '@' + UserServiceMock.randomString(length) + '.' + UserServiceMock.randomString(3);
    }
}
UserServiceMock.userRoleSearchResponse = {
    roles: [{
            roleId: '11e8d0fb-67f6-65d0-8eee-0242ac110004',
            roleName: 'Impersonation',
            displayName: 'Impersonation'
        }, {
            roleId: '11e8d0fb-67f1-5cc1-bc2f-0242ac110002',
            roleName: 'Administrator',
            displayName: 'Administrator'
        }, {
            roleId: '11e8d0fb-6800-77f0-bc2f-0242ac110002',
            roleName: 'Employee',
            displayName: 'Agent'
        }, {
            roleId: '11e8d0fb-67f1-5cc0-bc2f-0242ac110002',
            roleName: 'Manager',
            displayName: 'Manager'
        }, {
            roleId: '11e8d0fb-67f4-42f0-8eee-0242ac110004',
            roleName: 'Evaluator',
            displayName: 'Evaluator'
        }],
    page: {
        pageSize: 2147483647,
        pageNo: 0,
        totalRecords: 5
    }
};
UserServiceMock.password = 'Pa$$w0rd';
UserServiceMock.auth = {
    refreshToken: 'test',
    refreshTokenExpirationTimeSec: 7200,
    token: 'testtoken',
    tokenExpirationTimeSec: 3600
};

class PermissionUserService {
    constructor() {
        this.searchList = [];
        this.defaultPageSize = 100;
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new PermissionUserService();
        }
        return this._instance;
    }
    getActiveUserByPermission(permissions) {
        return __awaiter(this, void 0, void 0, function* () {
            this.searchList = [];
            const roleSearchRequest = {
                filters: {
                    permissions: permissions,
                    permissionSearchType: ['ALL']
                },
                metrics: {
                    columns: ['roleName', 'displayName']
                }
            };
            try {
                const roles = yield UserRoleService.instance.userRoleSearch(roleSearchRequest.filters, roleSearchRequest.metrics, undefined, undefined, undefined, false);
                const rolesWithPermission = [];
                roles.forEach((role) => {
                    rolesWithPermission.push(role.roleName);
                });
                yield this.searchUsersByRole(this.searchList, rolesWithPermission, 0, this.defaultPageSize);
                this.searchList.forEach(user => {
                    user.fullName = user.firstName + ' ' + user.lastName;
                });
                this.selectedEvaluator = this.searchList.find(evaluator => evaluator.id === User.instance.id);
            }
            catch (e) {
                console.error(`Failed to load evaluators : ${e}`);
            }
            return this.searchList;
        });
    }
    searchUsersByRole(usersWithPermission, rolesWithPermission, page, size) {
        return __awaiter(this, void 0, void 0, function* () {
            const userSearchByRoleRequest = {
                filter: {
                    roleName: rolesWithPermission,
                    status: ['ACTIVE']
                },
                fields: ['id', 'userName', 'firstName', 'lastName', 'emailAddress', 'assignedGroup', 'role', 'fullName', 'status', 'acdLoginId', 'billable', 'hireDate', 'roleUUID'],
                skip: page,
                top: size
            };
            const searchResponse = yield UserService.instance.searchUsers(userSearchByRoleRequest);
            usersWithPermission.push(...searchResponse.users);
            if (usersWithPermission.length < searchResponse.totalRecords) {
                yield this.searchUsersByRole(usersWithPermission, rolesWithPermission, usersWithPermission.length, size);
            }
        });
    }
}

class LocationService {
    constructor() { }
    static get instance() {
        if (!this._instance) {
            this._instance = new LocationService();
        }
        return this._instance;
    }
    searchLocations(filter, fields, skip, top, operations, orderBy) {
        const body = {
            filter: filter,
            fields: fields,
            skip: skip,
            top: top,
            operations: operations,
            orderBy: orderBy
        };
        return from(HttpUtils.apiPost('/location-management/location/search', body, undefined, true, undefined)).pipe(catchError((error) => {
            console.error('Search locations failed:', error);
            throw (error);
        }));
    }
}

class DivisionService {
    constructor() { }
    static get instance() {
        if (!this._instance) {
            this._instance = new DivisionService();
        }
        return this._instance;
    }
    getDivisionEntities(filter, fields, skip, top, orderBy) {
        const body = {
            filter: filter,
            fields: fields,
            skip: skip,
            top: top,
            orderBy: orderBy
        };
        return from(HttpUtils.apiPost('/division-management/v1/division/identities', body, undefined, true, undefined)).pipe(catchError((error) => {
            console.error('Get division entities failed:', error);
            throw (error);
        }));
    }
}

class LockedEmployeeService {
    constructor() { }
    static get instance() {
        if (!this._instance) {
            this._instance = new LockedEmployeeService();
        }
        return this._instance;
    }
    searchLockedEmployees(filter, fields, skip, top, operations, orderBy) {
        filter.userLockStatus = ['true'];
        const prefixUrl = ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.GlobalWebappUrl);
        const body = {
            filter: filter,
            fields: fields,
            skip: skip,
            top: top,
            operations: operations,
            orderBy: orderBy
        };
        return from(HttpUtils.apiPost('/auth-manager/v1/user/search', body, { overridePrefixValue: prefixUrl }, true)).pipe(catchError((error) => {
            console.error('Search locked employees failed:', error);
            throw (error);
        }));
    }
    unlockEmployee(userId) {
        const prefixUrl = ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.GlobalWebappUrl);
        const requestUrl = '/auth-manager/v1/user/unlock/' + userId;
        return from(HttpUtils.apiPost(requestUrl, {}, { overridePrefixValue: prefixUrl }, true)).pipe(catchError((error) => {
            console.error('Unlock employee failed:', error);
            throw (error);
        }));
    }
}

class LockInactiveUserService {
    constructor() { }
    static get instance() {
        if (!this._instance) {
            this._instance = new LockInactiveUserService();
        }
        return this._instance;
    }
    getUserInactivityConfig(userId) {
        const prefixUrl = ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.GlobalWebappUrl);
        const requestUrl = '/security-policy/v1/user/' + userId;
        return from(HttpUtils.apiGet(requestUrl, { overridePrefixValue: prefixUrl }, true)).pipe(map$1(res => res), catchError(error => {
            console.log('Cannot get user inactivity configuration.', error);
            return throwError(error);
        }));
    }
    createUserInactivityConfig(userId, payload) {
        const prefixUrl = ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.GlobalWebappUrl);
        const body = {
            id: userId,
            userInactivityPolicy: payload.userInactivityPolicy
        };
        return from(HttpUtils.apiPost('/security-policy/v1/user', body, { overridePrefixValue: prefixUrl }, true)).pipe(map$1(res => res), catchError(error => {
            console.log('Cannot create user inactivity configuration.', error);
            return throwError(error);
        }));
    }
    updateUserInactivityConfig(id, payload) {
        const prefixUrl = ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.GlobalWebappUrl);
        const body = {
            userInactivityPolicy: payload.userInactivityPolicy
        };
        return from(HttpUtils.apiPatch('/security-policy/v1/user/' + id, body, { overridePrefixValue: prefixUrl }, true)).pipe(map$1(res => res), catchError(error => {
            console.log('Cannot update user inactivity configuration.', error);
            return throwError(error);
        }));
    }
}

class LockInactiveTenantService {
    constructor() { }
    static get instance() {
        if (!this._instance) {
            this._instance = new LockInactiveTenantService();
        }
        return this._instance;
    }
    getTenantInactivityConfig() {
        const prefixUrl = ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.GlobalWebappUrl);
        const requestUrl = '/security-policy/v1/tenant';
        return from(HttpUtils.apiGet(requestUrl, { overridePrefixValue: prefixUrl }, true)).pipe(map$1(res => res), catchError(error => {
            console.log('Cannot get tenant inactivity configuration.', error);
            return throwError(error);
        }));
    }
    createTenantInactivityConfig(inactivityDays) {
        const payload = {
            tenantInactivityPolicy: {
                inactivityDays: inactivityDays
            }
        };
        const prefixUrl = ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.GlobalWebappUrl);
        const requestUrl = '/security-policy/v1/tenant';
        return from(HttpUtils.apiPost(requestUrl, payload, { overridePrefixValue: prefixUrl }, true)).pipe(map$1(response => {
            console.log('Tenant inactivity configuration created successfully:', response);
            return response;
        }), catchError(error => {
            console.error('Failed to create tenant inactivity configuration:', error);
            throw error;
        }));
    }
    updateTenantInactivityConfig(inactivityDays) {
        const payload = {
            tenantInactivityPolicy: {
                inactivityDays: inactivityDays
            }
        };
        const prefixUrl = ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.GlobalWebappUrl);
        const requestUrl = '/security-policy/v1/tenant';
        return from(HttpUtils.apiPatch(requestUrl, payload, { overridePrefixValue: prefixUrl }, true)).pipe(map$1(response => {
            console.log('Tenant inactivity configuration updated successfully:', response);
            return response;
        }), catchError(error => {
            console.error('Failed to update tenant inactivity configuration:', error);
            throw error;
        }));
    }
}

class FeatureToggleService {
    constructor() {
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new FeatureToggleService();
        }
        return this._instance;
    }
    reset() {
        delete this.features;
    }
    loadFeatures(shouldFailOnError = true) {
        if (this.features) {
            return Promise.resolve(this.features);
        }
        return this.reloadFeatures(shouldFailOnError);
    }
    reloadFeatures(shouldFailOnError = true) {
        return this.sendGetToggledFeaturesRequest(shouldFailOnError);
    }
    getFeatureToggle(featureName, handleFailure = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.features) {
                try {
                    const features = yield this.loadFeatures();
                    return features !== undefined && features.indexOf(featureName) !== -1;
                }
                catch (err) {
                    if (handleFailure) {
                        console.warn('Cannot get the state of the feature toggle');
                        return false;
                    }
                    else {
                        /* eslint no-throw-literal: "off"*/
                        console.error('Cannot get the state of the feature toggle: ', err);
                        throw false;
                    }
                }
            }
            else {
                return this.features !== undefined && this.features.includes(featureName);
            }
        });
    }
    getFeatureToggleSync(featureName) {
        return this.features !== undefined && this.features.includes(featureName);
    }
    getPublicFeatureToggleStatus(featureName) {
        return new Promise((resolve, reject) => {
            HttpUtils.apiGet('/authentication/v1/feature-toggle?featurename=' + featureName, undefined, true).then((response) => {
                resolve(response);
            }, (err) => {
                console.error('Cannot get features: ', err);
                reject(err);
            });
        });
    }
    getPublicFeatureToggleStatusAsync(featureName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpUtils.apiGet('/authentication/v1/feature-toggle?featurename=' + featureName, undefined, false);
                return response.success;
            }
            catch (err) {
                console.error('Cannot get features. reason:', err);
                throw err;
            }
        });
    }
    sendGetToggledFeaturesRequest(shouldFailOnError = true) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield HttpUtils.apiGet('/config/toggledFeatures', undefined, true);
                this.features = res.toggledFeatures;
                return res.toggledFeatures;
            }
            catch (err) {
                if (shouldFailOnError) {
                    console.error('Cannot get features. reason:', err);
                    throw err;
                }
                else {
                    console.warn('Cannot get features. will return an empty array. reason:', err);
                    return [];
                }
            }
        });
    }
    setFeatures(features) {
        this.features = features;
    }
}

class FeatureToggleMock {
}
FeatureToggleMock.resolveFeatureToggle = (response) => {
    const deferred = new Deferred();
    if (typeof response === 'undefined' || response === null) {
        deferred.reject(false);
    }
    else {
        deferred.resolve(response);
    }
    return deferred.promise;
};
FeatureToggleMock.spyOnFeatureToggleService = (ftValues) => {
    spyOn(FeatureToggleService.instance, 'getFeatureToggle').and.callFake(featureName => {
        const response = ftValues[featureName];
        return FeatureToggleMock.resolveFeatureToggle(response);
    });
};

class PublicFeatureToggleService {
    constructor() {
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new PublicFeatureToggleService();
        }
        return this._instance;
    }
    getFeatureToggleForTenant(featureName) {
        return new Promise((resolve, reject) => {
            HttpUtils.apiGet('/authentication/v1/feature-toggle?featurename=' + featureName, undefined, false).then((response) => {
                resolve(response);
            }, (err) => {
                console.error('Cannot get features: ', err);
                reject(err);
            });
        });
    }
}

class IconSvgService {
    constructor() {
        this.SVG_PATH = '/common_svg_icons/svg/';
        this.setStaticBaseUrl(ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.StaticBaseUrl));
        if (this.staticBaseUrl === undefined) {
            this.setStaticBaseUrl(ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.ApiServerBaseUrl));
        }
        this.reset();
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new IconSvgService();
        }
        return this._instance;
    }
    reset() {
        this.iconsSpriteDataUrls = {};
    }
    getDocumentObject() {
        return document;
    }
    setStaticBaseUrl(url) {
        this.staticBaseUrl = url;
    }
    /**
     * @deprecated Use setStaticBaseUrl() instead
     */
    setApiBaseUrl(url) {
        this.setStaticBaseUrl(url);
    }
    getIconsSpriteDataUrl(spriteType) {
        return this.iconsSpriteDataUrls[spriteType];
    }
    setIconsSpritesDataUrl(spriteType, fileName) {
        this.iconsSpriteDataUrl = this.staticBaseUrl + this.SVG_PATH + fileName;
        this.iconsSpriteDataUrls[spriteType] = this.iconsSpriteDataUrl;
    }
    /**
     * This javascript function purpose is to load and cache the icons sprite file.
     * It's done by creating a temporary <svg> element, which uses the sprite file.
     *
     * @param metaDataObj : meta object
     * @param spriteName :  name of sprite
     */
    loadAndCacheIconsSpriteFiles(metaDataObj, spriteName) {
        const hrefValue = this.staticBaseUrl + this.SVG_PATH + metaDataObj[spriteName].fileName + '#' + metaDataObj['sample-symbol-id'];
        const tempDiv = document.createElement('div');
        tempDiv.setAttribute('id', 'toDelete');
        tempDiv.innerHTML = '<svg viewBox="0 0 100 100"><use href="' + hrefValue + '"></use></svg>';
    }
    loadAndCacheIconsSpriteFilesOnDOM(metaDataObj, spriteName, useXhr) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('loadAndCacheIconsSpriteFilesOnDOM for ', spriteName, metaDataObj);
            const hrefValue = this.SVG_PATH + metaDataObj[spriteName].fileName;
            try {
                let svgContents = '';
                if (useXhr) {
                    svgContents = yield HttpUtils.apiGet(hrefValue, { isSvgCall: true, useXhrRequest: true, overridePrefixValue: this.staticBaseUrl + '/' }, false);
                }
                else {
                    svgContents = yield HttpUtils.apiGet(hrefValue, { overridePrefixValue: this.staticBaseUrl + '/' }, false);
                }
                if (svgContents) {
                    const div = document.createElement('div');
                    div.innerHTML = svgContents;
                    div.style.display = 'none';
                    div.className = 'nice-icon-sprite';
                    div.setAttribute('data-spritename', spriteName);
                    div.setAttribute('data-spriteurl', hrefValue);
                    this.getDocumentObject().body.insertBefore(div, document.body.childNodes[0]);
                }
            }
            catch (e) {
                console.log(e);
            }
        });
    }
    loadAllIconsSprite(sprites, onDom, useXhr) {
        return __awaiter(this, void 0, void 0, function* () {
            const DEFAULT_SPRITES_TO_LOAD = ['application', 'navigation'];
            let spritesToLoad = DEFAULT_SPRITES_TO_LOAD.slice();
            if (sprites) {
                // first, convert to array:
                const additionalSprites = Array.isArray(sprites) ? sprites : [sprites];
                spritesToLoad = spritesToLoad.concat(additionalSprites);
            }
            try {
                const iconsMetaData = yield HttpUtils.apiGet(this.SVG_PATH + 'iconsData.json', { overridePrefixValue: this.staticBaseUrl + '/' }, false);
                for (const spriteName in JSON.parse(JSON.stringify(iconsMetaData))) {
                    if (iconsMetaData.hasOwnProperty(spriteName)) {
                        const iconsSpriteFileName = iconsMetaData[spriteName].fileName;
                        console.debug('Resulted ' + spriteName + '-icons file name: ', iconsSpriteFileName);
                        this.setIconsSpritesDataUrl(spriteName, iconsSpriteFileName);
                        if (spritesToLoad.includes(spriteName)) {
                            if (!onDom) {
                                this.loadAndCacheIconsSpriteFiles(iconsMetaData, spriteName);
                            }
                            else {
                                yield this.loadAndCacheIconsSpriteFilesOnDOM(iconsMetaData, spriteName, useXhr);
                            }
                        }
                    }
                }
                return this.iconsSpriteDataUrls;
            }
            catch (err) {
                console.error('Failed to get SVG icons from S3', err);
                throw err;
            }
        });
    }
    setAllIconsSprite(iconsSpriteDataUrls) {
        this.iconsSpriteDataUrls = iconsSpriteDataUrls;
    }
}

class PasswordService {
    constructor() {
        this.setGlobalWebAppUrl(ConfigurationService.instance.get('global.web_app.url').length < 1 ? URLUtils.getCxoneHost()
            : ConfigurationService.instance.get('global.web_app.url'));
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new PasswordService();
        }
        return this._instance;
    }
    setGlobalWebAppUrl(url) {
        this.globalWebAppUrl = url;
    }
    reset() {
        this.users = undefined;
    }
    getWindowObject() {
        return window;
    }
    getAuthenticationUsers(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.users) {
                try {
                    const response = yield HttpUtils.apiGet('/authentication/v1/users?filter=:filter', { params: { filter } }, true);
                    console.debug('getAuthenticationUsers done successfully');
                    this.users = response.users;
                    return response;
                }
                catch (reason) {
                    console.error('getAuthenticationUsers failed. Reason: ', reason);
                    throw reason;
                }
            }
            else {
                return this.users;
            }
        });
    }
    sendRecoverPasswordMessage(username) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestObj = {
                userName: username
            };
            try {
                const res = yield HttpUtils.apiPost('/authentication/v2/password/forgot', requestObj, undefined, false);
                console.debug('Sending recover password message successfully completed');
                return res;
            }
            catch (reason) {
                console.error('resolve invitation token failed. Reason: ', reason);
                throw reason;
            }
        });
    }
    resetPasswordAfterRecover(userPassword, tok, confirmationcode, mfaToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestObj = {
                email: User.instance.emailAddress,
                userName: User.instance.userName,
                password: userPassword,
                token: tok,
                confirmationCode: confirmationcode,
                totp: mfaToken
            };
            try {
                const res = yield HttpUtils.apiPost('/public/authentication/v1/password/reset', requestObj, undefined, false);
                console.debug('activate user successfully completed');
                return res;
            }
            catch (reason) {
                console.error('activate user failed. Reason: ', reason);
                throw reason;
            }
        });
    }
    changeUserPassword(useremail, currentpassword, newpassword, username) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestObj = {
                email: useremail,
                userName: username,
                currentPassword: currentpassword,
                newPassword: newpassword
            };
            try {
                const res = yield HttpUtils.apiPost('/authentication/v1/password/change', requestObj, undefined, true);
                console.debug('change user password successfully completed');
                return res;
            }
            catch (reason) {
                console.error('change user password failed. Reason: ', reason);
                throw reason;
            }
        });
    }
    forceChangeUserPassword(useremail, currentpassword, newpassword, username) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestObj = {
                email: useremail,
                userName: username,
                currentPassword: currentpassword,
                newPassword: newpassword
            };
            try {
                const res = yield HttpUtils.apiPost('/public/authentication/v1/password/force-change', requestObj, undefined, false);
                console.debug('force change user password successfully completed');
                return res;
            }
            catch (reason) {
                console.error('force change user password failed. Reason: ', reason);
                throw reason;
            }
        });
    }
    resolveRecoverPasswordToken(emailAddress, username, tok) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestObj = {
                email: emailAddress,
                userName: username,
                token: tok
            };
            try {
                return yield HttpUtils.apiPost('/public/user/resolveForgotPasswordToken', requestObj, undefined, false);
            }
            catch (reason) {
                console.error('resolve invitation token failed. Reason: ', reason);
                throw reason;
            }
        });
    }
    generateMfaSecret() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield HttpUtils.apiGet('/public/authentication/v1/mfa/secret', undefined, true);
                console.debug('generated mfa secret');
                return res;
            }
            catch (reason) {
                console.error('generate mfa secret failed. Reason: ', reason);
                throw reason;
            }
        });
    }
    getUserMfaDetails(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield HttpUtils.apiGet('/authentication/v1/mfa/:userId', { params: { userId } }, true);
                console.debug('user mfa details received successfully');
                return res;
            }
            catch (reason) {
                console.error('user mfa details failed. Reason: ', reason);
                throw reason;
            }
        });
    }
    saveUserMfaDetails(mfaData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield HttpUtils.apiPut('/authentication/v1/mfa', mfaData, undefined, true);
                console.debug('user mfa details received successfully');
                return res;
            }
            catch (reason) {
                console.error('user mfa details failed. Reason: ', reason);
                throw reason;
            }
        });
    }
    getPublicLoginAuthenticator(userName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield HttpUtils.apiGet('/public/authorization/v1/login-authenticator?username=:userName', { params: { userName } }, true);
                console.debug('public login authenticator received successfully');
                return res;
            }
            catch (reason) {
                console.error('public login authenticator failed. Reason: ', reason);
                throw reason;
            }
        });
    }
    setShowPasswordExpiringMessageCookie(value) {
        CookieUtils.setCookie(CookieUtils.KEYS.PASSWORD_EXPIRY_MESSAGE, value, {
            path: '/',
            maxAge: 28000,
            samesite: 'None',
            secure: true,
            domain: this.getWindowObject().location.host.substring(this.getWindowObject().location.host.indexOf('.')),
            expires: moment.utc().add(8, 'hours').toDate()
        });
    }
    getPasswordExpirationInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!CookieUtils.getCookieAsObject('showPasswordExpiringMessage')) {
                const filter = 'userId eq \'' + User.instance.id + '\'';
                const response = yield PasswordService.instance.getAuthenticationUsers(filter);
                const passwordModifiedDate = new Date(response.users[0].passwordlastModifiedOn);
                const passwordExpiryInterval = response.users[0].passwordExpiryInterval;
                const translationKey = {};
                if (passwordExpiryInterval > 0 && passwordExpiryInterval !== null) {
                    const passwordWillExpireOn = passwordModifiedDate;
                    passwordWillExpireOn.setHours(0, 0, 0, 0);
                    passwordWillExpireOn.setDate(passwordWillExpireOn.getDate() + parseInt(passwordExpiryInterval));
                    const currentDate = DateUtils.now();
                    currentDate.setHours(0, 0, 0, 0);
                    console.debug(currentDate, passwordWillExpireOn);
                    if (currentDate.getTime() <= passwordWillExpireOn.getTime()) {
                        const timeDiff = Math.abs(currentDate.setHours(0, 0, 0, 0) - passwordWillExpireOn.setHours(0, 0, 0, 0));
                        const diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
                        if (diffDays === 0) {
                            translationKey.message = 'cxone-components.passwordExpiration.expireToday';
                            this.setShowPasswordExpiringMessageCookie(true);
                        }
                        else if (diffDays === 1) {
                            translationKey.message = 'cxone-components.passwordExpiration.expireTomorrow';
                            this.setShowPasswordExpiringMessageCookie(true);
                        }
                        else if (diffDays <= 5 && diffDays !== 1) {
                            translationKey.message = 'cxone-components.passwordExpiration.willExpireIn';
                            translationKey.param = diffDays;
                            this.setShowPasswordExpiringMessageCookie(true);
                        }
                    }
                }
                return translationKey;
            }
        });
    }
    resetUserPasswordById(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield HttpUtils.apiPost('/credentials/v1/user/' + userId + '/force-change-password', {}, { overridePrefixValue: this.globalWebAppUrl }, true);
                console.debug('force change password received successfully');
                return res;
            }
            catch (reason) {
                console.error('force change password failed. Reason: ', reason);
                throw reason;
            }
        });
    }
}

class UserPreferencesService {
    static get instance() {
        if (!this._instance) {
            this._instance = new UserPreferencesService();
        }
        return this._instance;
    }
    constructor() {
        this.initDone = false;
        this.ApiUrls = {
            preferenceURL: '/preferences/v1/users/:userId/contexts/:applicationContext/preferences/:preferenceName',
            preferencesURL: '/preferences/v1/users/:userId/contexts/:applicationContext/preferences',
            preferencesMultiple: '/preferences/v1/users/:userId/multipleContexts/:applicationContexts/preferences'
        };
        this.reset();
    }
    reset() {
        this.initDefer = new Deferred();
        this.initDone = false;
    }
    setValueToLocalStorage(appContext, preferenceName, value) {
        const localStoragePreferenceKey = this.buildKey(appContext, preferenceName);
        LocalStorageUtils.setItem(localStoragePreferenceKey, JSON.stringify(value));
    }
    updateLocalStorage(userPreferences) {
        if (Array.isArray(userPreferences.preferences)) {
            for (const preference of userPreferences.preferences) {
                this.setValueToLocalStorage(this.applicationContext, preference.preferenceName, preference.value);
            }
        }
        else {
            Object.keys(userPreferences.preferences).forEach(key => {
                for (const preference of userPreferences.preferences[key]) {
                    this.setValueToLocalStorage(key, preference.preferenceName, preference.value);
                }
            });
        }
    }
    // clean all user preferences from local storage by application context
    cleanup() {
        const storedKeys = LocalStorageUtils.getKeys();
        const prefixKey = this.buildKey(this.applicationContext);
        const globalPrefixKey = this.buildKey(UserPreferencesService.GlobalContext);
        storedKeys.forEach((singleKey) => {
            if (singleKey.includes(prefixKey) || singleKey.includes(globalPrefixKey)) {
                LocalStorageUtils.removeItem(singleKey);
            }
        });
    }
    getUserApplicationPreference(preferenceName, appContext) {
        return __awaiter(this, void 0, void 0, function* () {
            const deferred = new Deferred();
            const currentContext = appContext ? appContext : this.applicationContext;
            const valueFromLocalStorage = this.getFromLocalStorage(currentContext, preferenceName);
            if (valueFromLocalStorage) {
                deferred.resolve(valueFromLocalStorage);
            }
            const requestObj = this.buildRequestObject(currentContext, preferenceName);
            try {
                const response = yield HttpUtils.apiGet(this.ApiUrls.preferenceURL, requestObj, true);
                this.updateLocalStorage(response);
                deferred.resolve(response);
            }
            catch (error) {
                console.error('UserPreferencesService: get user preferences failed. reason: ', error);
                deferred.reject({ success: false });
            }
            return deferred.promise;
        });
    }
    getUserApplicationPreferences() {
        return __awaiter(this, void 0, void 0, function* () {
            const deferred = new Deferred();
            this.cleanup();
            const requestObj = { params: {
                    userId: User.instance.id,
                    applicationContexts: (this.applicationContext ? [this.applicationContext, UserPreferencesService.GlobalContext] : [UserPreferencesService.GlobalContext])
                } };
            try {
                const response = yield HttpUtils.apiGet(this.ApiUrls.preferencesMultiple, requestObj, true);
                this.updateLocalStorage(response);
                deferred.resolve({ success: true });
            }
            catch (error) {
                console.error('UserPreferencesService: get user preferences failed. reason: ', error);
                deferred.resolve({ success: false });
            }
            return deferred.promise;
        });
    }
    // this function check in local storage. If no value in local storage it go to get from user-preference service
    getPreference(preferenceName, appContext) {
        return __awaiter(this, void 0, void 0, function* () {
            const deferred = new Deferred();
            const currentContext = appContext ? appContext : this.applicationContext;
            if (!this.initDone) {
                deferred.reject({ error: 'getPreference function can not be invoked before running init' });
                return deferred.promise;
            }
            const valueFromLocalStorage = this.getFromLocalStorage(currentContext, preferenceName);
            if (!valueFromLocalStorage) {
                try {
                    const response = yield this.getUserApplicationPreference(preferenceName, currentContext);
                    deferred.resolve(response);
                }
                catch (_a) {
                    deferred.resolve(null);
                }
            }
            else {
                deferred.resolve(valueFromLocalStorage);
            }
            return deferred.promise;
        });
    }
    // get all user preferences from local storage by application context
    getAllPreferences() {
        const preferences = {};
        if (!this.initDone) {
            console.error('getAllPreferences can not be invoked before running init');
            return null;
        }
        const keys = LocalStorageUtils.getKeys();
        const prefixKey = this.buildKey(this.applicationContext);
        keys.forEach((key) => {
            if (key.includes(prefixKey)) {
                const preferenceName = key.replace(prefixKey + '.', '');
                preferences[preferenceName] = LocalStorageUtils.getItem(key);
            }
        });
        return preferences;
    }
    setPreference(preferenceName, value, appContext) {
        return __awaiter(this, void 0, void 0, function* () {
            const deferred = new Deferred();
            const currentContext = appContext ? appContext : this.applicationContext;
            if (!this.initDone) {
                deferred.reject({ error: 'setPreference function can not be invoked before running init' });
                return deferred.promise;
            }
            // if the value exists in local storage we know that this value taken from the server - so we need to update
            // else we need to create
            const res = yield this.getPreference(preferenceName, currentContext);
            const requestObj = this.buildRequestObject(currentContext);
            try {
                const url = this.ApiUrls.preferencesURL;
                const bodyObj = this.buildBodyObj(preferenceName, value);
                res !== null ? yield HttpUtils.apiPut(url, bodyObj, requestObj, true) :
                    yield HttpUtils.apiPost(url, bodyObj, requestObj, true);
                this.setValueToLocalStorage(currentContext, preferenceName, value);
                console.debug('UserPreferencesService: set user preference succeed for application: ', currentContext);
                deferred.resolve({ success: true });
            }
            catch (error) {
                console.error('UserPreferencesService: set user preferences failed. reason:', error);
                deferred.reject({ success: false });
            }
            return deferred.promise;
        });
    }
    // should be called first on app initialization
    init(appContext) {
        return __awaiter(this, void 0, void 0, function* () {
            this.applicationContext = appContext || '';
            try {
                const result = yield this.getUserApplicationPreferences();
                this.initDone = true;
                this.initDefer.resolve(result);
            }
            catch (error) {
                this.initDefer.reject(error);
            }
            return this.initDefer.promise;
        });
    }
    whenInitComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.initDefer.promise;
        });
    }
    buildBodyObj(preferenceName, obj) {
        return {
            preferenceName,
            value: JSON.stringify(obj)
        };
    }
    buildKey(appContext, preferenceName) {
        let prefixKey = User.instance.id + '_' + appContext;
        if (preferenceName) {
            prefixKey += '.' + preferenceName;
        }
        return prefixKey;
    }
    getFromLocalStorage(appContext, preferenceName) {
        const localStoragePreferenceKey = this.buildKey(appContext, preferenceName);
        return LocalStorageUtils.getItem(localStoragePreferenceKey);
    }
    buildRequestObject(appContext, preferenceName) {
        return preferenceName ? {
            params: {
                userId: User.instance.id,
                applicationContext: appContext,
                preferenceName: preferenceName
            }
        } : {
            params: {
                userId: User.instance.id,
                applicationContext: appContext
            }
        };
    }
}
UserPreferencesService.GlobalContext = 'GlobalContext';

class UserSettingsService {
    constructor() {
        this.userSettingsUrl = '/user/settings';
        this.UserSettingsConstants = { DEFAULTS: { netStaffingPivots: [-10, -4, -1, 1, 4, 10] } };
        this.clearSettingsCache();
    }
    static transformSettingsForRequest(settingsMap) {
        const keysArray = Object.keys(settingsMap);
        return Object.values(settingsMap).reduce((accumulator, currentValue, keyIndex) => {
            let parsedValue;
            try {
                parsedValue = typeof currentValue === 'string' ? currentValue : JSON.stringify(currentValue);
            }
            catch (e) {
                parsedValue = currentValue;
            }
            accumulator[keysArray[keyIndex]] = parsedValue;
            return accumulator;
        }, {});
    }
    static getSettingsFromJson(jsonSettings, initialSettings) {
        const keysArray = Object.keys(jsonSettings);
        return Object.values(jsonSettings).reduce((accumulator, currentValue, keyIndex) => {
            let parsedValue;
            try {
                parsedValue = typeof currentValue === 'string' ? JSON.parse(currentValue) : currentValue;
            }
            catch (e) {
                parsedValue = currentValue;
            }
            accumulator[keysArray[keyIndex]] = parsedValue;
            return accumulator;
        }, initialSettings || {});
    }
    clearSettingsCache() {
        this.cachedSettings = undefined;
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new UserSettingsService();
        }
        return this._instance;
    }
    getUserSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.cachedSettings) {
                return Promise.resolve(this.cachedSettings);
            }
            this.cachedSettings = yield this.fetchUserSettings();
            return this.cachedSettings;
        });
    }
    fetchUserSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpUtils.apiGet('/' + this.userSettingsUrl, undefined, true);
                this.cachedSettings = this.handleGetUserSettingsResponse(response);
                return CoreUtils.deepCopy(this.cachedSettings);
            }
            catch (err) {
                console.error('Cannot get user settings domain mapping. reason: ', err);
                throw err;
            }
        });
    }
    handleGetUserSettingsResponse(response) {
        if (response && response.userSettingsMap) {
            response.userSettingsMap = UserSettingsService.getSettingsFromJson(response.userSettingsMap, this.UserSettingsConstants.DEFAULTS);
            this.cachedSettings = response;
        }
        return this.cachedSettings;
    }
    saveUserSettingsRequest(settingsMap) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.cachedSettings != null) {
                Object.keys(settingsMap).forEach((key) => {
                    this.cachedSettings[key] = CoreUtils.deepCopy(settingsMap[key]);
                });
            }
            const settingsForRequest = UserSettingsService.transformSettingsForRequest(settingsMap);
            try {
                const response = yield HttpUtils.apiPost('/user/settings', settingsForRequest, undefined, true);
                this.handleGetUserSettingsResponse(response);
                return CoreUtils.deepCopy(this.cachedSettings);
            }
            catch (error) {
                console.error('Cannot get user settings domain mapping. reason: ', error);
                throw error;
            }
        });
    }
}

class GridPreferencesService {
    static get instance() {
        if (!this._instance) {
            this._instance = new GridPreferencesService();
        }
        return this._instance;
    }
    constructor() {
        this.preferencesService = PreferencesService.instance;
    }
    getGridState(context) {
        let preferences = this.preferencesService.getPreferences(context);
        if (typeof preferences === 'string') {
            preferences = JSON.parse(preferences);
        }
        if (preferences.grid && preferences.grid.state) {
            return preferences.grid.state;
        }
        return null;
    }
    getGridSort(context) {
        let preferences = this.preferencesService.getPreferences(context);
        if (typeof preferences === 'string') {
            preferences = JSON.parse(preferences);
        }
        if (preferences.grid && preferences.grid.sort) {
            return preferences.grid.sort;
        }
        return null;
    }
    saveGridState(context, gridColumnState) {
        let preferences = this.preferencesService.getPreferences(context);
        if (typeof preferences === 'string') {
            preferences = JSON.parse(preferences);
        }
        preferences = this.preferencesService.addPreference(preferences, 'grid', { state: gridColumnState }, 'state');
        this.preferencesService.setPreferences(context, preferences);
    }
    saveGridSort(context, gridSort) {
        let preferences = this.preferencesService.getPreferences(context);
        if (typeof preferences === 'string') {
            preferences = JSON.parse(preferences);
        }
        preferences = this.preferencesService.addPreference(preferences, 'grid', { sort: gridSort }, 'sort');
        this.preferencesService.setPreferences(context, preferences);
    }
}

class SchedulerService {
    constructor() {
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new SchedulerService();
        }
        return this._instance;
    }
    getDaysOffPreferences(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield HttpUtils.apiGet('/schedules/agent/preferences/dayoff/user/:userId', { params: { userId } }, true);
                console.debug('getDaysOffPreferences done successfully');
                return result;
            }
            catch (reason) {
                return reason;
            }
        });
    }
    getPreferences(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield HttpUtils.apiGet('/schedules/agent/preferences/user/:userId', { params: { userId } }, true);
            }
            catch (reason) {
                console.error('Error retrieving user preferences for user id "', userId, '", reason: ', reason);
                throw reason;
            }
        });
    }
    getMyPreferences() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield HttpUtils.apiGet('/schedules/agent/preferences/user/current', undefined, true);
            }
            catch (reason) {
                console.error('Error retrieving user preferences for current user, reason: ', reason);
                throw reason;
            }
        });
    }
    updateMyPreferences(myPreferences) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield HttpUtils.apiPost('/schedules/agent/preferences/user/current', myPreferences, undefined, true);
            }
            catch (reason) {
                console.error('Error retrieving user preferences for current user, reason: ', reason);
                throw reason;
            }
        });
    }
    getMyDaysOffPreferences() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield HttpUtils.apiGet('/schedules/agent/preferences/dayoff/user/current', undefined, true);
                console.debug('getMyDaysOffPreferences done successfully');
                return result;
            }
            catch (reason) {
                console.error('getMyDaysOffPreferences failed for current user Reason: ', reason);
                throw reason;
            }
        });
    }
    updateMyDaysOffPreferences(myDaysOffPreferences) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield HttpUtils.apiPost('/schedules/agent/preferences/dayoff/user/current', myDaysOffPreferences, undefined, true);
                console.debug('updateMyDaysOffPreferences done successfully');
                return result;
            }
            catch (reason) {
                console.error('updateMyDaysOffPreferences failed for current user Reason: ', reason);
                throw reason;
            }
        });
    }
}

class CxoneAttendantService {
    constructor() { }
    static get instance() {
        if (!this._instance) {
            this._instance = new CxoneAttendantService();
        }
        return this._instance;
    }
    userHasAccessToApp(cxoneAttendantAPIUrl, isSwithToFacadeToggleEnabled) {
        let userInfoUrl = '/autoattendant/v9/users/exists';
        if (isSwithToFacadeToggleEnabled) {
            userInfoUrl = '/attendant/v11/users/exists';
        }
        const userExistsUrl = cxoneAttendantAPIUrl + userInfoUrl;
        const nameCXASessionStorageKey = this.getNameCXASessionStorageKey();
        return from(HttpUtils.apiGet(userExistsUrl, { overridePrefixValue: '' }, true)).pipe(map(response => {
            sessionStorage.setItem(nameCXASessionStorageKey, response.exists);
            return response.exists;
        }), take(1), timeout(4000), retry(2), catchError$1((err) => {
            sessionStorage.removeItem(nameCXASessionStorageKey);
            console.error('cxone attendant user not found. Reason: ', err);
            return throwError(err);
        }));
    }
    getNameCXASessionStorageKey() {
        const token = LocalStorageUtils.getItem('userToken');
        const icAgentId = UserTokenService.getICAgentId(token);
        const icBUId = UserTokenService.getICBUId(token);
        return 'CXA.Available_' + icAgentId + '_' + icBUId;
    }
    getCXoneAttendantUrl(env, area, isSwithToFacadeToggleEnabled, urlMapping, isApiUrl) {
        const keySelector = isApiUrl ? 'API' : 'UI';
        try {
            if (typeof urlMapping !== 'undefined') {
                if (typeof env !== 'undefined' && env.length === 1) {
                    // lab environments
                    return this.getUrlMappingByEnvironment(env[0], isSwithToFacadeToggleEnabled, urlMapping, keySelector, area);
                }
                else {
                    //prod API environments
                    return this.getUrlMappingByArea(area, isSwithToFacadeToggleEnabled, urlMapping, keySelector);
                }
            }
            else {
                console.error('Error getting CXone Attendant URL, default URL configured: ', 'url mapping is undefined');
            }
        }
        catch (error) {
            console.error('Error getting CXone Attendant URL, default URL configured: ', error);
        }
        return this.getDefaultCXoneAttendantUrl(env, isApiUrl);
    }
    getDefaultCXoneAttendantUrl(env, isApiUrl) {
        let cxoneAttendantUrl = (typeof env !== 'undefined' && env.length === 1) ?
            CxoneAttendantService.COMMON_CONFIGURATION.ApiCXABaseUrl.replace('%env%', env[0])
            : CxoneAttendantService.COMMON_CONFIGURATION.ApiCXABaseUrl.replace('%env%.', '');
        if (isApiUrl) {
            cxoneAttendantUrl = cxoneAttendantUrl.replace('attendant.', 'attendant-api.').replace('?version=latest', '');
        }
        return cxoneAttendantUrl;
    }
    getUrlMappingByArea(area, isSwithToFacadeToggleEnabled, urlMapping, keySelector) {
        let urlKey = '';
        if (isSwithToFacadeToggleEnabled && keySelector !== 'UI') {
            // Regionalized API Url
            urlKey = area;
        }
        else {
            // global Attendant service
            switch (area) {
                case 'na2':
                    urlKey = 'fedramp' + keySelector;
                    break;
                default:
                    urlKey = 'prod' + keySelector;
                    break;
            }
        }
        if (isSwithToFacadeToggleEnabled && keySelector === 'UI') {
            // Attendant UI regionalized Url
            const attendantUIUrl = urlMapping[urlKey] + '&region=' + area;
            return attendantUIUrl;
        }
        return urlMapping[urlKey];
    }
    getUrlMappingByEnvironment(env, isSwithToFacadeToggleEnabled, urlMapping, keySelector, area) {
        let urlKey = '';
        switch (env) {
            case 'dev':
            case 'test':
            case 'perf':
            case 'staging':
            case 'wcxperf':
            case 'icpune':
                urlKey = isSwithToFacadeToggleEnabled && keySelector !== 'UI' ? env : env + keySelector;
                if (isSwithToFacadeToggleEnabled && keySelector === 'UI') {
                    // Attendant UI regionalized Url
                    const attendantUIUrl = urlMapping[urlKey] + '&region=' + area;
                    return attendantUIUrl;
                }
                return urlMapping[urlKey];
            default:
                return this.getDefaultCXoneAttendantUrl(['dev'], keySelector === 'API');
        }
    }
}
CxoneAttendantService.COMMON_CONFIGURATION = {
    ApiCXABaseUrl: 'https://attendant.%env%.niceincontact.com?version=latest'
};

var ModuleType;
(function (ModuleType) {
    ModuleType["NORMAL"] = "normal";
    ModuleType["LAUNCHER"] = "launcher";
    ModuleType["INTERNAL"] = "internalLauncher";
})(ModuleType || (ModuleType = {}));

const NAV_FEATURE_TOGGLES = {
    MAX_CLOUDFRONT_URL: 'max-cloudfront-ic-49275',
    PARTNERHUB_URL: 'release-partners-partnerhub-TO-3635',
    FM_SETTINGS_FEATURE_TOGGLE: 'release-uh-feedback-management-settings-UH-36391',
    WEB_STUDIO_FEATURE_TOGGLE: 'webstudio-l0-menu-integration-STX-3227',
    MAX_GA_FEATURE_TOGGLE: 'release-discovery-api-integration-MAX-12901',
    XSIGHT_AI_FEATURE_TOGGLE: 'release-xsight-ai-CX-193903',
    ATT_SWITCH_USE_FACADE_URL_API_TOGGLE: 'release-attendant-api-switch-old-to-facade-urls-ATT-16659',
    SMARTREACH_FEATURE_TOGGLE: 'release-acd-SmartReach-OB-19327'
};

class BusinessUnitModel {
    constructor() {
        this._isInitialized = false;
        this.resetModelState();
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new BusinessUnitModel();
        }
        return this._instance;
    }
    get parentTenantId() {
        return this._currentBusinessUnitState.parentTenantId;
    }
    set parentTenantId(value) {
        this._isInitialized = true;
        this._currentBusinessUnitState.parentTenantId = value;
    }
    get businessUnitName() {
        this._isInitialized = true;
        return this._currentBusinessUnitState.businessUnitName;
    }
    set businessUnitName(value) {
        this._isInitialized = true;
        this._currentBusinessUnitState.businessUnitName = value;
    }
    get businessUnitId() {
        this._isInitialized = true;
        return this._currentBusinessUnitState.businessUnitId;
    }
    set businessUnitId(value) {
        this._isInitialized = true;
        this._currentBusinessUnitState.businessUnitId = value;
    }
    get tenantId() {
        return this._currentBusinessUnitState.tenantId;
    }
    set tenantId(value) {
        this._isInitialized = true;
        this._currentBusinessUnitState.tenantId = value;
    }
    get enableMaxReleasePreview() {
        return this._currentBusinessUnitState.enableMaxReleasePreview;
    }
    set enableMaxReleasePreview(value) {
        this._isInitialized = true;
        this._currentBusinessUnitState.enableMaxReleasePreview = value;
    }
    get isMultiContactHandling() {
        return this._currentBusinessUnitState.isMultiContactHandling;
    }
    set isMultiContactHandling(value) {
        this._isInitialized = true;
        this._currentBusinessUnitState.isMultiContactHandling = value;
    }
    get isUnifiedRoutingEnabled() {
        return this._currentBusinessUnitState.isUnifiedRoutingEnabled;
    }
    set isUnifiedRoutingEnabled(value) {
        this._isInitialized = true;
        this._currentBusinessUnitState.isUnifiedRoutingEnabled = value;
    }
    get isVFMEnabled() {
        return this._currentBusinessUnitState.isVFMEnabled;
    }
    set isVFMEnabled(value) {
        this._isInitialized = true;
        this._currentBusinessUnitState.isVFMEnabled = value;
    }
    get features() {
        return this._currentBusinessUnitState.features;
    }
    set features(value) {
        this._isInitialized = true;
        this._currentBusinessUnitState.features = value;
    }
    get apiVersion() {
        return this._apiVersion;
    }
    set apiVersion(value) {
        this._apiVersion = value;
    }
    get openMaxToBrowserTab() {
        return this._currentBusinessUnitState.openMaxToBrowserTab;
    }
    set openMaxToBrowserTab(value) {
        this._isInitialized = true;
        this._currentBusinessUnitState.openMaxToBrowserTab = value;
    }
    resetModelState() {
        this._isInitialized = false;
        this.apiVersion = '';
        this._currentBusinessUnitState = {
            businessUnitId: '',
            businessUnitName: '',
            tenantId: '',
            parentTenantId: '',
            openMaxToBrowserTab: false,
            enableMaxReleasePreview: false,
            isMultiContactHandling: false,
            isUnifiedRoutingEnabled: false,
            isVFMEnabled: false,
            features: []
        };
    }
    setModelState(businessUnitDetails) {
        if (businessUnitDetails && businessUnitDetails.businessUnitId) {
            this._isInitialized = true;
            this._currentBusinessUnitState = businessUnitDetails;
        }
    }
    getModelState() {
        return this._currentBusinessUnitState;
    }
    get isInitialized() {
        return this._isInitialized;
    }
}

class AcdBaseService {
    constructor() {
        this.endpointsList = new Map();
        this.deferredLoadModel = new Deferred();
    }
    resetDeferredState() {
        this.deferredLoadModel = new Deferred();
    }
    setApiEndpoint(endpointUrlTemplate, endpointKey, apiVersion) {
        if (apiVersion) {
            const match = apiVersion.match(/v(\d+).(\d+)/gi);
            if (match) {
                this.endpointsList.set(endpointKey, endpointUrlTemplate.replace('{version}', apiVersion));
            }
            else {
                throw new Error('Invalid Api Version format.');
            }
        }
        return this.endpointsList.get(endpointKey) || '';
    }
    getApiEndpoint(apiVersionKey) {
        if (apiVersionKey && this.endpointsList.has(apiVersionKey)) {
            return this.endpointsList.get(apiVersionKey) || '';
        }
        const defaultEndpoint = this.endpointsList.values().next().value;
        if (defaultEndpoint) {
            return defaultEndpoint;
        }
        throw new Error('missing endpoint, please provide one.');
    }
}

class BusinessUnitService extends AcdBaseService {
    constructor() {
        super();
        this.isBusinessUnitDataLoading = false;
        this.defaultGetBuEndpointV22Key = 'get-business-unit-v22';
        this.resetBusinessUnitService();
        // default api endpoint
        this.setApiEndpoint(this.defaultGetBuEndpointV22Key, 'v22.0');
    }
    setApiEndpoint(endpointKey, apiVersion) {
        return super.setApiEndpoint(BusinessUnitService.BUSINESS_UNIT_ENDPOINT_TEMPLATE, endpointKey, apiVersion);
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new BusinessUnitService();
        }
        return this._instance;
    }
    resetDeferredState() {
        super.resetDeferredState();
        this.isBusinessUnitDataLoading = false;
    }
    static initializeBusinessUnitModel(organizationInfo, apiVersion) {
        BusinessUnitModel.instance.resetModelState();
        const emptyModel = BusinessUnitModel.instance.getModelState();
        BusinessUnitModel.instance.setModelState(Object.assign(Object.assign({}, emptyModel), organizationInfo));
        if (apiVersion) {
            BusinessUnitModel.instance.apiVersion = apiVersion;
        }
    }
    getBusinessUnitDetailsFromApi(apiVersionKey) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.deferredLoadModel.isPending()) {
                this.resetDeferredState();
            }
            try {
                this.tenantUrls = yield TenantCrossDomainParamsService.instance.getTenantBaseUrl();
                if (this.tenantUrls && this.tenantUrls.incontactApiBaseUrl) {
                    const currentEndpoint = this.getApiEndpoint(apiVersionKey);
                    const response = yield HttpUtils.apiGet(currentEndpoint, {
                        isAcdCall: true,
                        overridePrefixValue: this.tenantUrls.incontactApiBaseUrl
                    }, true);
                    if (response.businessUnits) {
                        const bu = response.businessUnits;
                        if (bu && bu.length > 0) {
                            BusinessUnitService.initializeBusinessUnitModel(bu[0], apiVersionKey);
                            this.deferredLoadModel.resolve(BusinessUnitModel.instance.getModelState());
                            return this.deferredLoadModel.promise;
                        }
                    }
                    this.deferredLoadModel.reject(new Error('Unable to get business unit details, invalid response.'));
                    return this.deferredLoadModel.promise;
                }
                this.deferredLoadModel.reject(new Error('Undefined tenant urls, failed to retrieve business unit details.'));
            }
            catch (err) {
                console.log('get business unit details from cluster failed, bu extra configuration was not loaded. Error:');
                this.deferredLoadModel.reject(err);
            }
            return this.deferredLoadModel.promise;
        });
    }
    resetBusinessUnitService() {
        BusinessUnitModel.instance.resetModelState();
        this.resetDeferredState();
    }
    reloadBusinessUnitDetails(apiVersionKey) {
        if (!this.deferredLoadModel.isPending()) {
            this.resetDeferredState();
        }
        if (this.isBusinessUnitDataLoading) {
            return this.deferredLoadModel.promise;
        }
        this.isBusinessUnitDataLoading = true;
        return this.getBusinessUnitDetailsFromApi(apiVersionKey);
    }
    getBusinessUnitDetails(apiVersionKey) {
        if (apiVersionKey && BusinessUnitModel.instance.apiVersion !== apiVersionKey) {
            BusinessUnitModel.instance.resetModelState();
        }
        if (BusinessUnitModel.instance.isInitialized) {
            return Promise.resolve(BusinessUnitModel.instance.getModelState());
        }
        return this.reloadBusinessUnitDetails(apiVersionKey);
    }
}
BusinessUnitService.BUSINESS_UNIT_ENDPOINT_TEMPLATE = '/IncontactAPI/services/{version}/business-unit';

class PresenceSyncAdapterService {
    constructor() {
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new PresenceSyncAdapterService();
        }
        return this._instance;
    }
    getPresenceSyncUrl(item, area, env) {
        var _a;
        let presenceSyncUrl = (_a = item === null || item === void 0 ? void 0 : item.url) !== null && _a !== void 0 ? _a : '';
        if (env) {
            if (env === 'perf' && item.urlMapping) {
                presenceSyncUrl = item.urlMapping[area === 'icpune' ? area : env];
            }
            else {
                presenceSyncUrl = presenceSyncUrl === null || presenceSyncUrl === void 0 ? void 0 : presenceSyncUrl.replace('%env%', '.' + env).replace('%areaId%', '');
            }
        }
        else if (area && item.urlMapping && area in item.urlMapping) {
            //For those regions whose mapping is present in web app navigation data.
            presenceSyncUrl = item.urlMapping[area];
        }
        // for those areas whose mapping is not present in web app navigation data
        else {
            presenceSyncUrl = presenceSyncUrl === null || presenceSyncUrl === void 0 ? void 0 : presenceSyncUrl.replace('%env%', '').replace('%areaId%', '-' + area);
        }
        return presenceSyncUrl;
    }
}
PresenceSyncAdapterService.ENVIRONMENTS = ['dev', 'test', 'staging', 'perf'];

class MaxLaunchService {
    constructor() {
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new MaxLaunchService();
        }
        return this._instance;
    }
    intersectResponseWithEnvironment(response) {
        return response.filter(value => MaxLaunchService.ENVIRONMENTS.includes(value));
    }
    getCloudFrontMaxUrlGA(tenantConfigDiscoveryApi) {
        const maxURLTemplate = 'https://max.%domain%/index.html';
        const defaultDomain = 'dev.niceincontact.com';
        let maxURLGA = '';
        const domain = tenantConfigDiscoveryApi ? tenantConfigDiscoveryApi.domain : defaultDomain;
        maxURLGA = maxURLTemplate.replace('%domain%', domain);
        return maxURLGA;
    }
    getCloudFrontMaxUrl(envUrl) {
        let maxURL = '';
        let env;
        if (typeof envUrl !== 'undefined' && envUrl.length !== 0) {
            const maxURLTemplate = 'https://max.%env%.niceincontact.com/index.html';
            const res = envUrl.split(/[:.,\/ -]/);
            env = this.intersectResponseWithEnvironment(res);
            if (typeof env !== 'undefined' && env.length === 1) {
                maxURL = maxURLTemplate.replace('%env%', env);
            }
            else {
                maxURL = maxURLTemplate.replace('%env%.', '');
            }
        }
        return maxURL;
    }
}
MaxLaunchService.ENVIRONMENTS = ['dev', 'test', 'staging', 'perf'];

class AppLauncherService {
    constructor() {
        this.openMaxToBrowserTab = false;
        this.cxaOnBrowserToggleEnabled = false;
        this.updatedModuleSubject = new Subject();
        this.updatedModuleEvent = this.updatedModuleSubject.asObservable();
        this.getCurrentEnvAndArea = (envUrl) => {
            const res = envUrl.split(/[:.,\/ -]/);
            const env = this.intersectResponseWithEnvironment(res);
            const area = res[3];
            return { env, area };
        };
        this.addLaunchDetailsToModuleOrLinkWithErrorHandling = ((item, globalDetails, isModule = false) => {
            try {
                item = this.addLaunchDetailsToModuleOrLink(item, globalDetails, isModule);
            }
            catch (reason) {
                console.error('Error calling addLaunchDetailsToModuleOrLink:', item, reason);
            }
            return item;
        });
        this.addLaunchDetailsToModuleOrLink = ((item, globalDetails, isModule = false) => {
            const launcherId = item.launcherId || item.id;
            const { env, area } = this.getCurrentEnvAndArea(globalDetails.baseUrls.niceBaseUrl);
            const launchHandlers = {
                'inview': this.handleInview,
                'supervisor': this.handleSupervisor,
                'max': this.handleMax,
                'expert': this.handleExpert,
                'partnerhub': this.handlePartnerHub,
                'npxview': this.handleNpxView,
                'digital': this.handleDigital,
                'botbuilder': this.handleBotBuilder,
                'adapter': this.handleAdapter,
                'cxOneAttendant': this.handleCxOneAttendant,
                'webStudio': this.handleWebStudio,
                'integrations': this.handleIntegrations,
                'automationstudio': this.handleAutomationStudio,
                'cxa': this.handleCxa,
                'xsight_ai': this.handleXsightAi,
                'smartreachadmin': this.handleSmartReach,
                'smartreachagent': this.handleSmartReach
            };
            if (launchHandlers[launcherId]) {
                launchHandlers[launcherId].call(this, item, globalDetails, env, area, isModule);
            }
            return item;
        });
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new AppLauncherService();
        }
        return this._instance;
    }
    getWindowObject() {
        return window;
    }
    intersectResponseWithEnvironment(response) {
        return response.filter(value => AppLauncherService.ENVIRONMENTS.includes(value));
    }
    getCurrentEnvUrl(env, templateUrl) {
        let currentEnvurl = '';
        if (typeof env !== 'undefined' && env.length === 1) {
            currentEnvurl = templateUrl.replace('%env%', env);
        }
        else {
            currentEnvurl = templateUrl.replace('%env%.', '');
        }
        return currentEnvurl;
    }
    getCXoneExpertLandingPageUrl(envUrl) {
        let envUrlDomain = 'mindtouch.us';
        let url = 'https://sites.%envUrlDomain%';
        let env;
        if (typeof envUrl !== 'undefined' && envUrl.length !== 0) {
            const res = envUrl.split(/[:.,\/ -]/);
            env = this.intersectResponseWithEnvironment(res);
            if (typeof env !== 'undefined'
                && env.length === 1) {
                if (env[0] === 'dev' || env[0] === 'test') {
                    envUrlDomain = 'alpha.mindtouch.mx';
                }
            }
            url = url.replace('%envUrlDomain%', envUrlDomain);
        }
        return url;
    }
    getPartnerHubUrl(envUrl) {
        let partnerhubURL = '';
        let env;
        if (typeof envUrl !== 'undefined' && envUrl.length !== 0) {
            const partnerHubURLTemplate = 'https://partners-na1.%env%.niceincontact.com/';
            const res = envUrl.split(/[:.,\/ -]/);
            env = this.intersectResponseWithEnvironment(res);
            partnerhubURL = this.getCurrentEnvUrl(env, partnerHubURLTemplate);
        }
        return partnerhubURL;
    }
    getDigitalEngagementUrl(envUrl, item) {
        let digitalUrl = '';
        let redirectUrl = '';
        if (typeof envUrl !== 'undefined' && envUrl.length !== 0 && item !== undefined) {
            const digitalDomain = item[DfoUtils.extractUrlMappingKey(envUrl)];
            digitalUrl = digitalDomain + '/system/auth/jwt-login?redirectUrl=';
            redirectUrl = encodeURIComponent(digitalDomain + '/settings');
        }
        return digitalUrl + redirectUrl;
    }
    getBotBuilderUrl(envUrl, item) {
        let botBuilderUrl = '';
        if (typeof envUrl !== 'undefined' && envUrl.length !== 0 && item !== undefined) {
            const botBuilderDomain = item[DfoUtils.extractUrlMappingKey(envUrl)];
            botBuilderUrl = botBuilderDomain + '/sso/jwt-login';
        }
        return botBuilderUrl;
    }
    getWebStudioUrl(envUrl) {
        let webStudioURL = '';
        if (typeof envUrl !== 'undefined' && envUrl.length !== 0) {
            const webStudioURLTemplate = 'https://studio.%env%.niceincontact.com?version=latest';
            const res = envUrl.split(/[:.,\/ -]/);
            const env = this.intersectResponseWithEnvironment(res);
            webStudioURL = this.getCurrentEnvUrl(env, webStudioURLTemplate);
        }
        return webStudioURL;
    }
    getAiAdminIntegrationsUrl(urlMapping, env, area) {
        let aiAdminIntegrationsUrl = '';
        if (urlMapping && Object.keys(urlMapping).length > 0) {
            aiAdminIntegrationsUrl = env !== 'undefined' && env.length === 1 ? urlMapping[env[0]] : urlMapping[area];
        }
        else {
            console.error('Error getting AiAdmin URL', 'url mapping is null, empty or undefined');
        }
        return aiAdminIntegrationsUrl;
    }
    getCxoneAgentUrl(tenantConfigDiscoveryApi, urlTemplate) {
        const cxaURLTemplate = urlTemplate;
        return cxaURLTemplate.replace('%domain%', tenantConfigDiscoveryApi.globaldomain_v1);
    }
    getXSightAIPortalUrl(item, envUrl) {
        let xsightPortalUrl = '';
        const areaId = ConfigurationService.instance.get('areaIdentifier');
        const res = envUrl.split(/[:.,\/ -]/);
        const env = this.intersectResponseWithEnvironment(res);
        if (typeof item.urlMapping !== 'undefined' && typeof item.urlMapping[areaId] !== 'undefined') {
            const temp_xsightdomain = item.urlMapping[areaId];
            if (typeof env !== 'undefined' && env.length === 1) {
                xsightPortalUrl = temp_xsightdomain.replace('%env%', env);
            }
            else {
                xsightPortalUrl = temp_xsightdomain.replace('%env%.', '');
            }
        }
        return xsightPortalUrl;
    }
    getSmartReachUrl(item, globalDetails) {
        var _a, _b, _c, _d;
        let url = '';
        const smartReachTemplateURL = item.url;
        if (globalDetails.smartReachFT) {
            const srLiecense = Organization.instance.licenses.find(x => x.applicationId === 'SMARTREACH');
            if (smartReachTemplateURL && ((_a = srLiecense === null || srLiecense === void 0 ? void 0 : srLiecense.settings) === null || _a === void 0 ? void 0 : _a.smartReachBaseUrl) && ((_b = srLiecense === null || srLiecense === void 0 ? void 0 : srLiecense.settings) === null || _b === void 0 ? void 0 : _b.smartReachClientCode)) {
                url = smartReachTemplateURL.replace('%baseUrl%', (_c = srLiecense === null || srLiecense === void 0 ? void 0 : srLiecense.settings) === null || _c === void 0 ? void 0 : _c.smartReachBaseUrl)
                    .replace('%clientCode%', (_d = srLiecense === null || srLiecense === void 0 ? void 0 : srLiecense.settings) === null || _d === void 0 ? void 0 : _d.smartReachClientCode);
            }
        }
        return url;
    }
    // TODO: This is a temporary solution CXAPP-25676 has been created to support custom callbacks
    getSmartReachPermission(item, globalDetails) {
        var _a;
        const attributeName = item.permission;
        let customAttributeValue = '';
        if (globalDetails.smartReachFT && attributeName && !!item.url) {
            const userDetails = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userDetails);
            const attribute = userDetails.customAttributes[attributeName];
            if (attribute && attribute.values && attribute.values[0]) {
                customAttributeValue = (_a = attribute.values[0].value) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase();
            }
        }
        return true.toString() === customAttributeValue ? 'default' : '';
    }
    initializeApps(modules, baseUrls, disableAppLauncherInit) {
        return __awaiter(this, void 0, void 0, function* () {
            const globalDetails = yield this.getGlobalDetails(baseUrls, disableAppLauncherInit);
            for (let module of modules) {
                if (module.type === ModuleType.LAUNCHER) {
                    module = this.addLaunchDetailsToModuleOrLinkWithErrorHandling(module, globalDetails, true);
                }
                if (module.linksList) {
                    this.handleLinksList(module.linksList, globalDetails);
                }
            }
        });
    }
    handleLinksList(linksList, globalDetails) {
        for (let link of linksList) {
            if (link.type === ModuleType.LAUNCHER) {
                link = this.addLaunchDetailsToModuleOrLinkWithErrorHandling(link, globalDetails);
            }
            if (link.subMenu) {
                for (let subMenuItem of link.subMenu) {
                    if (subMenuItem.type === ModuleType.LAUNCHER) {
                        subMenuItem = this.addLaunchDetailsToModuleOrLinkWithErrorHandling(subMenuItem, globalDetails);
                    }
                }
            }
        }
    }
    getGlobalDetails(baseUrls, disableAppLauncherInit) {
        return __awaiter(this, void 0, void 0, function* () {
            let maxCloudFT, partnerHubFT, fmSettingFT, webStudioFT, maxGAFT, xsightaiFT, tenantConfigDiscoveryApi, smartReachFT, attFacadeUrlFT;
            try {
                [maxCloudFT, partnerHubFT, fmSettingFT, webStudioFT, maxGAFT, xsightaiFT, tenantConfigDiscoveryApi, smartReachFT, attFacadeUrlFT] = (yield Promise.allSettled([
                    FeatureToggleService.instance.getFeatureToggle(NAV_FEATURE_TOGGLES.MAX_CLOUDFRONT_URL),
                    FeatureToggleService.instance.getFeatureToggle(NAV_FEATURE_TOGGLES.PARTNERHUB_URL),
                    FeatureToggleService.instance.getFeatureToggle(NAV_FEATURE_TOGGLES.FM_SETTINGS_FEATURE_TOGGLE),
                    FeatureToggleService.instance.getFeatureToggle(NAV_FEATURE_TOGGLES.WEB_STUDIO_FEATURE_TOGGLE),
                    FeatureToggleService.instance.getFeatureToggle(NAV_FEATURE_TOGGLES.MAX_GA_FEATURE_TOGGLE),
                    FeatureToggleService.instance.getFeatureToggle(NAV_FEATURE_TOGGLES.XSIGHT_AI_FEATURE_TOGGLE),
                    GlobalAuthService.instance.getTenantConfigDiscoveryApi(),
                    FeatureToggleService.instance.getFeatureToggle(NAV_FEATURE_TOGGLES.SMARTREACH_FEATURE_TOGGLE),
                    FeatureToggleService.instance.getFeatureToggle(NAV_FEATURE_TOGGLES.ATT_SWITCH_USE_FACADE_URL_API_TOGGLE)
                ]));
            }
            catch (reason) {
                console.error('Error loading globalDetails:', reason);
            }
            const globalDetails = {
                baseUrls: baseUrls,
                disableAppLauncherInit: disableAppLauncherInit,
                maxCloudFT: (maxCloudFT === null || maxCloudFT === void 0 ? void 0 : maxCloudFT.value) || false,
                partnerHubFT: (partnerHubFT === null || partnerHubFT === void 0 ? void 0 : partnerHubFT.value) || false,
                fmSettingFT: (fmSettingFT === null || fmSettingFT === void 0 ? void 0 : fmSettingFT.value) || false,
                webStudioFT: (webStudioFT === null || webStudioFT === void 0 ? void 0 : webStudioFT.value) || false,
                maxGAFT: (maxGAFT === null || maxGAFT === void 0 ? void 0 : maxGAFT.value) || false,
                xsightaiFT: (xsightaiFT === null || xsightaiFT === void 0 ? void 0 : xsightaiFT.value) || false,
                tenantConfigDiscoveryApi: (tenantConfigDiscoveryApi === null || tenantConfigDiscoveryApi === void 0 ? void 0 : tenantConfigDiscoveryApi.value) || '',
                smartReachFT: (smartReachFT === null || smartReachFT === void 0 ? void 0 : smartReachFT.value) || false,
                attFacadeUrlFT: (attFacadeUrlFT === null || attFacadeUrlFT === void 0 ? void 0 : attFacadeUrlFT.value) || false
            };
            return globalDetails;
        });
    }
    handleInview(item) {
        item.url = 'https://inviewsso.clearviewportal.com';
    }
    handleSupervisor(item, globalDetails) {
        item.url = globalDetails.baseUrls.incontactBaseUrl + '/inContact/Supervisor/index.html';
    }
    handleMax(item, globalDetails) {
        const endpointVersionKey = 'get-business-unit-v24';
        BusinessUnitService.instance.setApiEndpoint(endpointVersionKey, 'v24.0');
        BusinessUnitService.instance.getBusinessUnitDetails(endpointVersionKey).then((businessUnitDetails) => {
            this.openMaxToBrowserTab = businessUnitDetails.openMaxToBrowserTab ? businessUnitDetails.openMaxToBrowserTab : false;
        }).catch(() => {
            console.log('Business Unit details was not loaded, using default values for max.');
        });
        item.url = globalDetails.baseUrls.incontactBaseUrl + '/inContact/MAX/index.html';
        if (globalDetails.maxCloudFT) {
            if (globalDetails.maxGAFT && globalDetails.tenantConfigDiscoveryApi) {
                const maxUrlGA = MaxLaunchService.instance.getCloudFrontMaxUrlGA(globalDetails.tenantConfigDiscoveryApi);
                item.url = maxUrlGA;
            }
            else {
                const cloudFrontMaxUrl = MaxLaunchService.instance.getCloudFrontMaxUrl(globalDetails.baseUrls.niceBaseUrl);
                item.url = cloudFrontMaxUrl;
            }
        }
    }
    handleExpert(item, globalDetails) {
        item.url = 'https://mindtouch.com';
        item.url = this.getCXoneExpertLandingPageUrl(globalDetails.baseUrls.niceBaseUrl);
    }
    handlePartnerHub(item, globalDetails) {
        if (globalDetails.partnerHubFT) {
            const partnerHubUrl = this.getPartnerHubUrl(globalDetails.baseUrls.niceBaseUrl);
            item.url = partnerHubUrl;
        }
    }
    handleNpxView(item, globalDetails) {
        var _a, _b;
        const fmLiecense = Organization.instance.licenses.find(x => x.applicationId === 'SATMETRIX');
        if (globalDetails.fmSettingFT && ((_a = fmLiecense === null || fmLiecense === void 0 ? void 0 : fmLiecense.settings) === null || _a === void 0 ? void 0 : _a.fmBaseURL)) {
            item.url = ((_b = fmLiecense === null || fmLiecense === void 0 ? void 0 : fmLiecense.settings) === null || _b === void 0 ? void 0 : _b.fmBaseURL) + '/app/core/main/login/cxoneNpxAuth.html';
        }
        else {
            item.url = ConfigurationService.instance.get('npxBaseUrl') + '/app/core/main/login/cxoneNpxAuth.html';
        }
    }
    handleDigital(item, globalDetails) {
        const urlMapping = item.urlMapping;
        item.url = this.getDigitalEngagementUrl(globalDetails.baseUrls.niceBaseUrl, urlMapping);
    }
    handleBotBuilder(item, globalDetails) {
        const urlMapping = item.urlMapping;
        item.url = this.getBotBuilderUrl(globalDetails.baseUrls.niceBaseUrl, urlMapping);
    }
    handleAdapter(item, _globalDetails, env, area) {
        item.url = PresenceSyncAdapterService.instance.getPresenceSyncUrl(item, area, env[0]);
    }
    handleCxOneAttendant(item, globalDetails, env, area, isModule) {
        if (globalDetails.disableAppLauncherInit) {
            return;
        }
        const cxoneAttendantAPIUrl = CxoneAttendantService.instance.getCXoneAttendantUrl(env, area, globalDetails.attFacadeUrlFT, item.urlMapping, true);
        const cxoneAttendantUIUrl = CxoneAttendantService.instance.getCXoneAttendantUrl(env, area, globalDetails.attFacadeUrlFT, item.urlMapping, false);
        const CXASessionStorageKeyName = CxoneAttendantService.instance.getNameCXASessionStorageKey();
        const cxOneAttendantSessionEnabled = sessionStorage.getItem(CXASessionStorageKeyName);
        if (cxOneAttendantSessionEnabled === null || typeof cxOneAttendantSessionEnabled === 'undefined') {
            CxoneAttendantService.instance.userHasAccessToApp(cxoneAttendantAPIUrl, globalDetails.attFacadeUrlFT)
                .pipe(catchError$1(() => {
                return of(false);
            }))
                .subscribe(hasCxoneAttendant => {
                if (hasCxoneAttendant) {
                    item.permission = 'default';
                    item.url = cxoneAttendantUIUrl;
                    if (isModule) {
                        this.updatedModuleSubject.next(item);
                    }
                }
            });
        }
        if ((cxOneAttendantSessionEnabled && cxOneAttendantSessionEnabled === 'true')) {
            item.permission = 'default';
            item.url = cxoneAttendantUIUrl;
        }
    }
    handleWebStudio(item, globalDetails) {
        if (globalDetails.webStudioFT) {
            item.url = this.getWebStudioUrl(globalDetails.baseUrls.niceBaseUrl);
        }
    }
    handleIntegrations(item, env, area) {
        item.url = this.getAiAdminIntegrationsUrl(item.urlMapping, env, area) || item.url;
    }
    handleAutomationStudio(item, globalDetails) {
        item.url = globalDetails.baseUrls.niceBaseUrl + '/as/';
    }
    handleCxa(item, globalDetails) {
        const urlTemplate = item.url || 'https://cxagent.%domain%?src=UH';
        const endpointVersionKey = 'get-business-unit-v24';
        BusinessUnitService.instance.setApiEndpoint(endpointVersionKey, 'v24.0');
        BusinessUnitService.instance.getBusinessUnitDetails(endpointVersionKey).then((businessUnitDetails) => {
            this.cxaOnBrowserToggleEnabled = businessUnitDetails.openMaxToBrowserTab ? businessUnitDetails.openMaxToBrowserTab : false;
        }).catch(() => {
            console.log('Business Unit details was not loaded, using default values for cxa.');
        });
        if (globalDetails === null || globalDetails === void 0 ? void 0 : globalDetails.tenantConfigDiscoveryApi) {
            const cxaUrl = this.getCxoneAgentUrl(globalDetails.tenantConfigDiscoveryApi, urlTemplate);
            item.url = cxaUrl;
        }
    }
    handleXsightAi(item, globalDetails) {
        item.url = this.getXSightAIUrl(item, globalDetails);
    }
    handleSmartReach(item, globalDetails) {
        item.url = this.getSmartReachUrl(item, globalDetails);
        item.permission = this.getSmartReachPermission(item, globalDetails);
    }
    getXSightAIUrl(item, globalDetails) {
        let url = '';
        if (globalDetails.xsightaiFT) {
            url = this.getXSightAIPortalUrl(item, globalDetails.baseUrls.niceBaseUrl);
        }
        return url;
    }
    onLoad(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if ((event.origin.indexOf('nice-incontact.com') !== -1) ||
                (event.origin.indexOf('qa9app.pune.nice.com') !== -1) ||
                (event.origin.indexOf('satmetrix.com') !== -1) ||
                (event.origin.indexOf('ucn.net') !== -1) ||
                (event.origin.indexOf('visual.force.com') !== -1) ||
                (event.origin.indexOf('visualforce.com') !== -1) ||
                (event.origin.indexOf('inviewsso.clearviewportal.com') !== -1) ||
                (event.origin.indexOf('cxagent.nicecxone') !== -1) ||
                (event.origin.indexOf('livevox.net') !== -1) ||
                (event.origin.indexOf('livevox.com') !== -1) ||
                (event.source.parent === this.getWindowObject() || event.source.opener === this.getWindowObject())) {
                if (event.data && event.data.messageType && event.data.messageType === 'Loaded') {
                    const issuers = ['EXPERT', 'MAX', 'PARTNERHUB', 'SUPERVISOR', 'INVIEW', 'SATMETRIX', 'PSA', 'BE', 'AA', 'STX', 'INTEGRATIONS', 'AUTOMATIONSTUDIO', 'CXA', 'BOTBUILDER'];
                    if (event.data.issuer && issuers.includes(event.data.issuer)) {
                        const response = yield TenantCrossDomainParamsService.instance.getTenantBaseUrl();
                        const token = LocalStorageUtils.getItem('userToken');
                        const eventObj = {
                            messageType: 'Token',
                            token: token,
                            issuer: 'CXOne',
                            central: '',
                            url: {
                                authBaseUrl: TenantCrossDomainParamsService.instance.getAuthHostForArea(),
                                niceBaseUrl: response.niceBaseUrl,
                                incontactBaseUrl: response.incontactBaseUrl
                            }
                        };
                        if (event.data.issuer === 'AA') {
                            const userDetails = LocalStorageUtils.getItem('userDetails');
                            const userTimeZone = userDetails.timeZone;
                            eventObj.userTimeZone = userTimeZone;
                        }
                        this.maxWindow.postMessage(eventObj, '*');
                    }
                }
            }
        });
    }
    launchApp(appModuleOrPage) {
        const url = appModuleOrPage.url;
        const launcherId = appModuleOrPage.launcherId || appModuleOrPage.id;
        if (url) {
            if (launcherId === 'adapter') {
                this.maxWindow = WindowService.instance.openWindow(url, '_blank', `height=${window.screen.availHeight}, width=${window.screen.availWidth}`);
            }
            else if (launcherId === 'max' && this.openMaxToBrowserTab) {
                this.maxWindow = WindowService.instance.openWindow(url, '_blank', '', true);
            }
            else if (launcherId === 'cxa' && this.cxaOnBrowserToggleEnabled) {
                this.maxWindow = WindowService.instance.openWindow(url, '_blank', '', true);
            }
            else if (launcherId === 'integrations') {
                this.maxWindow = WindowService.instance.openWindow(url, '_blank', `height=${window.screen.availHeight}, width=${window.screen.availWidth}`);
            }
            else if (launcherId === 'automationstudio') {
                this.maxWindow = WindowService.instance.openWindow(url, '_blank', '', true);
            }
            else if (launcherId === 'xsight_ai') {
                this.maxWindow = WindowService.instance.openWindow(url, '_blank', '', true);
            }
            else {
                // launch a new tab if appWindow is not specified or if height or width are invalid
                let launchString = '';
                if (appModuleOrPage.appWindow) {
                    if (appModuleOrPage.appWindow.height === 0 && appModuleOrPage.appWindow.width === 0) {
                        // if height and width are 0, launch a new window full screen
                        launchString = `height=${window.screen.availHeight}, width=${window.screen.availWidth}`;
                    }
                    else if (appModuleOrPage.appWindow.height > 0 && appModuleOrPage.appWindow.width > 0) {
                        // if height and width are specified and positive, launch a new window
                        launchString = `height=${appModuleOrPage.appWindow.height}, width=${appModuleOrPage.appWindow.width}`;
                    }
                }
                this.maxWindow = WindowService.instance.openWindow(url, '_blank', launchString, true);
            }
            this.getWindowObject().addEventListener('message', this.onLoad.bind(this));
        }
    }
}
AppLauncherService.ENVIRONMENTS = ['dev', 'test', 'staging', 'perf'];

class FilterModulesService {
    constructor() { }
    static get instance() {
        if (!this._instance) {
            this._instance = new FilterModulesService();
        }
        return this._instance;
    }
    isLinkFeatureToggled(link, toggledFeatures) {
        return (link.featureToggle && !link.HideonFeatureEnabled && (!toggledFeatures.includes(link.featureToggle))) ||
            (link.HideonFeatureEnabled && link.featureToggle && (toggledFeatures.includes(link.featureToggle)));
    }
    hasAccessToModule(moduleData, toggledFeatures) {
        let embeddedClientCondition = true;
        const hideOnFeatureEnabled = moduleData.hideOnFeatureEnabled !== undefined && moduleData.hideOnFeatureEnabled;
        // user should have access to a module if the feature toggle settings are in any 1 of these 3 states:
        // A: the module has no feature toggle assigned to it
        // B: the module has a feature toggle, that feature is enabled, and hideOnFeatureEnabled is false
        // C: the module has a feature toggle, that feature is disabled, and hideOnFeatureEnabled is true
        const moduleAccessByFT = !moduleData.featureToggle || (toggledFeatures.includes(moduleData.featureToggle) && !hideOnFeatureEnabled) || (!toggledFeatures.includes(moduleData.featureToggle) && hideOnFeatureEnabled);
        if (moduleAccessByFT) {
            const embeddedSupport = moduleData.embeddedClientSupport; // L2  embedded client flag
            const embeddedMode = ScreenUtils.instance.getLayoutSetting().isCustomLayout; //embedded client mode
            if ((embeddedSupport && !embeddedMode) || (!embeddedSupport && embeddedMode)) {
                embeddedClientCondition = false;
            }
        }
        return moduleAccessByFT && embeddedClientCondition;
    }
    filterByFeatureToggle(givenModules) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const toggledFeatures = yield FeatureToggleService.instance.loadFeatures(false);
                let moduleData, link;
                const linkSuffix = ScreenUtils.instance.getLinkSuffix();
                let subMenu, subLink;
                const filteredModules = [];
                givenModules.forEach(module => {
                    moduleData = CoreUtils.cloneDeep(module);
                    if (this.hasAccessToModule(moduleData, toggledFeatures)) {
                        if (moduleData.linksList) {
                            for (let i = 0; i < moduleData.linksList.length; i += 1) {
                                link = moduleData.linksList[i];
                                if (link.mfeId && moduleData.microFrontends) {
                                    const mfeId = link.mfeId;
                                    const mfe = moduleData.microFrontends.find(el => el.id === mfeId);
                                    if (mfe && mfe.urlPrefix && link.url && !link.url.startsWith(mfe.urlPrefix)) {
                                        link.url = mfe.urlPrefix + link.url;
                                    }
                                }
                                if (linkSuffix !== '') {
                                    link.url = link.url + linkSuffix;
                                }
                                if (this.isLinkFeatureToggled(link, toggledFeatures)) {
                                    moduleData.linksList.splice(moduleData.linksList.indexOf(link), 1);
                                    i -= 1;
                                }
                                else {
                                    subMenu = link.subMenu;
                                    if (subMenu && subMenu.length) {
                                        for (let j = 0; j < subMenu.length; j += 1) {
                                            subLink = subMenu[j];
                                            if (subLink.mfeId && moduleData.microFrontends) {
                                                const mfeId = subLink.mfeId;
                                                const mfe = moduleData.microFrontends.find(el => el.id === mfeId);
                                                if (mfe && mfe.urlPrefix && subLink.url && !subLink.url.startsWith(mfe.urlPrefix)) {
                                                    subLink.url = mfe.urlPrefix + subLink.url;
                                                }
                                            }
                                            if ((!subLink.HideonFeatureEnabled && (subLink.featureToggle && (!toggledFeatures.includes(subLink.featureToggle)))) ||
                                                (subLink.HideonFeatureEnabled && (subLink.featureToggle && toggledFeatures.includes(subLink.featureToggle)))) {
                                                subMenu.splice(subMenu.indexOf(subLink), 1);
                                                j -= 1;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        filteredModules.push(moduleData);
                    }
                });
                return filteredModules;
            }
            catch (error) {
                console.error('error while loading all toggled features inside FilterModulesService' + error);
                throw error;
            }
        });
    }
    /**
     * filtering menu links (L4) by permission*/
    filterPermissionByL4Links(L4SubLinks) {
        if (L4SubLinks === undefined || L4SubLinks.length === 0) {
            return L4SubLinks;
        }
        for (let i = 0; i < L4SubLinks.length; i += 1) {
            if (!PermissionService.instance.allowAccess(L4SubLinks[i].permission)) {
                //if a L4 sublink is not permitted - it removes the sublink from the list
                L4SubLinks.splice(i, 1);
                i -= 1;
            }
        }
        return L4SubLinks;
    }
    /**
     * filtering menu links (L3) by permission*/
    filterPermissionByL3Links(L3Links) {
        if (L3Links === undefined || L3Links.length === 0) {
            return L3Links;
        }
        for (let i = 0; i < L3Links.length; i += 1) {
            /*checking if L4 sublinks exist in L3 link*/
            if (L3Links[i].subMenu !== undefined) {
                /*filtering by permission L4 menus*/
                const filteredL4 = this.filterPermissionByL4Links(L3Links[i].subMenu);
                if (filteredL4 && filteredL4.length > 0) {
                    L3Links[i].subMenu = filteredL4;
                }
                else {
                    /*if after filtering L4 sublinks no longer exist in a L3 link - it removes the L3 link from the list*/
                    L3Links.splice(i, 1);
                    i -= 1;
                }
            }
            /*if L3 item is not permitted - it removes the L3 item from the list*/
            else if (!PermissionService.instance.allowAccess(L3Links[i].permission)) {
                L3Links.splice(i, 1);
                i -= 1;
            }
        }
        return L3Links;
    }
    /**
     * filtering menu (L2)
     */
    filterNavigationMenuByPermission(L2Modules) {
        if (L2Modules === undefined || L2Modules.length === 0) {
            return L2Modules;
        }
        /*checking each L2 module*/
        for (let i = 0; i < L2Modules.length; i += 1) {
            if (L2Modules[i].permissions) {
                if (!PermissionService.instance.allowAccess(L2Modules[i].permissions)) {
                    L2Modules.splice(i, 1);
                    i -= 1;
                    continue;
                }
            }
            if (L2Modules[i].linksList !== undefined) {
                const filteredL3 = this.filterPermissionByL3Links(L2Modules[i].linksList);
                if (filteredL3 && filteredL3.length > 0) {
                    L2Modules[i].linksList = filteredL3;
                }
                else {
                    /*if after filtering L3 links no longer exist in a L2 module - it removes the L2Module from the list*/
                    L2Modules.splice(i, 1);
                    i -= 1;
                }
            }
        }
        return L2Modules;
    }
    filterAppLauncherModulesByPermission(L2Modules) {
        return L2Modules.filter(module => (!module.type || (module.type === ModuleType.LAUNCHER && PermissionService.instance.allowAccess(module.permission)) ||
            (module.type === ModuleType.INTERNAL && PermissionService.instance.allowAccess(module.permission))));
    }
    filterNavigationMenuByModuleConfig(modules) {
        return __awaiter(this, void 0, void 0, function* () {
            let filteredModules = modules;
            try {
                const licenses = yield LicenseService.instance.getLicensesForTenant();
                modules.forEach((module) => {
                    const moduleConfigurationNeeded = CXOneConstants.modulesConfigurationMapToFilterModules[module.name];
                    if (moduleConfigurationNeeded) {
                        const moduleLicense = licenses.licenses.filter((license) => license.applicationId === moduleConfigurationNeeded.applicationId);
                        if (moduleLicense.length > 0 && moduleLicense[0].featureIds.sort().toString() === moduleConfigurationNeeded.featureIds.sort().toString()) {
                            filteredModules = modules.filter((moduleObj) => !moduleConfigurationNeeded.removeModuleWithName.includes(moduleObj.name));
                        }
                    }
                });
                return filteredModules;
            }
            catch (error) {
                console.error(error);
                modules.forEach((value) => {
                    const moduleConfigurationNeeded = CXOneConstants.modulesConfigurationMapToFilterModules[value.name];
                    if (moduleConfigurationNeeded && moduleConfigurationNeeded.defaultModuleForLicense === 'true') {
                        filteredModules = modules.filter((module) => !moduleConfigurationNeeded.removeModuleWithName.includes(module.name));
                    }
                });
                return filteredModules;
            }
        });
    }
    filterNavigationMenuByFeature(modules) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let needToFilter = true;
                const excludeApp = URLUtils.isExcludedApp(window.location.href, ['sso']);
                let includesModuleToFilter = false;
                modules.forEach(value => {
                    const moduleConfigurationNeeded = CXOneConstants.modulesConfigurationMapToFilterModules[value.name];
                    if (moduleConfigurationNeeded) {
                        includesModuleToFilter = true;
                    }
                });
                needToFilter = (includesModuleToFilter && !excludeApp);
                if (needToFilter) {
                    return yield this.filterNavigationMenuByModuleConfig(modules);
                }
                else {
                    return modules;
                }
            }
            catch (error) {
                console.error(error);
                return yield this.filterNavigationMenuByModuleConfig(modules);
            }
        });
    }
    getAvailableModules(modules) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const filteredModulesByFeatureToggle = yield this.filterByFeatureToggle(modules);
                const filteredModulesByLicense = yield LicenseService.instance.filterApplicationsDataByLicense(filteredModulesByFeatureToggle);
                let filteredModules = this.filterAppLauncherModulesByPermission(filteredModulesByLicense);
                filteredModules = this.filterNavigationMenuByPermission(filteredModules);
                filteredModules = yield this.filterNavigationMenuByFeature(filteredModules);
                return filteredModules;
            }
            catch (error) {
                console.error('Failed to filter modules', error);
                throw error;
            }
        });
    }
}

const DEMO_MODULE = {
    id: 'demo',
    categoryId: 'general',
    translationKey: 'modules.demo',
    sortOrder: 0,
    name: 'demo',
    iconSVG: 'dashboard',
    iconSvg: 'icon-dashboard',
    iconName: 'icon-dashboards',
    color: '#00A7EA',
    type: ModuleType.NORMAL,
    helpLink: 'topics/user%20hub/welcome%20to%20admin.htm',
    absoluteHelpLinkUrl: false,
    license: [
        'wfm',
        'qm',
        'acd',
        'wfi',
        'recording',
        'automationstudio',
        'xsight_ai',
        'adapters'
    ],
    linksList: [
        {
            id: 'hello',
            name: 'niceNavigationUi.globalNavigation.sideBar.wfmModuleLinks.scheduler',
            appContext: '/cxoneSampleApp',
            baseUrl: 'nice',
            url: '/#/hello',
            iconSvg: 'icon-Icons_svg_schedule-manager',
            permission: 'skill:view',
            license: [
                'wfm'
            ],
            translationKey: ''
        },
        {
            id: 'mylinks',
            name: 'niceNavigationUi.globalNavigation.sideBar.wfmModuleLinks.scheduler',
            appContext: '/cxoneSampleApp',
            baseUrl: 'nice',
            // url: '/#/goodbye',
            iconSvg: 'icon-Icons_svg_schedule-manager',
            permission: 'skill:view',
            license: [
                'wfm'
            ],
            translationKey: '',
            subMenu: [{
                    id: 'link1',
                    name: 'niceNavigationUi.globalNavigation.sideBar.wfmModuleLinks.scheduler',
                    appContext: '/cxoneSampleApp',
                    baseUrl: 'nice',
                    url: '/#/link1',
                    iconSvg: 'icon-Icons_svg_schedule-manager',
                    permission: 'skill:view',
                    license: [
                        'wfm'
                    ],
                    translationKey: ''
                }, {
                    id: 'link2',
                    name: 'niceNavigationUi.globalNavigation.sideBar.wfmModuleLinks.scheduler',
                    appContext: '/cxoneSampleApp',
                    baseUrl: 'nice',
                    url: '/#/link2',
                    iconSvg: 'icon-Icons_svg_schedule-manager',
                    permission: 'skill:view',
                    license: [
                        'wfm'
                    ],
                    translationKey: ''
                }]
        },
        {
            id: 'helloagain',
            name: 'niceNavigationUi.globalNavigation.sideBar.wfmModuleLinks.scheduler',
            appContext: '/cxoneSampleApp',
            baseUrl: 'nice',
            url: '/#/helloagain',
            iconSvg: 'icon-Icons_svg_schedule-manager',
            permission: 'skill:view',
            license: [
                'wfm'
            ],
            translationKey: ''
        },
        {
            id: 'mylinks2',
            name: 'niceNavigationUi.globalNavigation.sideBar.wfmModuleLinks.scheduler',
            appContext: '/cxoneSampleApp',
            baseUrl: 'nice',
            // url: '/#/goodbye',
            iconSvg: 'icon-Icons_svg_schedule-manager',
            permission: 'skill:view',
            license: [
                'wfm'
            ],
            translationKey: '',
            subMenu: [{
                    id: 'link3',
                    name: 'niceNavigationUi.globalNavigation.sideBar.wfmModuleLinks.scheduler',
                    appContext: '/cxoneSampleApp',
                    baseUrl: 'nice',
                    url: '/#/link3',
                    iconSvg: 'icon-Icons_svg_schedule-manager',
                    permission: 'skill:view',
                    license: [
                        'wfm'
                    ],
                    translationKey: ''
                }, {
                    id: 'link4',
                    name: 'niceNavigationUi.globalNavigation.sideBar.wfmModuleLinks.scheduler',
                    appContext: '/cxoneSampleApp',
                    baseUrl: 'nice',
                    url: '/#/link4',
                    iconSvg: 'icon-Icons_svg_schedule-manager',
                    permission: 'skill:view',
                    license: [
                        'wfm'
                    ],
                    translationKey: ''
                }]
        },
        {
            id: 'goodbye',
            name: 'niceNavigationUi.globalNavigation.sideBar.wfmModuleLinks.scheduler',
            appContext: '/cxoneSampleApp',
            baseUrl: 'nice',
            url: '/#/goodbye',
            iconSvg: 'icon-Icons_svg_schedule-manager',
            permission: 'skill:view',
            license: [
                'wfm'
            ],
            translationKey: ''
        }
    ],
    appWindow: { width: 0, height: 0 }
};

class ModulesService {
    constructor() {
        this.allModules = [];
        this.demoMode = false;
        this.moduleChangeSubject = new Subject();
        this.moduleChangeEvent = this.moduleChangeSubject.asObservable();
        this.allModules = [];
        this.allCategories = [];
        this.filterModulesService = FilterModulesService.instance;
        this.appLauncherService = AppLauncherService.instance;
        this.setStaticBaseUrl(ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.StaticBaseUrl));
        if (this.staticBaseUrl === undefined) {
            this.setStaticBaseUrl(ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.ApiServerBaseUrl));
        }
        this.appLauncherService.updatedModuleEvent
            .pipe(distinctUntilChanged())
            .subscribe((updatedModule) => __awaiter(this, void 0, void 0, function* () {
            const moduleIndex = this.allModules.findIndex((module) => module.id === updatedModule.id);
            if (moduleIndex !== -1) {
                this.allModules[moduleIndex] = updatedModule;
                this.moduleChangeSubject.next(this.allModules);
            }
            else {
                this.allModules.push(updatedModule);
                this.allModules = yield this.filterModulesService.getAvailableModules(this.allModules);
                this.moduleChangeSubject.next(this.allModules);
            }
        }));
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new ModulesService();
        }
        return this._instance;
    }
    reset() {
        ModulesService._instance = new ModulesService();
    }
    setStaticBaseUrl(url) {
        this.staticBaseUrl = url;
    }
    /**
     * @deprecated Use setStaticBaseUrl() instead
     */
    setApiBaseUrl(url) {
        this.setStaticBaseUrl(url);
    }
    getAllModules() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.getAllModulesDeferred) {
                this.getAllModulesDeferred = new Deferred();
                this.allModules = yield this.getAllModulesAndLinks();
                this.getAllModulesDeferred.resolve(this.allModules);
            }
            return this.getAllModulesDeferred.promise;
        });
    }
    fetchAllModulesAndLinksJson() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.allModulesAndLinksJson) {
                return this.allModulesAndLinksJson;
            }
            if (!this.fetchAllModulesAndLinksDeferred) {
                this.fetchAllModulesAndLinksDeferred = new Deferred();
                this.allModulesAndLinksJson = yield HttpUtils.apiGet('/navigation_data/modules/allModulesAndLinks', { overridePrefixValue: this.staticBaseUrl + '/' });
                this.fetchAllModulesAndLinksDeferred.resolve(this.allModulesAndLinksJson);
            }
            return this.fetchAllModulesAndLinksDeferred.promise;
        });
    }
    getAllCategories() {
        return this.allCategories;
    }
    getPermissionsString(permissionsArr) {
        let str = '';
        permissionsArr.forEach(permission => str = str + permission + ' ');
        return str;
    }
    addPermissionsArrToArr(arrToCopy, arrToCopyTo) {
        arrToCopy.forEach(item => {
            if (arrToCopyTo.indexOf(item) === -1) {
                arrToCopyTo.push(item);
            }
        });
    }
    addPermissionsStringToArr(permissionsStr, permissionsArr) {
        if (permissionsStr === undefined || permissionsStr === null) {
            return;
        }
        else {
            const permissions = permissionsStr.split(' ');
            this.addPermissionsArrToArr(permissions, permissionsArr);
        }
    }
    // sets the module permission property and the link items permission properties in case they have sub items
    setModulePermissions(moduleData) {
        const permissions = [];
        const updatedModuleData = JSON.parse(JSON.stringify(moduleData));
        this.addPermissionsStringToArr(updatedModuleData.permission, permissions);
        if (updatedModuleData.linksList) {
            updatedModuleData.linksList.forEach((linkItem) => {
                if (linkItem.subMenu && linkItem.subMenu.length) {
                    const linkItemPermissions = [];
                    this.addPermissionsStringToArr(linkItem.permission, linkItemPermissions);
                    linkItem.subMenu.forEach((subMenuLinkItem) => this.addPermissionsStringToArr(subMenuLinkItem.permission, linkItemPermissions));
                    const linkItemPermissionsStr = this.getPermissionsString(linkItemPermissions);
                    if (linkItemPermissionsStr !== '') {
                        linkItem.permission = linkItemPermissionsStr;
                        this.addPermissionsArrToArr(linkItemPermissions, permissions);
                    }
                }
                else {
                    this.addPermissionsStringToArr(linkItem.permission, permissions);
                }
            });
        }
        const permissionsStr = this.getPermissionsString(permissions);
        if (permissionsStr !== '') {
            updatedModuleData.permission = permissionsStr;
        }
        return updatedModuleData;
    }
    setModuleLinks(moduleData, baseUrlsObj) {
        if (moduleData.linksList) {
            moduleData.linksList.forEach((linkItem) => {
                if (linkItem.subMenu) {
                    linkItem.subMenu.forEach((subMenuItem) => {
                        if (subMenuItem.appContext && subMenuItem.appContext.indexOf(baseUrlsObj[subMenuItem.baseUrl]) === -1) {
                            subMenuItem.appContext = baseUrlsObj[subMenuItem.baseUrl] + subMenuItem.appContext;
                        }
                    });
                }
                else if (linkItem.appContext && linkItem.appContext.indexOf(baseUrlsObj[linkItem.baseUrl]) === -1) {
                    linkItem.appContext = baseUrlsObj[linkItem.baseUrl] + linkItem.appContext;
                }
            });
        }
    }
    setDfoDomains(allModules) {
        const acdModule = allModules.find(x => x.id === 'acd');
        if (acdModule !== undefined) {
            DfoUtils.saveDfoDomainFormats(acdModule);
        }
        else {
            console.error('ACD Module not found for DfoUtils');
        }
    }
    getAllModulesAndLinks(disableAppLauncherInit) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.allModules && this.allModules.length !== 0) {
                this.setDfoDomains(this.allModules);
                return this.allModules;
            }
            else {
                const response = yield this.fetchAllModulesAndLinksJson();
                this.allCategories = response.categories;
                this.allModules = [...response.modules];
                if (response.apps) {
                    this.allModules = [...response.modules, ...response.apps];
                }
                else {
                    this.allModules = [...response.modules];
                }
                this.setDfoDomains(this.allModules);
                return yield this.initModulesData(disableAppLauncherInit);
            }
        });
    }
    setModuleObjects(baseUrls) {
        const baseUrlsObj = {
            incontact: baseUrls.incontactBaseUrl,
            nice: baseUrls.niceBaseUrl,
            analytics: baseUrls.analyticsBaseUrl,
            npx: ConfigurationService.instance.get('npxBaseUrl'),
            digitalEngagement: baseUrls.digitalEngagementBaseUrl
        };
        if (this.allModules) {
            for (let i = 0; i < this.allModules.length; i += 1) {
                this.setModuleLinks(this.allModules[i], baseUrlsObj);
                this.allModules[i] = this.setModulePermissions(this.allModules[i]);
            }
        }
    }
    initModulesData(disableAppLauncherInit) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const baseUrls = yield TenantCrossDomainParamsService.instance.getTenantBaseUrl();
                this.automationStudioUrl = baseUrls.niceBaseUrl + '/as/';
                yield this.appLauncherService.initializeApps(this.allModules, baseUrls, disableAppLauncherInit);
                this.setModuleObjects(baseUrls);
                // Uncomment to get all
                if (this.demoMode) {
                    this.allModules.push(DEMO_MODULE);
                    return CoreUtils.cloneDeep(this.allModules);
                }
                return yield this.filterModulesService.getAvailableModules(this.allModules);
            }
            catch (error) {
                console.error('Failed to initialize modules data', error);
                throw error;
            }
        });
    }
    hasLinkItemPermission(linkItem, userPermissions) {
        if (linkItem.permission === null || linkItem.permission === undefined) {
            return false;
        }
        if (userPermissions.includes('all') || linkItem.permission === '') {
            return true;
        }
        const linkItemPermissions = linkItem.permission.split(' ');
        let iLinkPermission;
        for (iLinkPermission = 0; iLinkPermission < linkItemPermissions.length; iLinkPermission = iLinkPermission + 1) {
            if (userPermissions.includes(linkItemPermissions[iLinkPermission]) === false) {
                return false;
            }
        }
        return true;
    }
    getFirstPermissionedModuleItem(moduleId) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                this.initModulesData().then((availableData) => {
                    const modules = availableData.find(x => x.id === moduleId);
                    if (!modules || modules.length === 0) {
                        return resolve({ url: null });
                    }
                    const foundModule = modules;
                    let url = null;
                    let linkItem;
                    let iLink;
                    let hasPermission;
                    let iSubMenuItem;
                    // get the logged in user permissions list
                    PermissionService.instance.getUserPermissionList().then(() => {
                        const userPermissions = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.permissions);
                        // run through the module's L3 items
                        for (iLink = 0; iLink < foundModule.linksList.length; iLink = iLink + 1) {
                            linkItem = foundModule.linksList[iLink];
                            if (linkItem.subMenu === undefined) { // no L4 items exist - check L3 permission
                                hasPermission = this.hasLinkItemPermission(linkItem, userPermissions);
                                if (hasPermission) {
                                    url = linkItem.appContext + linkItem.url;
                                }
                            }
                            else {
                                // run through the L4 items of the current L3
                                for (iSubMenuItem = 0; iSubMenuItem < linkItem.subMenu.length; iSubMenuItem = iSubMenuItem + 1) {
                                    hasPermission = this.hasLinkItemPermission(linkItem.subMenu[iSubMenuItem], userPermissions);
                                    if (hasPermission) {
                                        url = linkItem.subMenu[iSubMenuItem].appContext + linkItem.subMenu[iSubMenuItem].url;
                                        break;
                                    }
                                }
                            }
                            // in case the user has the permission to the current link item, abort the loop
                            if (hasPermission) {
                                break;
                            }
                        }
                        return resolve({ url: url });
                    });
                });
            });
        });
    }
    getModuleFirstLinkUrl(moduleData) {
        // if any L3s exist
        if (moduleData.linksList && moduleData.linksList.length > 0) {
            const linkItem = moduleData.linksList[0];
            if (linkItem.subMenu === undefined) { // no L4 items exist - get first L3 url
                return (linkItem.appContext ? linkItem.appContext : '') + (linkItem.url ? linkItem.url : '');
            }
            // get the first L4 url
            return (linkItem.subMenu[0].appContext ? linkItem.subMenu[0].appContext : '') + (linkItem.subMenu[0].url ? linkItem.subMenu[0].url : '');
        }
        else if (moduleData.url) {
            // if the module has a url, use that
            return moduleData.url;
        }
        return null; // no links
    }
    initPermissions() {
        return new Promise((resolve) => {
            const storedUserPermissions = LocalStorageUtils.getItem('userPermissionsKey');
            if (!storedUserPermissions) { // permissions are not available
                PermissionService.instance.getUserPermissionList().then(() => {
                    return resolve();
                });
            }
            else { // permissions are already available - no need to get them from the BE
                resolve();
            }
        });
    }
    getFirstModuleItem(availableModules, moduleIds, searchOtherModules) {
        let url = null;
        if (availableModules) {
            // first try to get the url from the input module ids
            // eslint-disable-next-line @typescript-eslint/prefer-for-of
            for (let iModuleId = 0; iModuleId < moduleIds.length; iModuleId += 1) {
                // look for the module id
                const foundModules = availableModules.find((x) => x.id === moduleIds[iModuleId]);
                if (foundModules) { // module found
                    url = this.getModuleFirstLinkUrl(foundModules); // get the first url of the found module
                    if (url !== null) {
                        return { url: url }; // url found
                    }
                }
            }
            // url wasn't found in the input module ids
            // in case the input searchOtherModules is true, get the url from the first module in the modules list
            if (searchOtherModules === true) {
                // get the url from the system modules according to their order
                // eslint-disable-next-line @typescript-eslint/prefer-for-of
                for (let iModule = 0; iModule < availableModules.length; iModule += 1) {
                    url = this.getModuleFirstLinkUrl(availableModules[iModule]);
                    if (url !== null) {
                        return { url: url }; // url found
                    }
                }
            }
        }
        return { url: null }; // no url found
    }
    getLastPageInfo(availableModules, accessKey, lastModule, lastSubMenu, lastAppContext) {
        if (availableModules === undefined) {
            return null;
        }
        const targetModule = availableModules.find((x) => x.id === lastModule);
        if (targetModule === undefined || targetModule.linksList === undefined) {
            return null;
        }
        const targetLinks = targetModule.linksList.filter((x) => x.id === lastSubMenu);
        let targetLink;
        // if there's more than one item in targetLinks, find the first one that also matches appContext
        if (targetLinks && targetLinks.length > 1) {
            targetLink = targetLinks.find((x) => x.appContext && x.appContext.includes(lastAppContext));
        }
        // if there is at least one item in targetLinks but we haven't yet identified the single targetLink, take the first one
        if (targetLinks && targetLinks.length && !targetLink) {
            targetLink = targetLinks[0];
        }
        if (targetLink === undefined) {
            return null;
        }
        if (targetLink.subMenu === undefined) {
            if (targetLink.id === accessKey) {
                return { url: targetLink.appContext + targetLink.url, permission: targetLink.permission };
            }
            else {
                return null;
            }
        }
        const targetSubMenus = targetLink.subMenu.filter((x) => x.id === accessKey);
        let targetSubMenu;
        // if there's more than one item in targetSubMenus, find the first one that also matches appContext
        if (targetSubMenus && targetSubMenus.length > 1) {
            targetSubMenu = targetSubMenus.find((x) => x.appContext && x.appContext.includes(lastAppContext));
        }
        // if there is at least one item in targetSubMenus but we haven't yet identified the single targetSubMenu, take the first one
        if (targetSubMenus && targetSubMenus.length && !targetSubMenu) {
            targetSubMenu = targetSubMenus[0];
        }
        if (targetSubMenu) {
            return { url: targetSubMenu.appContext + targetSubMenu.url, permission: targetSubMenu.permission };
        }
        return null;
    }
    // gets the user last page url saved in cookie
    getLastPage(availableModules) {
        const userLastPage = PreferencesService.instance.getUserLastPage();
        const lastAppContext = PreferencesService.instance.getUserLastAppContext();
        const lastModule = PreferencesService.instance.getUserLastModule();
        const lastSubMenu = PreferencesService.instance.getUserLastSubMenu();
        let accessKey = userLastPage;
        if (accessKey && accessKey.substring(0, 3) === '/#/') {
            accessKey = accessKey.substring(3);
        }
        // get the last page information - url and permission
        const lastPageInfo = this.getLastPageInfo(availableModules, accessKey, lastModule, lastSubMenu, lastAppContext);
        if (lastPageInfo !== null) { // if page information was found
            // does the last page exist and does the user has permissions to it
            if (lastAppContext && userLastPage && PermissionService.instance.allowAccess(lastPageInfo.permission)) {
                return lastPageInfo.url;
            }
        }
        return null;
    }
    getLandingPage(isEmbeddedClientMode) {
        const modules = [];
        let searchOtherModules = false;
        const promiseHandler = (resolve) => {
            Promise.all([this.initPermissions(), this.initModulesData(true)]).then(res => {
                const availableModules = res[1];
                if (isEmbeddedClientMode) {
                    modules.push('embedded-client');
                    // get the url according to the requested modules
                    return resolve(this.getFirstModuleItem(availableModules, modules, searchOtherModules));
                }
                else {
                    // get the last page the user visited
                    const lastPage = this.getLastPage(availableModules);
                    if (lastPage !== null) { // last page found
                        return resolve({ url: lastPage });
                    }
                    // when the last page is not found, then check availability in the following order to
                    // determine where to redirect: (a) first admin link, then (b) first my-space link, then
                    // (c) searchOtherModules and go to the first link under the first available module
                    modules.push('admin');
                    modules.push('my-space');
                    searchOtherModules = true;
                    // get the url according to the requested modules
                    return resolve(this.getFirstModuleItem(availableModules, modules, searchOtherModules));
                }
            });
        };
        return new Promise(promiseHandler);
    }
}

class URLChangeService {
    constructor() {
        this._handler = new ReplaySubject();
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new URLChangeService();
        }
        return this._instance;
    }
    reset() {
        this._handler = new ReplaySubject();
    }
    broadcastURLChange(type, payload = null) {
        this._handler.next({ type, payload });
    }
    subscribeToURLChange(type, callback) {
        return this._handler.pipe(filter((message) => message.type === type), map((message) => message.payload), shareReplay(0)).subscribe(callback);
    }
}
URLChangeService.URL_CHANGED = 'urlchanged';

class SidebarService {
    constructor() {
        this.eventName = 'BEFORE_MODULE_UNLOAD_NG2';
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new SidebarService();
        }
        return this._instance;
    }
    redirectToUrl(url, isPageDirty = false) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const isDfoUrl = DfoUtils.isDfoDomain(url);
                if (TenantCrossDomainParamsService.instance.checkDomainSwitch(url) &&
                    !TenantCrossDomainParamsService.instance.isParentDomainDifferent(url)) {
                    this.saveTokenInCookie();
                }
                const isAcdDomain = yield TenantCrossDomainParamsService.instance.checkACDDomain(url);
                if (isAcdDomain && TenantCrossDomainParamsService.instance.checkDomainSwitch(url) && !isDfoUrl) {
                    const brandingHostUrl = BrandingService.instance.getBrandingHostURL();
                    if (!URLUtils.hasParameter(url, 'UHRequest')) {
                        url = URLUtils.addURLQueryParam(url, 'UHRequest') + '1';
                    }
                    if (brandingHostUrl !== URLUtils.getDomain() && brandingHostUrl !== undefined && brandingHostUrl !== null) {
                        url = URLUtils.addURLQueryParam(url, 'brandingHost') + brandingHostUrl;
                    }
                }
                if (isPageDirty && SubscribeService.instance.getSubscribeCallbacks(this.eventName).length > 0) {
                    SubscribeService.instance.invokeSubscribeCallbacks(this.eventName, { redirectionUrl: url }, false);
                }
                else {
                    URLUtils.redirectToUrl(url);
                }
            }
            catch (error) {
                console.error(error);
                URLUtils.redirectToUrl(url);
            }
        });
    }
    saveTokenInCookie() {
        const token = JSON.stringify({ accessToken: LocalStorageUtils.getItem('userToken') });
        CookieUtils.setAccessTokenWithCookieName('token_exchange', btoa(token), 120);
    }
}

class CoachingService {
    constructor() {
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new CoachingService();
        }
        return this._instance;
    }
    getCoachDetails(requesterId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield HttpUtils.apiGet('/cxpm-coaching-manager/v1/user/' + requesterId + '/teamlead', undefined, true);
            }
            catch (error) {
                console.error('failed to get coach details');
                throw error;
            }
        });
    }
    createCoachingRequest(requestObj) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield HttpUtils.apiPost('/cxpm-coaching-manager/v1/coaching-request', requestObj, undefined, true);
            }
            catch (error) {
                console.error('failed to create coaching request');
                throw error;
            }
        });
    }
    updateCoachingRequest(requestObj) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield HttpUtils.apiPut('/cxpm-coaching-manager/v1/coaching-request', requestObj, undefined, true);
            }
            catch (error) {
                console.error('failed to update coaching request');
                throw error;
            }
        });
    }
    viewCoachingRequest(requestId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const payload = this.getPayloadForViewRequest(requestId);
                return yield HttpUtils.apiPost('/cxpm-coaching-manager/v1/coaching-request/search', payload, undefined, true);
            }
            catch (error) {
                console.error('failed to view coaching request');
                throw error;
            }
        });
    }
    getPayloadForViewRequest(requestId) {
        const viewCoachingRequestPayload = {
            agentView: true,
            fields: [
                'id',
                'name',
                'coachDetails',
                'status',
                'comment',
                'createdBy'
            ],
            filters: [
                {
                    name: 'id',
                    operation: 'EQUAL',
                    values: [requestId]
                }
            ],
            orderBy: [{ name: 'lastModifiedDate', value: 'DESC' }],
            skip: 0,
            top: 1
        };
        return viewCoachingRequestPayload;
    }
}

class ProductCatalogService {
    constructor() { }
    static get instance() {
        if (!this._instance) {
            this._instance = new ProductCatalogService();
        }
        return this._instance;
    }
    getEvolveProduct() {
        if (!this.localEvolveProductCache) {
            return from(HttpUtils.apiGet('/catalog/product/EVOLVE', undefined, true, undefined)).pipe(map(response => {
                this.localEvolveProductCache = response.product;
                return this.localEvolveProductCache;
            }), catchError$1(error => {
                console.error('Failed to get Evolve product. reason: ', error);
                return throwError(error);
            }));
        }
        else {
            return of(this.localEvolveProductCache);
        }
    }
}

class MSTRLogout {
    static doMSTRLibraryLogout() {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = ConfigurationService.instance.get(ConfigurationService.COMMON_KEYS.ApiServerBaseUrl);
            const tokenResponse = yield fetch(baseUrl + '/MicroStrategyLibrary/api/auth/token', {
                method: 'GET',
                mode: 'cors',
                credentials: 'include'
            });
            if (tokenResponse.ok) {
                const token = tokenResponse.headers.get('X-MSTR-AuthToken');
                if (!token) {
                    throw new Error('Invalid Microstrategy AuthToken');
                }
                const logoutResponse = yield fetch(baseUrl + '/MicroStrategyLibrary/api/auth/logout', {
                    method: 'POST',
                    mode: 'cors',
                    credentials: 'include',
                    headers: {
                        'X-MSTR-AuthToken': token
                    }
                });
                if (!logoutResponse.ok) {
                    throw new Error('Unable to logout from Microstrategy');
                }
            }
        });
    }
}

export { AccessKeyService, AcdClusterDomainService, AnalyticsService, AppLauncherService, BrandingService, BusinessUnitModel, BusinessUnitService, CoachingService, DateTimeFormattingService, DivisionService, EmployeeGroupsService, FeatureToggleMock, FeatureToggleService, FilterModulesService, GlobalAuthService, GridPreferencesService, GroupsService, HierarchyDataService, IFrameAppService, IconSvgService, LicenseService, LocationService, LockInactiveTenantService, LockInactiveUserService, LockedEmployeeService, MSTRLogout, ModuleType, ModulesService, NAV_FEATURE_TOGGLES, NotificationService, OrganizationService, PasswordService, PermissionService, PermissionServiceMock, PermissionUserService, PreferencesService, ProductCatalogService, PublicFeatureToggleService, RefreshTokenService, SchedulerService, SidebarService, TenantCrossDomainParamsService, URLChangeService, UserActivityService, UserAuthenticationService, UserDetailsService, UserPreferencesService, UserRoleService, UserService, UserServiceMock, UserSettingsService, UserTokenService };

